import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Checkbox,
  Text,
  Flex,
  Stack,
  InputGroup,
  IconButton,
  Input,
  Image,
  RadioGroup,
  Radio,
  Divider,
  CheckboxGroup,
  Button,
  Spacer,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Textarea,
  VStack,
  HStack,
} from "@chakra-ui/react";
import PrimaryInput from "../../primary-input";
import DatePicker from "../../date-picker";
import DropdownInput from "../../dropdown-input";
import MiniDropdownInput from "../../mini-dropdown";
import moment from "moment";
import {
  GetDoctorNotes,
  updateDoctorNotes,
  doctorUpdatePatientMedicine,
  GetDoctorFavMedicine,
  GetAIMedicineComposition,
} from "../../../middleware/services/visits/patient-overview/updatedoctornotes";
import { COLORS } from "../../styles/colors";
import PrimaryButton from "../../primary-button";
import NoDataScreen from "../no-data-screen";
import SearchBar from "../../search-bar";
import useLoader from "../../loader/loaderstates";
import Loader from "../../loader/loader";
import TypingLoader from "../../typing-loader";
import AiModal from "../../ai-modal";
import {
  FetchMedicineAIAnswer,
  FetchMedicineAIPrompts,
  FetchMyHealthAIData,
  DetectDrugInteractions,
  AIAlternativeMedicines,
  CorrectChiefComplaintUsingAI,
  CorrectInstructionsUsingAI,
  CorrectMedicalTermsUsingAI,
} from "../../../middleware/services/visits/aicalls";
import AlertToaster from "../../toaster/AlertToaster";
import DynamicModal from "../../dynamic-modal";
import { FetchMedicineList } from "../../../middleware/services/billing";
import { useScreenType } from "../../../auth";
import { GiMedicines } from "react-icons/gi";
import DynamicModalForTwo from "./dynamic-modal-for-two";
import DropdownInputForVitals from "../../dropdown-input-forVitals";
import { useSearchParams } from "react-router-dom";
import { GPUChatAudioManager } from "./cheif-complaint-audio/gpuChatVoiceManager";
import { useGPUTranscriber } from "./cheif-complaint-audio/useGPUTranscriber";
import { useForm } from "react-hook-form";
import { useHybridTranscriber } from "./cheif-complaint-audio/useHybridTranscriber";
import { GPUChatAudioManagerSpeechMode } from "./cheif-complaint-audio/gpuChatVoiceManagerSpeechMode";
import DropdownWithMultiLingual from "../../dropdown-multilingual";
import { AudioDisplayForClutter } from "./notes-transcription/utils/audio-display-multi-lingual";
import { languageCodeMap, languageOptions } from "../../language-dropdown";
import { FetchMedicineViewDetails } from "../../../middleware/services/medicines";
// import DropdownInputForVitals from "../../dropdown-input-forVitals/index (3)";
// import DropdownInputForVitals from '../../components/dropdown-input-forVitals';

// Helper function to get the meal timing option label
const getMealTimingLabel = (morning, afternoon, night) => {
  const pattern = `${morning || 0}-${afternoon || 0}-${night || 0}`;
  const labelMap = {
    "1-0-0": "1-0-0",
    "0-1-0": "0-1-0",
    "0-0-1": "0-0-1",
    "1-1-0": "1-1-0",
    "1-0-1": "1-0-1",
    "0-1-1": "0-1-1",
    "1-1-1": "1-1-1",
    "0-0-0": "0-0-0"
    // "1-0-0": "1-0-0 (Morning)",
    // "0-1-0": "0-1-0 (Afternoon)",
    // "0-0-1": "0-0-1 (Night)",
    // "1-1-0": "1-1-0 (Morning & Afternoon)",
    // "1-0-1": "1-0-1 (Morning & Night)",
    // "0-1-1": "0-1-1 (Afternoon & Night)",
    // "1-1-1": "1-1-1 (All three)",
    // "0-0-0": "0-0-0 (None)"
  };
  return labelMap[pattern] || "1-0-0"; // Default to morning if pattern not found
};

// Helper function to parse meal timing option value
const parseMealTiming = (optionValue) => {
  // Extract only the numeric part (e.g., "0-0-1" from "0-0-1 (Night)")
  const numericPart = optionValue.split(' ')[0];
  const [morning, afternoon, night] = numericPart.split('-').map(Number);
  return { morning, afternoon, night };
};

const PrescriptionComponent = forwardRef(
  (
    {
      patientId,
      patientname,
      patientgender,
      patientage,
      doctorId,
      appointmentId,
      showSuccessToast,
      showErrorToast,
      fetchDoctorNotes,
      addPrescription,
      medicineID,
      // editedMedicine,
      experience,
      specialities
    },
    ref
  ) => {
    //-------------Medicines Inventory

    const [medicineList, setMedicineList] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [showMedicineNamesDropdown, setShowMedicineNamesDropdown] =
      useState(-1);
    const [boolValForSuggestions, setBoolValForSuggestions] = useState(true);
    const [focusedItemIndex, setFocusedItemIndex] = useState(-1);
    const suggestionsMenuRef = useRef(null);

    const [QuantityInStrip, setQuantityInStrip] = useState(0);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
      const [isSelectedEditModalOpen, setIsSelectedEditModalOpen] = useState(false);
      const [isCurrentEditModalOpen, setIsCurrentEditModalOpen] = useState(false);

    //new states
    
    const [sos, setSOS] = useState(null);
    const [customMessage, setCustomMessage] = useState(null);

    // useEffect(() => {
    //   fetchMedicines();
    //   console.log("medicineID88 : ", editedMedicine)
    //   if(editedMedicine) {
    //     // setMedicineREdirect(editedMedicine)
    //     handleEditMedicine(editedMedicine)
    //   }
    // }, []);

    // const [searchParams] = useSearchParams();
    // const [redirectMedicine, setRedirectMedicine] = useState([])
    // const medicineId = searchParams.get('medicineId');
    // console.log('medicineId: ', medicineId)

    useEffect(() => {
      fetchMedicines();
      // fetchCurrentMedicines();
      // console.log("medicineID88 : ", medicineID)

      // if(medicineID) {
      //   // setMedicineREdirect(medicineID)
      //   // const foundMedicine = redirectMedicine.find(med => med.id.toString() === medicineId);

      //   // if (foundMedicine) {
      //   //   console.log('Found medicine:', foundMedicine);
      //   //   handleEditMedicine(foundMedicine); 
      //   // } else {
      //   //   console.warn(`Medicine with ID ${medicineId} not found`);
      //   // }
      //   handleEditMedicine(medicineID)
      // }
    }, []);

    const fetchMedicines = async () => {
      try {
        const result = await FetchMedicineList({ doctorId });
        if (result?.output?.data?.length > 0) {
          setMedicineList(result.output.data);
        }
        dismissLoader();
      } catch (error) {
        console.error("Error in home:", error);
      }
    };

    const filterMedicineNames = (medicine) => {
      const filtered = medicineList.filter((obj) =>
        obj.productname?.toLowerCase().includes(medicine.toLowerCase())
      );
      setSuggestions(filtered);
      setBoolValForSuggestions(!boolValForSuggestions);
    };

    // const handleMedicineNameChange = (name, index) => {
    //   console.log(name, "name");
    //   const newRows = [...rows];
    //   newRows[index].medicinename = name;
    //   if (!name) {
    //     newRows[index] = { ...initialRow }; // Reset the entire row if medicine name is cleared
    //   }
    //   setRows(newRows);
    //   if (name) {
    //     filterMedicineNames(name);
    //     setShowMedicineNamesDropdown(index);
    //     setBoolValForSuggestions(!boolValForSuggestions);
    //   } else {
    //     setSuggestions([]);
    //     setBoolValForSuggestions(!boolValForSuggestions);
    //     setShowMedicineNamesDropdown(-1);
    //   }
    // };
    const handleSelect = (suggestion, index) => {
      // handleNewMedicineChange(
      //   "medicinename",
      //   suggestion.productname + " (" + suggestion.remainingquantity + " Qty)"
      // );
      handleNewMedicineChange("medicinename", suggestion.productname);
      handleNewMedicineChange("composition", suggestion.chemicalcomposition);
      handleNewMedicineChange("inventoryid", suggestion.inventoryid);
      // console.log(suggestion);

      setSuggestions([]);
      setBoolValForSuggestions(!boolValForSuggestions);
      setShowMedicineNamesDropdown(-1);
    };

    const handleEditSelect = (suggestion, index) => {
      // handleEditMedicineChange(
      //   "medicinename",
      //   suggestion.productname + " (" + suggestion.remainingquantity + " Qty)"
      // );
      handleEditMedicineChange("medicinename", suggestion.productname);
      handleEditMedicineChange("inventoryid", suggestion.inventoryid);
      setSuggestions([]);
      setBoolValForSuggestions(!boolValForSuggestions);
      setShowMedicineNamesDropdown(-1);
    };

    const handleKeyDown = (e, index) => {
      if (e.key === "ArrowDown") {
        setFocusedItemIndex(
          (prevIndex) => (prevIndex + 1) % suggestions.length
        );
        const itemHeight =
          suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
        if (suggestionsMenuRef.current) {
          suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
        }
      } else if (e.key === "ArrowUp") {
        setFocusedItemIndex((prevIndex) =>
          prevIndex === 0 ? suggestions.length - 1 : prevIndex - 1
        );
        const itemHeight =
          suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
        if (suggestionsMenuRef.current) {
          suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
        }
      } else if (e.key === "Enter" && focusedItemIndex !== -1) {
        const selectedItem = suggestions[focusedItemIndex];
        handleSelect(selectedItem, index);
      }
    };

    const handleEditKeyDown = (e, index) => {
      if (e.key === "ArrowDown") {
        setFocusedItemIndex(
          (prevIndex) => (prevIndex + 1) % suggestions.length
        );
        const itemHeight =
          suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
        if (suggestionsMenuRef.current) {
          suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
        }
      } else if (e.key === "ArrowUp") {
        setFocusedItemIndex((prevIndex) =>
          prevIndex === 0 ? suggestions.length - 1 : prevIndex - 1
        );
        const itemHeight =
          suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
        if (suggestionsMenuRef.current) {
          suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
        }
      } else if (e.key === "Enter" && focusedItemIndex !== -1) {
        const selectedItem = suggestions[focusedItemIndex];
        handleEditSelect(selectedItem, index);
      }
    };

    //-------------AI Insights
    const chatContainerRef = useRef(null);
    const [aianswers, setAIAnswers] = useState([]);
    const [remainingquestions, setRemainingQuestions] = useState([]);
    const [aiquestion, setAIAnalysis] = useState(null);
    const [AiInput, setAiInput] = useState(null);
    const [initialRender, setInitialRender] = useState(true);
    const [animate, setAnimate] = useState(false);
    const [showAIModal, setShowAIModal] = useState(true);

    const AIChatModel = useRef();
    const drugInteractionAlertModal = useRef();

    //------------------alternative medicine
    const aiRecommendMedicineRef = useRef();

    const [recommendMedicinesAiResponse, setRecommendMedicinesAiResponse] =
      useState([]);

    const [
      selectedRecommendedMedicinesAiResponses,
      setSelectedRecommendedMedicinesAiResponses,
    ] = useState([]);

    const handleRecommendedMedicinesCheckboxChange = (index) => {
      setSelectedRecommendedMedicinesAiResponses((prevSelected) =>
        prevSelected.includes(index)
          ? prevSelected.filter((i) => i !== index)
          : [...prevSelected, index]
      );
    };

    const fetchAlternativeMedicines = async (name, composition) => {
      showLoader();

      const Aiprompts = {
        medicinename: name,
        medicinecomposition: composition,
        patientcountry: "India",
      };
      const response = await AIAlternativeMedicines(Aiprompts);
      console.log("ai response", response);
      if (
        response &&
        response?.alternative_medicines &&
        response?.alternative_medicines?.length > 0
      ) {
        setRecommendMedicinesAiResponse(response?.alternative_medicines);
        setSelectedRecommendedMedicinesAiResponses([]);
        aiRecommendMedicineRef.current.openModal();
      } else {
        // if (noAiResponseModal.current) {
        //   noAiResponseModal.current.openModal();
        //   setTimeout(() => {
        //     if (noAiResponseModal.current) {
        //       // Check again before closing
        //       noAiResponseModal.current.closeModal();
        //     }
        //   }, 3000); // 3 seconds delay
        // }
        showErrorToast("Currently No Alternatives Available");
      }
      dismissLoader();
    };

    const saveSelectedRecommendedMedicinesToOrder = async () => {
      console.log(selectedRecommendedMedicinesAiResponses); // Logs the array of selected indices

      selectedRecommendedMedicinesAiResponses.forEach((index) => {
        const selectedMedicine = recommendMedicinesAiResponse[index]; // Get the item at the respective index

        const newMedicine = {
          medicinename: selectedMedicine?.name,
          composition: selectedMedicine?.composition,
          id: null,
          inventoryid: null,
          medicinetype: "Tablet",
          dosage: "",
          dosageunit: "mg",
          medicationstartdate: today, // Default values
          medicationenddate: fiveDaysFromToday, // Default values
          frequency: 1, // Default values
          frequencytime: "",
      frequencyvalue: "",
          morning: 1, // Default values
          afternoon: 0,
          evening: 0,
          night: 0,
          prescribedby: "",
          hospitalname: "",
          beforefood: 0, // Default values
          afterfood: 1,
          issaved: false,

          duration: "5 Days", // Set default duration value
  durationunit: "Days", // Add this new field
  durationvalue: 5,

          
      custommessage:null,
      sos:null
        };

        setSelectedMedicines((prev) => [...prev, newMedicine]); // Add the new medicine to the list
        DetectInteractionsUsingAI(newMedicine.medicinename); // Call the AI detection function
      });

      // Reset the new medicine form
      setNewMedicine({
        id: null,
        inventoryid: null,
        medicinename: "",
        manufacturer: "",
        drugclass: "",
        therapeutic: "",
        composition: "",
        medicinetype: "Tablet",
        dosage: "",
        dosageunit: "mg",
        medicationstartdate: today, // Default values
        medicationenddate: fiveDaysFromToday, // Default values
        frequency: 1, // Default values
        frequencytime: "",
      frequencyvalue: "",
        morning: 1, // Default values
        afternoon: 0,
        evening: 0,
        night: 0,
        prescribedby: "",
        hospitalname: "",
        beforefood: 0, // Default values
        afterfood: 1,
        // beforefood: 1, // Default values
        // afterfood: 0,
        issaved: false,

        duration: "5 Days", // Set default duration value
  durationunit: "Days", // Add this new field
  durationvalue: 5,

        
      });
    };

    useEffect(() => {
      if (animate) {
        const timer = setTimeout(() => {
          setAnimate(false);
        }, 500);
        return () => clearTimeout(timer);
      }
    }, [animate]);

    useEffect(() => {
      // Scroll to bottom whenever aianswers changes
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    }, [aianswers]);
    const fetchAiDoctorPrompts = async (medicinename) => {
      showLoader();
      setRemainingQuestions([]);
      setAiInput(null);
      setAIAnswers([]);
      setInitialRender(true);
      const result = await FetchMyHealthAIData(
        {},
        patientId,
        patientname,
        patientgender,
        patientage
      );
      // console.log(result);
      let Aiprompts = { ...result, medicinename };
      setAiInput(Aiprompts);
      const response = await FetchMedicineAIPrompts(Aiprompts);
      if (response.generated_question) {
        setAIAnalysis(response);
        setRemainingQuestions(response.generated_question);
        AIChatModel.current.openRight();
      }
      dismissLoader();
    };

    const GetAIAnswer = async (prompt) => {
      // Display question immediately
      const newQuestion = { question: prompt, answer: "" };
      setAIAnswers((prevState) => [...prevState, newQuestion]);

      // Remove the question from remaining questions immediately
      setRemainingQuestions((prevState) =>
        prevState.filter((question) => question.value !== prompt)
      );

      // Trigger animation
      setAnimate(true);

      // Set initialRender to false after the first question is clicked
      setInitialRender(false);
      let AichatInput = { ...AiInput, query: prompt };

      const response = await FetchMedicineAIAnswer(AichatInput);

      if (response) {
        // Replace "typing" with actual answer
        setAIAnswers((prevState) =>
          prevState.map((item) =>
            item.question === prompt && item.answer === ""
              ? { question: item.question, answer: response.answer }
              : item
          )
        );
      }
    };

    const [drugInteractionAlerts, setDrugInteractionAlerts] = useState([]);

    const { showAlertToast } = AlertToaster();

    const DetectInteractionsUsingAI = async (medicinestocheck) => {
      setDrugInteractionAlerts([]);
      const result = await FetchMyHealthAIData(
        {},
        patientId,
        patientname,
        patientgender,
        patientage
      );
      let AiInput = { ...result, medicinestocheck };

      const isValidArray = (arr) => Array.isArray(arr) && arr.length > 0;
      AiInput.currentmedications = [
        ...(isValidArray(patientCurrentMedicinesForDoctor)
          ? patientCurrentMedicinesForDoctor
              .filter((med) => med.isactive !== 0) // Filter out items with isactive === 0
              .map((med) => ({ medicinename: med.medicinename }))
          : []),
        ...(isValidArray(selectedMedicines)
          ? selectedMedicines
              .filter((med) => med.isactive !== 0) // Filter out items with isactive === 0
              .map((med) => ({ medicinename: med.medicinename }))
          : []),
      ];
      console.log("medicine to check", medicinestocheck);
      console.log("medicine list", AiInput?.currentmedications);
      const response = await DetectDrugInteractions(AiInput);
      // console.log("output", response);
      if (response.interactions && response.interactions.length > 0) {
        setDrugInteractionAlerts(response.interactions);

        // response.interactions.forEach((interaction) => {
        //   showAlertToast(interaction.message);
        // });
        //if (drugInteractionAlertModal.current) {
          //drugInteractionAlertModal.current.openModal();
          // Prepare the full message string
          const interactionMessages = response.interactions
            .map((interaction) => `• ${interaction.message}`)
            .join('\n'); // Use '\n' for new lines in the toast

          // Then call the toast
          showErrorToast(interactionMessages);
        // } else {
        //   // console.log("Modal unavailable");
        // }
      }
    };

    //--------------------other functionality
    const { isLoading, showLoader, dismissLoader } = useLoader();

    const [selectedTab, setSelectedTab] = useState("recurrent");
    const [selectedMedicines, setSelectedMedicines] = useState([]);
    const [showAddCard, setShowAddCard] = useState(false);

    const today = moment().format("DD-MM-YYYY");
    const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");

    const [newMedicine, setNewMedicine] = useState({
      id: null,
      inventoryid: null,
      medicinename: "",
      manufacturer: "",
      drugclass: "",
      therapeutic: "",
      composition: "",
      medicinetype: "Tablet",
      dosage: "",
      dosageunit: "mg",
      medicationstartdate: today, // SETTING DEFAULTS
      medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
      frequency: 1, // SETTING DEFAULTS
      frequencytime: "",
      frequencyvalue: "",
      morning: 1, // SETTING DEFAULTS
      afternoon: 0,
      evening: 0,
      night: 0,
      prescribedby: "",
      hospitalname: "",
      beforefood: 0, // SETTING DEFAULTS
      afterfood: 1,
      // beforefood: 1, // SETTING DEFAULTS
      // afterfood: 0,
      issaved: false,

      // new inputs

      frequencyduration: null,
      routeofadministration: null,
      timingofinjection: null,
      quantitytobeapplied: null,
      areaofapplication: null,
      diluent: null,
      additives: null,

      rateofinfusionvalue: null,
      rateofinfusionunit: "ml/hr",
      // duration: null,
      duration: "5 Days", // Set default duration value
  durationunit: "Days", // Add this new field
  durationvalue: 5, // Add this new field

      custommessage:null,
      sos:null,

      // Topical medicine fields
      productQuantity: "1", // NEW - Product quantity for Ointment/Cream/Gel
      timing: "", // Application timing for topical medicines
    });

    const [editMedicine, setEditMedicine] = useState(null);
    const [editCurrentMedicine, setEditCurrentMedicine] = useState(null);

    //-----Fetch Current and Recent Medicines

    const [currentMedicines, setCurrentMedicines] = useState([]);
    const [recentMedicines, setRecentMedicines] = useState([]);
    const [savedMedicines, setSavedMedicines] = useState([]);
    const [
      patientCurrentMedicinesForDoctor,
      setPatientCurrentMedicinesForDoctor,
    ] = useState([]);
    const [search, setSearch] = useState(""); // for recent medicine
    const screenType = useScreenType();
    const [doctorName, setDoctorName] = useState("");

    function processMedicationsData(medicationArray) {
      console.log('processMedicationsData medicationArray: ', medicationArray)
      if (!medicationArray || medicationArray.length === 0) {
        return [];
      }

      const today = moment().format("DD-MM-YYYY");
      const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");

      return medicationArray.map((med) => {
        // Parse the duration string (e.g., "6 Days") into value and unit
    const durationParts = med.duration?.split(' ') || [];
    const durationValue = durationParts[0] ? parseInt(durationParts[0]) : 5;
    const durationUnit = durationParts[1] || 'Days';

    return {
        id: med.id,
        inventoryid: med?.inventoryid,
        remainingquantity: med?.remainingquantity ? med.remainingquantity : 0,
        medicinename: med.medicinename,
        medicinetype: med.medicinetype,
        dosage: med.dosage,
        dosageunit: med.dosageunit,
        medicationstartdate: med.medicationstartdate
          ? moment(med.medicationstartdate, "YYYY-MM-DD").format("DD-MM-YYYY")
          : today,
        //medicationstartdate: today,
        medicationenddate: med.medicationenddate
          ? moment(med.medicationenddate, "YYYY-MM-DD").format("DD-MM-YYYY")
          : fiveDaysFromToday,
        //medicationenddate: fiveDaysFromToday,
        duration:
          Math.abs(
            new Date(med.medicationstartdate) - new Date(med.medicationenddate)
          ) /
            (1000 * 60 * 60 * 24) +
          " days",
        frequency: med.frequency,
        frequencytime: med.frequencytime,
        frequencyvalue: med.frequencyvalue,
        morning: med.morning,
        afternoon: med.afternoon,
        evening: med.evening,
        night: med.night,
        beforefood: med.beforefood,
        afterfood: med.afterfood,
        composition: med.chemicalcomposition,
        issaved: false,

        // duration: med.duration,
        duration: med.duration, // Keep the original combined string
      durationvalue: durationValue, // Add the parsed value
      durationunit: durationUnit, 

      manufacturer: med.manufacturer,
        drugclass: med.drugclass,
        therapeutic: med.therapeutic,
        custommessage:med.instructions,
        sos:med.sos,
        
        // Topical medicine fields; backend stores Product Quantity in frequency (1-4)
        quantitytobeapplied: med.quantitytobeapplied || "",
        areaofapplication: med.areaofapplication || "",
        applicationtiming: med.timing || med.applicationtiming || "",
        wheretoapply: med.areaofapplication || "",
        timing: med.timing || med.applicationtiming || "",
        productQuantity: ["Syrup", "Ointment", "Cream", "Gel"].includes(med.medicinetype)
          ? (med.productQuantity || (["1", "2", "3", "4"].includes(String(med.frequency)) ? String(med.frequency) : "1"))
          : (med.productQuantity || "1")
      }});
    }

    function processCurrentMedicationsDataForDoctor(medicationArray) {
      console.log('medicationArray: ', medicationArray)
      if (!medicationArray || medicationArray.length === 0) {
        return [];
      }

      const today = moment().format("DD-MM-YYYY");
      const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");

      return medicationArray.map((med) => {

        // Parse the duration string (e.g., "6 Days") into value and unit
    const durationParts = med.duration?.split(' ') || [];
    const durationValue = durationParts[0] ? parseInt(durationParts[0]) : 5;
    const durationUnit = durationParts[1] || 'Days';

    return {
        id: med.id,
        remainingquantity: med?.remainingquantity ? med.remainingquantity : 0,
        medicinename: med.medicinename,
        medicinetype: med.medicinetype,
        dosage: med.dosage,
        dosageunit: med.dosageunit,
        medicationstartdate: med.medicationstartdate
          ? moment(med.medicationstartdate, "YYYY-MM-DD").format("DD-MM-YYYY")
          : today,
        //medicationstartdate: today,
        medicationenddate: med.medicationenddate
          ? moment(med.medicationenddate, "YYYY-MM-DD").format("DD-MM-YYYY")
          : fiveDaysFromToday,
        //medicationenddate: fiveDaysFromToday,
        duration:
          Math.abs(
            new Date(med.medicationstartdate) - new Date(med.medicationenddate)
          ) /
            (1000 * 60 * 60 * 24) +
          " days",
        frequency: med.frequency,
        frequencytime: med.frequencytime,
        frequencyvalue: med.frequencyvalue,
        morning: med.morning,
        afternoon: med.afternoon,
        evening: med.evening,
        night: med.night,
        beforefood: med.beforefood,
        afterfood: med.afterfood,
        composition: med.chemicalcomposition,
        iscurrent: med.iscurrent,
        issaved: true,

        // duration: med.duration, 
        // duration: med.duration, // Keep the original combined string
        duration: med.duration || `${durationValue} ${durationUnit}`,
      durationvalue: durationValue, // Add the parsed value
      durationunit: durationUnit, 


      manufacturer: med.manufacturer,
        drugclass: med.drugclass,
        therapeutic: med.therapeutic,
        custommessage:med.custommessage,
        sos:med.sos,
        
        // Topical medicine fields; backend stores Product Quantity in frequency (1-4)
        quantitytobeapplied: med.quantitytobeapplied || "",
        areaofapplication: med.areaofapplication || "",
        applicationtiming: med.timing || med.applicationtiming || "",
        wheretoapply: med.areaofapplication || "",
        timing: med.timing || med.applicationtiming || "",
        productQuantity: ["Syrup", "Ointment", "Cream", "Gel"].includes(med.medicinetype)
          ? (med.productQuantity || (["1", "2", "3", "4"].includes(String(med.frequency)) ? String(med.frequency) : "1"))
          : (med.productQuantity || "1")
      }});
    }

    function processSavedMedicationsData(medicationArray) {
      if (!medicationArray || medicationArray.length === 0) {
        return [];
      }

      const today = moment().format("DD-MM-YYYY");
      const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");

      return medicationArray.map((med) => {

        // Parse the duration string (e.g., "6 Days") into value and unit
    const durationParts = med.duration?.split(' ') || [];
    const durationValue = durationParts[0] ? parseInt(durationParts[0]) : 5;
    const durationUnit = durationParts[1] || 'Days';

    return {
        id: med.id,
        inventoryid: med?.inventoryid,
        medicinename: med.medicinename,
        medicinetype: med.medicinetype,
        dosage: med.dosage,
        dosageunit: med.dosageunit,
        medicationstartdate: med.medicationstartdate
          ? moment(med.medicationstartdate, "YYYY-MM-DD").format("DD-MM-YYYY")
          : today,
        medicationenddate: med.medicationenddate
          ? moment(med.medicationenddate, "YYYY-MM-DD").format("DD-MM-YYYY")
          : fiveDaysFromToday,
        duration:
          Math.abs(
            new Date(med.medicationstartdate) - new Date(med.medicationenddate)
          ) /
            (1000 * 60 * 60 * 24) +
          " days",
        frequency: med.frequency,
        frequencytime: med.frequencytime,
        frequencyvalue: med.frequencyvalue,
        morning: med.morning,
        afternoon: med.afternoon,
        evening: med.evening,
        night: med.night,
        beforefood: med.beforefood,
        afterfood: med.afterfood,
        composition: med.chemicalcomposition,
        isactive: 1,
        issaved: true,

        // duration: med.duration,
        duration: med.duration, // Keep the original combined string
      durationvalue: durationValue, // Add the parsed value
      durationunit: durationUnit, 


        manufacturer: med.manufacturer,
        drugclass: med.drugclass,
        therapeutic: med.therapeuticcategory,
        custommessage:med.custommessage,
        sos:med.sos,
        
        // Topical medicine fields; backend stores Product Quantity in frequency (1-4)
        quantitytobeapplied: med.quantitytobeapplied || "",
        areaofapplication: med.areaofapplication || "",
        applicationtiming: med.timing || med.applicationtiming || "",
        wheretoapply: med.areaofapplication || "",
        timing: med.timing || med.applicationtiming || "",
        productQuantity: ["Syrup", "Ointment", "Cream", "Gel"].includes(med.medicinetype)
          ? (med.productQuantity || (["1", "2", "3", "4"].includes(String(med.frequency)) ? String(med.frequency) : "1"))
          : (med.productQuantity || "1")
      }});
    }

    const fetchCurrentMedicines = async () => {
      // console.log("Function called");
      const inputToFetch = {
        input: {
          patientid: patientId,
          doctorid: doctorId,
          appointmentid: appointmentId,
        },
      };
      try {
        const data = await GetDoctorNotes(inputToFetch.input);
         console.log(data, "Fayaq");
        // console.log("fetching patient medicines");
        setDoctorName(data?.output?.data?.info?.drname);
        setCurrentMedicines(
          processMedicationsData(data?.output?.data?.currentpatientmedicine)
        );
        // setPatientCurrentMedicinesForDoctor(
        //   processCurrentMedicationsDataForDoctor(
        //     data?.output?.data?.currentpatientmedicine
        //   )
        // );
        // console.log(currentMedicines);
        console.log("saved medicines", prescribedMedicines);
        // setRedirectMedicine(prescribedMedicines)
        if (!prescribedMedicines || prescribedMedicines.length === 0) {
          setPatientCurrentMedicinesForDoctor(
            processCurrentMedicationsDataForDoctor(
              data?.output?.data?.currentpatientmedicine
            )
          );
        } else {
          // console.log("removing current medicines once something is prescribed")
          setPatientCurrentMedicinesForDoctor([]);
        }
      } catch (error) {
        console.error("Error fetching Current Medications data:", error);
      }
    };

    const fetchRecentMedicines = async () => {
      // console.log("Function called");
      const inputToFetch = {
        input: {
          doctorid: doctorId,
          type: 'favourite',
          "pageno": 1,
        "pagesize": 1000
        },
      };
      showLoader();
      try {
        // const data = await GetDoctorFavMedicine(inputToFetch.input);
        // setRecentMedicines(processMedicationsData(data?.output?.data));
        const data = await FetchMedicineViewDetails(inputToFetch.input);
        setRecentMedicines(processMedicationsData(data?.data));
        // console.log(recentMedicines);
      } catch (error) {
        console.error("Error fetching Recent Medications data:", error);
      } finally {
        dismissLoader();
      }
    };

    let prescribedMedicines = [];

    const fetchSavedMedicines = async () => {
      const inputToFetch = {
        input: {
          patientid: patientId,
          doctorid: doctorId,
          appointmentid: appointmentId,
        },
      };

      // console.log("fetching prescribed medicines");
      showLoader();
      try {
        const data = await GetDoctorNotes(inputToFetch.input);
        // console.log(data , " data output");
        setSavedMedicines(
          processSavedMedicationsData(data.output.data?.orders?.medication)
        );
        prescribedMedicines = processSavedMedicationsData(
          data.output.data?.orders?.medication
        );
        savedMedicines.forEach((medicine) => {
          if (!selectedMedicines.includes(medicine)) {
            handleCheckboxChange(medicine);
          }
        });
        // console.log(selectedMedicines);
      } catch (error) {
        console.error("Error fetching Doctor Notes data:", error);
      } finally {
        dismissLoader();
      }
    };

    useEffect(() => {
      fetchRecentMedicines();
    }, []);

    // useEffect(() => {
    //   fetchSavedMedicines();
    //   fetchCurrentMedicines();
    //   fetchRecentMedicines();
    // }, []);

    useEffect(() => {
      fetchSavedMedicines()
        .then(() => {
          // Once fetchSavedMedicines is completed, call fetchCurrentMedicines
          return fetchCurrentMedicines();
        })
        .catch((error) => {
          // Handle any errors from either of the fetch calls
          console.error("Error occurred during fetching medicines:", error);
        });
    }, []);

    const [searchParams] = useSearchParams();
    const [redirectMedicine, setRedirectMedicine] = useState([])
    const medicineId = searchParams.get('medicineId');
    // console.log('medicineId: ', medicineId)
    useEffect(() => {
      // console.log(savedMedicines  , " savedMedicines")
      setSelectedMedicines(savedMedicines);
      setRedirectMedicine(savedMedicines)
      if(medicineId && savedMedicines.length > 0) {
        // const foundMedicine = redirectMedicine.find(med => med.id.toString() === medicineId);
        const foundMedicine = savedMedicines.find(med => 
          med.id.toString() === medicineId.toString() 
        );

        if (foundMedicine) {
          // console.log('Found medicine:', foundMedicine);
          handleEditMedicine(foundMedicine); 
        } else {
          console.warn(`Medicine with ID ${medicineId} not found`);
        }
      }
    }, [savedMedicines]);

    const handleTabChange = (tab) => {
      setSelectedTab(tab);
    };

    // const handleCheckboxChange = (medicine) => {
    //   setSelectedMedicines((prev) =>
    //     prev.includes(medicine)
    //       ? prev.filter((m) => m !== medicine)
    //       : [...prev, medicine]
    //   );
    //   if (selectedTab === "recurrent") {
    //     DetectInteractionsUsingAI(medicine.medicinename);
    //   }
    // };

    //----------------------
    // let lastInteractionName = "";

  const [lastInteractionName, setLastInteractionName] = useState("");

  // existing function
    // const handleCheckboxChange = (medicine) => {
    //   setSelectedMedicines((prev) => {
    //     const isAlreadySelected = prev.includes(medicine);
    //     const updatedMedicines = isAlreadySelected
    //       ? prev.filter((m) => m !== medicine)
    //       : [...prev, medicine];

    //     // Run AI only if the medicine is being added and the selected tab is "recurrent"
    //     console.log("last checked for ", lastInteractionName)
    //     if (isAlreadySelected){
    //       setLastInteractionName("");
    //       console.log("resetting last set medicine to none ", lastInteractionName)
    //     }
    //     if (medicine.medicinename !== lastInteractionName) {
    //       if (!isAlreadySelected && selectedTab === "recurrent") {
    //         console.log("calling interaction");
    //         DetectInteractionsUsingAI(medicine.medicinename);
    //         setLastInteractionName(medicine.medicinename);  // Update lastInteractionName in state
    //       }
    //     } else {
    //       console.log("exception occured");
    //     }

    //     return updatedMedicines;
    //   });
    // };

    // newly added function
//     const handleCheckboxChange = (medicine) => {
//   setSelectedMedicines(prev => {
//     const exists = prev.some(m => m.id === medicine.id);
//     if (exists) {
//       return prev.filter(m => m.id !== medicine.id);
//     } else {
//       return [...prev, medicine];
//     }
//   });
  
//   // if (!selectedMedicines.some(m => m.id === medicine.id)) {
//   //   editSelectedPrescriptionMedication.current.openModal();
//   //   setEditMedicine(medicine);
//   // }
// };

// const handleCheckboxChange = (medicine) => {
//   setSelectedMedicines(prev => {
//     const exists = prev.some(m => 
//       m.medicinename === medicine.medicinename &&
//       m.medicinetype === medicine.medicinetype &&
//       m.dosage === medicine.dosage &&
//       m.dosageunit === medicine.dosageunit
//     );

//     if (exists) {
//       // When unchecking, mark as inactive but keep in list
//       return prev.map(m => 
//         (m.medicinename === medicine.medicinename &&
//          m.medicinetype === medicine.medicinetype &&
//          m.dosage === medicine.dosage &&
//          m.dosageunit === medicine.dosageunit)
//           ? { ...m, isactive: 0 }
//           : m
//       );
//     } else {
//       // When checking, add to list or mark as active
//       const existingInactive = prev.find(m => 
//         m.medicinename === medicine.medicinename &&
//         m.medicinetype === medicine.medicinetype &&
//         m.dosage === medicine.dosage &&
//         m.dosageunit === medicine.dosageunit &&
//         m.isactive === 0
//       );
      
//       if (existingInactive) {
//         return prev.map(m => 
//           m === existingInactive ? { ...m, isactive: 1 } : m
//         );
//       } else {
//         return [...prev, medicine];
//       }
//     }
//   });
// };

const handleCheckboxChange = (medicine) => {
  // robust key to identify same medicine
  const makeKey = (m) =>
    `${(m?.medicinename || "").toString().toLowerCase().trim()}|${(m?.medicinetype || "").toString().trim()}|${(m?.dosage || "").toString().trim()}|${(m?.dosageunit || "").toString().trim()}`;

  // refs for debouncing duplicate toasts
  if (!handleCheckboxChange._lastDuplicateToast) {
    handleCheckboxChange._lastDuplicateToast = { key: null, ts: 0 };
  }

  const key = makeKey(medicine);
  const areSame = (a, b) =>
    makeKey(a) === makeKey(b);

  // Check existence in current patient meds or saved meds (active only)
  const existsInCurrent = patientCurrentMedicinesForDoctor.some(
    (m) => areSame(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
  );
  const existsInSaved = savedMedicines.some(
    (m) => areSame(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
  );
  const existsInSelected = selectedMedicines.some(
    (m) => areSame(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
  );

  if ((existsInCurrent || existsInSaved) && !existsInSelected) {
    const last = handleCheckboxChange._lastDuplicateToast;
    const now = Date.now();
    // avoid showing multiple toasts for same medicine in short interval
    if (last.key !== key || now - last.ts > 2000) {
      showErrorToast && showErrorToast("This medicine is already present in the doctor's notes.");
      handleCheckboxChange._lastDuplicateToast = { key, ts: now };
    }
    return;
  }

  // proceed with toggle/add behavior
  setSelectedMedicines((prev) => {
    const existingIndex = prev.findIndex((m) =>
      areSame(m, medicine)
    );

    if (existingIndex >= 0) {
      // Toggle isactive status
      return prev.map((m, index) =>
        index === existingIndex
          ? { ...m, isactive: m.isactive === 0 ? 1 : 0 }
          : m
      );
    } else {
      // Add new medicine as active
      return [...prev, { ...medicine, isactive: 1 }];
    }
  });
};

// last existing function which we were using 
// const handleCheckboxChange = (medicine) => {
//   setSelectedMedicines(prev => {
//     // Find if medicine exists (active or inactive)
//     const existingIndex = prev.findIndex(m => 
//       m.medicinename === medicine.medicinename &&
//       m.medicinetype === medicine.medicinetype &&
//       m.dosage === medicine.dosage &&
//       m.dosageunit === medicine.dosageunit
//     );

//     if (existingIndex >= 0) {
//       // Toggle isactive status
//       return prev.map((m, index) => 
//         index === existingIndex 
//           ? { ...m, isactive: m.isactive === 0 ? 1 : 0 }
//           : m
//       );
//     } else {
//       // Add new medicine as active
//       return [...prev, { ...medicine, isactive: 1 }];
//     }
//   });
// };

//     const handleCheckboxChange = (medicine) => {
//   const isAlreadySelected = selectedMedicines.some(m => m.id === medicine.id);
  
//   if (isAlreadySelected) {
//     setSelectedMedicines(prev => prev.filter(m => m.id !== medicine.id));
//     editSelectedPrescriptionMedication.current.closeModal();
//   } else {
//     setSelectedMedicines(prev => [...prev, medicine]);
//     editSelectedPrescriptionMedication.current.openModal();
//     setEditMedicine(medicine);
//   }
// };

    const formatQuantity = (quantity) => {
      // console.log('What is remainting quantitiy: ', quantity)
      // if (quantity === 0) {
      if (quantity <= 0) {
        return "Out of Stock";
      } else {
        return quantity.toLocaleString(); // This formats the number with commas
      }
    };

    const handleSelectAll = () => {
      currentMedicines.forEach((medicine) => {
        if (!selectedMedicines.includes(medicine)) {
          handleCheckboxChange(medicine);
        }
      });
    };

    const [dropdownMedType, setDropdownMedType] = useState("");
const additionalMedicineTypes = [
  "Respules",
  "Suspension",
  "Foam",
  "Suppository",
  "EA",
  "Device",
  // "Sachet",
  "Box",
  "Spray",
  "Lotion",
  "Tube",
  "Gargle",
  "Powder",
  "Soap",
  "Aerosol",
  "Shampoo",
  "Topical Cleanser",
  "Custom"
];

const handleCurrentEditTypeChange = (value) => {
  if (additionalMedicineTypes.includes(value)) {
    setDropdownMedType(value);
    handleEditCurrentMedicineChange("medicinetype", value);
  } else {
    setDropdownMedType("");
    handleEditCurrentMedicineChange("medicinetype", value);
  }

  // Set default dosage units based on medicine type
  if (["Syrup", "Drops", "Suspension", "Respules", "Gargle", "Shampoo", "Topical Cleanser"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "ml");
  } else if (["Tablet", "Capsule", "Suppository", "Powder"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "mg");
  } else if (["Injection", "Nebulization", "IVFluids"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "ml");
  } else if (["Ointment", "Cream", "Gel", "Foam", "Lotion", "Tube", "Soap"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "grms");
  } else if (["Inhaler", "Spray", "Aerosol"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "puffs");
  } else if (["EA", "Device", "Box"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "each");
  } else if (value === "Sachet") {
    handleEditCurrentMedicineChange("dosageunit", "mg");
  } else if (value === "Custom") {
    handleEditCurrentMedicineChange("dosageunit", "");
  }
};

const handleEditTypeChange = (value) => {
  if (additionalMedicineTypes.includes(value)) {
    setDropdownMedType(value);
    handleEditMedicineChange("medicinetype", value);
  } else {
    setDropdownMedType("");
    handleEditMedicineChange("medicinetype", value);
  }

  // Set default dosage units based on medicine type
  if (["Syrup", "Drops", "Suspension", "Respules", "Gargle", "Shampoo", "Topical Cleanser"].includes(value)) {
    handleEditMedicineChange("dosageunit", "ml");
  } else if (["Tablet", "Capsule", "Suppository", "Powder"].includes(value)) {
    handleEditMedicineChange("dosageunit", "mg");
  } else if (["Injection", "Nebulization", "IVFluids"].includes(value)) {
    handleEditMedicineChange("dosageunit", "ml");
  } else if (["Ointment", "Cream", "Gel", "Foam", "Lotion", "Tube", "Soap"].includes(value)) {
    handleEditMedicineChange("dosageunit", "grms");
  } else if (["Inhaler", "Spray", "Aerosol"].includes(value)) {
    handleEditMedicineChange("dosageunit", "puffs");
  } else if (["EA", "Device", "Box"].includes(value)) {
    handleEditMedicineChange("dosageunit", "each");
  } else if (value === "Sachet") {
    handleEditMedicineChange("dosageunit", "mg");
  } else if (value === "Custom") {
    handleEditMedicineChange("dosageunit", "");
  }
};

const handleTypeChange = (value) => {
  if (additionalMedicineTypes.includes(value)) {
    setDropdownMedType(value);
    handleNewMedicineChange("medicinetype", value);
  } else {
    setDropdownMedType("");
    handleNewMedicineChange("medicinetype", value);
  }

  // Set default dosage units
  if (["Syrup", "Drops", "Suspension", "Respules", "Gargle", "Shampoo", "Topical Cleanser"].includes(value)) {
    handleNewMedicineChange("dosageunit", "ml");
  } else if (["Tablet", "Capsule", "Suppository", "Powder"].includes(value)) {
    handleNewMedicineChange("dosageunit", "mg");
  } else if (["Injection", "Nebulization", "IVFluids"].includes(value)) {
    handleNewMedicineChange("dosageunit", "ml");
  } else if (["Ointment", "Cream", "Gel", "Foam", "Lotion", "Tube", "Soap"].includes(value)) {
    handleNewMedicineChange("dosageunit", "grms");
  } else if (["Inhaler", "Spray", "Aerosol"].includes(value)) {
    handleNewMedicineChange("dosageunit", "puffs");
  } else if (["EA", "Device", "Box"].includes(value)) {
    handleNewMedicineChange("dosageunit", "each");
  } else if (value === "Sachet") {
    handleNewMedicineChange("dosageunit", "mg");
  } else if (value === "Custom") {
    handleNewMedicineChange("dosageunit", "");
  }
};

const [addMedicineInstructions, setAddMedicineInstructions] = useState("");
    const handleNewMedicineChange = (field, value) => {
      if (field === "custommessage") {
    setAddMedicineInstructions(value);
  }
      setNewMedicine((prev) => ({ ...prev, [field]: value }));
    };

    const handleAddMedicine = () => {
      if (newMedicine.medicinename === "") {
        showErrorToast("Please enter medicine name to continue");
        return;
      }
      if (newMedicine.frequencytime && !newMedicine.frequencyvalue) {
        showErrorToast("Please select the Value when Frequency is selected");
        return;
      }
      setSelectedMedicines((prev) => [...prev, newMedicine]);
      DetectInteractionsUsingAI(newMedicine.medicinename);
      // setShowAddCard(false);
      // Reset the new medicine form
       setDropdownMedType("");
       setAddMedicineInstructions("");
      setNewMedicine({
        id: null,
        inventoryid: null,
        medicinename: "",
        manufacturer: "",
        drugclass: "",
        therapeutic: "",
        composition: "",
        medicinetype: "Tablet",
        dosage: "",
        dosageunit: "mg",
        medicationstartdate: today, // SETTING DEFAULTS
        medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
        frequency: 1, // SETTING DEFAULTS
        frequencytime: "",
        frequencyvalue: '',
        morning: 1, // SETTING DEFAULTS
        afternoon: 0,
        evening: 0,
        night: 0,
        prescribedby: "",
        hospitalname: "",
        beforefood: 0, // SETTING DEFAULTS
        afterfood: 1,
        // beforefood: 1, // SETTING DEFAULTS
        // afterfood: 0,
        issaved: false,

        // new inputs

        frequencyduration: null,
        routeofadministration: null,
        timingofinjection: null,
        quantitytobeapplied: null,
        areaofapplication: null,
        diluent: null,
        additives: null,

        rateofinfusionvalue: null,
        rateofinfusionunit: "ml/hr",
        // duration: null,
        duration: "",
        // duration: durationvalue + durationunit, // Set default duration value
  durationunit: "Days", // Add this new field
  durationvalue: 5,

        custommessage:null,
      sos:null
      });

      addPrescriptionMedication.current.closeModal();
      setIsAddModalOpen(false)

      // console.log(selectedMedicines);
    };

    const handleCancelAddMedicine = () => {
      // setShowAddCard(false);
      // Reset the new medicine form
      setNewMedicine({
        id: null,
        medicinename: "",
        manufacturer: "",
        drugclass: "",
        therapeutic: "",
        composition: "",
        medicinetype: "Tablet",
        dosage: "",
        dosageunit: "mg",
        medicationstartdate: today, // SETTING DEFAULTS
        medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
        frequency: 1, // SETTING DEFAULTS
        frequencytime: "",
        frequencyvalue: "",
        morning: 1, // SETTING DEFAULTS
        afternoon: 0,
        evening: 0,
        night: 0,
        prescribedby: "",
        hospitalname: "",
        beforefood: 0, // SETTING DEFAULTS
        afterfood: 1,
        // beforefood: 1, // SETTING DEFAULTS
        // afterfood: 0,
        issaved: false,

        // new inputs

        frequencyduration: null,
        routeofadministration: null,
        timingofinjection: null,
        quantitytobeapplied: null,
        areaofapplication: null,
        diluent: null,
        additives: null,

        rateofinfusionvalue: null,
        rateofinfusionunit: "ml/hr",
        // duration: null,
        duration: "5 Days", // Set default duration value
  durationunit: "Days", // Add this new field
  durationvalue: 5,

        custommessage:null,
      sos:null
      });

      addPrescriptionMedication.current.closeModal();
      setIsAddModalOpen(false)

      // console.log(selectedMedicines);
    };

    // existing function to delete
    // const handleDeleteMedicine = (medicine) => {
    //   setSelectedMedicines((prev) => {
    //     if (medicine.issaved) {
    //       const updatedMedicine = { ...medicine, isactive: 0 };
    //       // console.log("recorded to delete");
    //       return prev.map((m) => (m === medicine ? updatedMedicine : m));
    //     } else {
    //       return prev.filter((m) => m !== medicine);
    //     }
    //   });
    // };

    // newly added function to delete
    const handleDeleteMedicine = (medicine) => {
  setSelectedMedicines((prev) => {
    const isMatch = (m) => 
      m.medicinename === medicine.medicinename &&
      m.medicinetype === medicine.medicinetype &&
      m.dosage === medicine.dosage &&
      m.dosageunit === medicine.dosageunit;

    if (medicine.issaved) {
      return prev.map(m => isMatch(m) ? { ...m, isactive: 0 } : m);
    } else {
      return prev.filter(m => !isMatch(m));
    }
  });
};

    const handleDeleteCurrentMedicine = (medicine) => {
      setPatientCurrentMedicinesForDoctor((prev) => {
        if (medicine.issaved) {
          const updatedMedicine = { ...medicine, isactive: 0 };
          // console.log("recorded to delete");
          return prev.map((m) => (m === medicine ? updatedMedicine : m));
        } else {
          return prev.filter((m) => m !== medicine);
        }
      });
    };

    const validationOfNumberWithOnly1Decimal = (inputValue, maxLength) => {
      // Remove all characters that are not digits or a decimal point
      let cleanedValue = inputValue.replace(/[^0-9.]/g, "");

      // Remove leading decimal point if present
      if (cleanedValue.startsWith(".")) {
        cleanedValue = cleanedValue.substring(1);
      }

      // Handle multiple decimal points
      const decimalIndex = cleanedValue.indexOf(".");
      if (decimalIndex !== -1) {
        const parts = cleanedValue.split(".");
        // Keep only the first two digits after the decimal point
        cleanedValue = parts[0] + "." + parts[1].slice(0, 2);
      }

      // Enforce the max length after cleaning and truncating
      if (cleanedValue.length > maxLength) {
        cleanedValue = cleanedValue.substring(0, maxLength);
      }

      // console.log("input", inputValue);
      // console.log("cleaned", cleanedValue);

      return cleanedValue;
    };

    const handleEditMedicine = (medicine) => {
      console.log('medicine dtls: ', medicine);
      console.log('quantitytobeapplied from API:', medicine.quantitytobeapplied);
      console.log('areaofapplication from API:', medicine.areaofapplication);
      console.log('timing/applicationtiming from API:', medicine.timing || medicine.applicationtiming);

      if (additionalMedicineTypes.includes(medicine.medicinetype)) {
        setDropdownMedType(medicine.medicinetype);
      } else {
        setDropdownMedType("");
      }

      // For topical medicines, ensure all fields are properly preserved
      const isTopical = (medicine.medicinetype === "Syrup" || medicine.medicinetype === "Ointment" || medicine.medicinetype === "Cream" || medicine.medicinetype === "Gel");
      // Backend stores Product Quantity in frequency for topical; show in dropdown
      const topicalProductQty = isTopical && ["1", "2", "3", "4"].includes(String(medicine.frequency))
        ? String(medicine.frequency)
        : null;

      // Keep API values exactly as they come for dropdown binding
      const preparedMedicine = {
        ...medicine,
        // Preserve topical-specific fields EXACTLY from API
        quantitytobeapplied: medicine.quantitytobeapplied || "",
        areaofapplication: medicine.areaofapplication || "",
        timing: medicine.timing || medicine.applicationtiming || "",
        // For productQuantity (numeric 1-4): use from API or derive from frequency for topical
        productQuantity: isTopical ? (medicine.productQuantity || topicalProductQty || "1") : (medicine.productQuantity || "1"),
      };

      console.log('Prepared medicine state:', preparedMedicine);
      
      setEditMedicine(preparedMedicine);
      setIsSelectedEditModalOpen(true);
      editSelectedPrescriptionMedication.current.openModal();
   };

    const handleEditCurrentMedicine = (medicine) => {
      console.log('current medicine dtls: ', medicine);
      console.log('quantitytobeapplied from API:', medicine.quantitytobeapplied);
      console.log('areaofapplication from API:', medicine.areaofapplication);
      console.log('timing/applicationtiming from API:', medicine.timing || medicine.applicationtiming);

      if (additionalMedicineTypes.includes(medicine.medicinetype)) {
        setDropdownMedType(medicine.medicinetype);
      } else {
        setDropdownMedType("");
      }

      // For topical medicines, ensure all fields are properly preserved
      const isTopical = (medicine.medicinetype === "Syrup" || medicine.medicinetype === "Ointment" || medicine.medicinetype === "Cream" || medicine.medicinetype === "Gel");
      // Backend stores Product Quantity in frequency for topical; show in dropdown
      const topicalProductQty = isTopical && ["1", "2", "3", "4"].includes(String(medicine.frequency))
        ? String(medicine.frequency)
        : null;

      // Keep API values exactly as they come for dropdown binding
      const preparedMedicine = {
        ...medicine,
        // Preserve topical-specific fields EXACTLY from API
        quantitytobeapplied: medicine.quantitytobeapplied || "",
        areaofapplication: medicine.areaofapplication || "",
        timing: medicine.timing || medicine.applicationtiming || "",
        // For productQuantity (numeric 1-4): use from API or derive from frequency for topical
        productQuantity: isTopical ? (medicine.productQuantity || topicalProductQty || "1") : (medicine.productQuantity || "1"),
      };

      console.log('Prepared current medicine state:', preparedMedicine);

      setEditCurrentMedicine(preparedMedicine);
      setIsCurrentEditModalOpen(true);
      editCurrentPrescriptionMedication.current.openModal();
    };

    const [selectMedicineId, setSelectMedicineId] = useState(null);
const [instructionsMap, setInstructionsMap] = useState({});
    useEffect(() => {
  if (editMedicine?.id) {
    setSelectMedicineId(editMedicine.id);
    // Initialize or set the current instruction
    setValue("textField", editMedicine.custommessage || instructionsMap[editMedicine.id] || "");
    setInitialText(editMedicine.custommessage || instructionsMap[editMedicine.id] || "");
  }
}, [editMedicine?.id]);

    const [currentMedicineId, setCurrentMedicineId] = useState(null);
const [currentInstructionsMap, setCurrentInstructionsMap] = useState({});
    useEffect(() => {
  if (editCurrentMedicine?.id) {
    setSelectMedicineId(editCurrentMedicine.id);
    // Initialize or set the current instruction
    setValue("textField", editCurrentMedicine.custommessage || instructionsMap[editCurrentMedicine.id] || "");
    setInitialText(editCurrentMedicine.custommessage || instructionsMap[editCurrentMedicine.id] || "");
  }
}, [editCurrentMedicine?.id]);

    const handleEditMedicineChange = (field, value) => {
      // setEditMedicine((prev) => ({ ...prev, [field]: value }));
      setEditMedicine((prev) => {
    const updated = { ...prev, [field]: value };
    // Update the instructions map when custommessage changes
    if (field === "custommessage" && selectMedicineId) {
      setInstructionsMap(prevMap => ({
        ...prevMap,
        [selectMedicineId]: value
      }));
    }
    return updated;
  });
  
  // Also update the form field
  if (field === "custommessage") {
    setValue("textField", value, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  }
    };

    const handleEditCurrentMedicineChange = (field, value) => {
      // setEditCurrentMedicine((prev) => ({ ...prev, [field]: value }));
      setEditCurrentMedicine((prev) => {
    const updated = { ...prev, [field]: value };
    // Backend stores Product Quantity in frequency for Syrup/Ointment/Cream/Gel (same as prescribed edit)
    const topicalForProductQty = ["Syrup", "Ointment", "Cream", "Gel"];
    if (field === "productQuantity" && topicalForProductQty.includes(prev.medicinetype)) {
      updated.frequency = value;
    }
    // Update the instructions map when custommessage changes
    if (field === "custommessage" && currentMedicineId) {
      setCurrentInstructionsMap(prevMap => ({
        ...prevMap,
        [currentMedicineId]: value
      }));
    }
    return updated;
  });
  
  // Also update the form field
  if (field === "custommessage") {
    setValue("textField", value, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  }
    };

    const handleSaveEditMedicine = () => {
      if (editMedicine.medicinename === "") {
        showErrorToast("Please enter medicine name to continue");
        return;
      }
      if (editMedicine.frequencytime && !editMedicine.frequencyvalue) {
        showErrorToast("Please select the Value when Frequency is selected");
        return;
      }
      setSelectedMedicines((prev) =>
        prev.map((m) => (m.id === editMedicine.id ? editMedicine : m))
      );

      // console.log(selectedMedicines);
      setEditMedicine(null);
      editSelectedPrescriptionMedication.current.closeModal();
      setIsSelectedEditModalOpen(false)
    };

    const handleSaveEditCurrentMedicine = () => {
      if (editCurrentMedicine.medicinename === "") {
        showErrorToast("Please enter medicine name to continue");
        return;
      }

      const topicalTypes = ["Syrup", "Ointment", "Cream", "Gel"];
      const savedCurrent =
        topicalTypes.includes(editCurrentMedicine.medicinetype)
          ? {
              ...editCurrentMedicine,
              frequency:
                editCurrentMedicine.productQuantity ||
                editCurrentMedicine.frequency ||
                "1",
            }
          : editCurrentMedicine;

      // Update doctor-facing current medicines list
      setPatientCurrentMedicinesForDoctor((prev) =>
        prev.map((m) =>
          m.id === savedCurrent.id ? savedCurrent : m
        )
      );

      // Also update the display list used in the Current tab so UI reflects changes immediately
      setCurrentMedicines((prev) =>
        prev.map((m) =>
          m.id === savedCurrent.id ? savedCurrent : m
        )
      );

      setEditCurrentMedicine(null);
      editCurrentPrescriptionMedication.current.closeModal();
      setIsCurrentEditModalOpen(false)
    };

    const [key, setKey] = useState(0); // to rerender the composition input box
    const [compositionEditKey, setCompositionEditKey] = useState(0); // to rerender the composition input box

    const fetchComposition = async (medicineName) => {
      if (!medicineName) {
        showErrorToast("Please enter medicine name first to fetch composition");
      } else {
        const inputData = {
          input: {
            name: medicineName,
          },
        };

        // console.log(inputData.input);

        try {
          // showLoader();
          // console.log(inputData);
          const result = await GetAIMedicineComposition(inputData.input);
          // console.log(result, "resutl for Fetch");
          if (result) {
            showSuccessToast("Fetched Medicine composition successfully");
            handleNewMedicineChange("composition", result.chemical_composition);
            // handleNewMedicineChange("manufacturer", result.Manufacturer);
            // handleNewMedicineChange("therapeutic", result.TherapeuticCategory);
            // handleNewMedicineChange("drugclass", result.DrugClass);

            if (Array.isArray(result.Manufacturer)) {
          handleNewMedicineChange("manufacturer", result.Manufacturer.join(", "));
        } else {
          handleNewMedicineChange("manufacturer", result.Manufacturer || ""); 
        }
        if (Array.isArray(result.TherapeuticCategory)) {
          handleNewMedicineChange("therapeutic", result.TherapeuticCategory.join(", "));
        } else {
          handleNewMedicineChange("therapeutic", result.TherapeuticCategory || "");
        }
        if (Array.isArray(result.DrugClass)) {
          handleNewMedicineChange("drugclass", result.DrugClass.join(", "));
        } else {
          handleNewMedicineChange("drugclass", result.DrugClass || ""); 
        }
            // handleNewMedicineChange("custommessage", result.InstructionsOfAdministration);
            // Bind InstructionsOfAdministration
        // handleNewMedicineChange("custommessage", result.InstructionsOfAdministration || "");
        if (result.InstructionsOfAdministration) {
          handleNewMedicineChange("custommessage", result.InstructionsOfAdministration);
        }

            setKey((prevKey) => prevKey + 1);
            // handleNewMedicineChange("medicinetype", result.type);
          }
        } catch (error) {
          console.error("Error Fetching Medicine composition:", error);
          showErrorToast(
            "An error occurred while Fetching Medicine composition"
          );
        } finally {
          // dismissLoader();
        }

        // fetchDoctorNotes();

        // console.log("Clicked");
      }
    };

    const fetchCompositionForEdit = async (medicineName) => {
      if (!medicineName) {
        showErrorToast("Please enter medicine name first to fetch composition");
      } else {
        const inputData = {
          input: {
            name: medicineName,
          },
        };

        // console.log(inputData.input);

        try {
          // showLoader();
          // console.log(inputData);
          const result = await GetAIMedicineComposition(inputData.input);
          // console.log(result);
          if (result) {
            showSuccessToast("Fetched Medicine composition successfully");
            handleEditMedicineChange(
              "composition",
              result.chemical_composition
            );
            // handleEditMedicineChange(
            //   "manufacturer",
            //   result.Manufacturer
            // );
            // handleEditMedicineChange(
            //   "therapeutic",
            //   result.TherapeuticCategory
            // );
            // handleEditMedicineChange(
            //   "drugclass",
            //   result.DrugClass
            // );
            if (Array.isArray(result.Manufacturer)) {
          handleEditMedicineChange("manufacturer", result.Manufacturer.join(", "));
        } else {
          handleEditMedicineChange("manufacturer", result.Manufacturer || ""); 
        }
        if (Array.isArray(result.TherapeuticCategory)) {
          handleEditMedicineChange("therapeutic", result.TherapeuticCategory.join(", "));
        } else {
          handleEditMedicineChange("therapeutic", result.TherapeuticCategory || "");
        }
        if (Array.isArray(result.DrugClass)) {
          handleEditMedicineChange("drugclass", result.DrugClass.join(", "));
        } else {
          handleEditMedicineChange("drugclass", result.DrugClass || ""); 
        }

        // Bind InstructionsOfAdministration
        // handleEditMedicineChange("custommessage", result.InstructionsOfAdministration || "");
        if (result.InstructionsOfAdministration) {
          handleEditMedicineChange("custommessage", result.InstructionsOfAdministration);
        }

            setCompositionEditKey((prevKey) => prevKey + 1);
            // handleNewMedicineChange("medicinetype", result.type);
          }
        } catch (error) {
          console.error("Error Fetching Medicine composition:", error);
          showErrorToast(
            "An error occurred while Fetching Medicine composition"
          );
        } finally {
          // dismissLoader();
        }

        // fetchDoctorNotes();

        // console.log("Clicked");
      }
    };

    const fetchCompositionForCurrentEdit = async (medicineName) => {
      if (!medicineName) {
        showErrorToast("Please enter medicine name first to fetch composition");
      } else {
        const inputData = {
          input: {
            name: medicineName,
          },
        };

        // console.log(inputData.input);

        try {
          // showLoader();
          // console.log(inputData);
          const result = await GetAIMedicineComposition(inputData.input);
          // console.log(result);
          if (result) {
            showSuccessToast("Fetched Medicine composition successfully");
            handleEditCurrentMedicineChange(
              "composition",
              result.chemical_composition
            );
            // handleEditCurrentMedicineChange(
            //   "manufacturer",
            //   result.Manufacturer
            // );
            // handleEditCurrentMedicineChange(
            //   "therapeutic",
            //   result.TherapeuticCategory
            // );
            // handleEditCurrentMedicineChange(
            //   "drugclass",
            //   result.DrugClass
            // );
            if (Array.isArray(result.Manufacturer)) {
          handleEditCurrentMedicineChange("manufacturer", result.Manufacturer.join(", "));
        } else {
          handleEditCurrentMedicineChange("manufacturer", result.Manufacturer || ""); 
        }
        if (Array.isArray(result.TherapeuticCategory)) {
          handleEditCurrentMedicineChange("therapeutic", result.TherapeuticCategory.join(", "));
        } else {
          handleEditCurrentMedicineChange("therapeutic", result.TherapeuticCategory || "");
        }
        if (Array.isArray(result.DrugClass)) {
          handleEditCurrentMedicineChange("drugclass", result.DrugClass.join(", "));
        } else {
          handleEditCurrentMedicineChange("drugclass", result.DrugClass || ""); 
        }

        if (result.InstructionsOfAdministration) {
          handleEditCurrentMedicineChange("custommessage", result.InstructionsOfAdministration);
        }

            setCompositionEditKey((prevKey) => prevKey + 1);
            // handleNewMedicineChange("medicinetype", result.type);
          }
        } catch (error) {
          console.error("Error Fetching Medicine composition:", error);
          showErrorToast(
            "An error occurred while Fetching Medicine composition"
          );
        } finally {
          // dismissLoader();
        }

        // fetchDoctorNotes();

        // console.log("Clicked");
      }
    };

    function transformStatesToApiInput(medicationArray) {
      // console.log(medicationArray);
      const today = moment().format("YYYY-MM-DD");
      const fiveDaysFromToday = moment().add(5, "days").format("YYYY-MM-DD");

      return medicationArray.map((med) => {
        const frequency =
          med.frequency ||
          (med.morning ? 1 : 0) + (med.afternoon ? 1 : 0) + (med.night ? 1 : 0);

        // Check if this is a topical medicine (Ointment, Cream, Gel)
        const isTopical = (med.medicinetype === "Syrup" || med.medicinetype === "Ointment" || med.medicinetype === "Cream" || med.medicinetype === "Gel");

        return {
          id: med.issaved ? med.id : null,
          inventoryid: med?.inventoryid,
          medicinename: med.medicinename,
          medicinetype: med.medicinetype,
          dosage: med.dosage,
          dosageunit: med.dosageunit,
          startdate: isTopical ? "" : (med.medicationstartdate
            ? moment(med.medicationstartdate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : today),
          enddate: isTopical ? "" : (med.medicationenddate
            ? moment(med.medicationenddate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : fiveDaysFromToday),
          // For topical, send Product Quantity in frequency so QTY column and backend stay correct
          frequency: isTopical ? (med.productQuantity || med.frequency || "1") : med.frequency,
          // frequency:
          //   med.frequency && med.frequencyduration
          //     ? med.frequency + " " + med.frequencyduration
          //     : med.frequency,
          frequencytime: med.frequencytime,
        frequencyvalue: med.frequencyvalue,
          morning: med.morning,
          afternoon: med.afternoon,
          evening: med.evening,
          night: med.night,
          beforefood: med.beforefood,
          afterfood: med.afterfood,
          chemical_composition: med.composition, // uncomment it when db changes are done
          Manufacturer: med.manufacturer,
          TherapeuticCategory: med.therapeutic,
          DrugClass: med.drugclass,
          prescribedby: doctorName,
          isactive: med.issaved ? med.isactive : 1,

          routeofadministration: med.routeofadministration,
          timingofinjection: med.timingofinjection,
          quantitytobeapplied: med.quantitytobeapplied,
          areaofapplication: med.areaofapplication,
          diluent: med.diluent,
          additives: med.additives,

          rateofinfusionvalue: med.rateofinfusionvalue,
          rateofinfusionunit: med.rateofinfusionunit,
          // "duration": durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue,
          "duration": isTopical ? "" : (med.durationvalue && med.durationunit ? (med.durationvalue + " " + med.durationunit) : med.durationvalue),
          applicationtiming: med.timing || "",
          wheretoapply: med.areaofapplication || "",
          productQuantity: isTopical ? (med.productQuantity || "1") : med.productQuantity,
      custommessage: med.custommessage,
      sos: med.sos
        };
      });
    }

    function transformCurrentMedicationStatesToApiInput(medicationArray) {
      const today = moment().format("YYYY-MM-DD");
      const fiveDaysFromToday = moment().add(5, "days").format("YYYY-MM-DD");

      return medicationArray.map((med) => {
        const frequency =
          med.frequency ||
          (med.morning ? 1 : 0) + (med.afternoon ? 1 : 0) + (med.night ? 1 : 0);

        // Check if this is a topical medicine (Ointment, Cream, Gel)
        const isTopical = (med.medicinetype === "Syrup" || med.medicinetype === "Ointment" || med.medicinetype === "Cream" || med.medicinetype === "Gel");

        return {
          prescribedmedicineid: med.issaved ? med.id : null,
          medicinename: med.medicinename,
          medicinetype: med.medicinetype,
          dosage: med.dosage,
          dosageunit: med.dosageunit,
          startdate: isTopical ? "" : (med.medicationstartdate
            ? moment(med.medicationstartdate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : today),
          enddate: isTopical ? "" : (med.medicationenddate
            ? moment(med.medicationenddate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : fiveDaysFromToday),
          // Match transformStatesToApiInput: topical uses productQuantity in frequency for backend
          frequency: isTopical ? (med.productQuantity || med.frequency || "1") : frequency,
          // frequencytime: frequencytime,
          // frequencyvalue: frequencyvalue,
          morning: med.morning,
          afternoon: med.afternoon,
          evening: med.evening,
          night: med.night,
          beforefood: med.beforefood,
          afterfood: med.afterfood,
          chemicalcomposition: med.composition, // uncomment it when db changes are done
          prescribedby: doctorName,
          medicineactive: med.issaved ? med.isactive : 1,
          iscurrentmedicine: med.iscurrent,
          
          // Topical medicine fields
          quantitytobeapplied: med.quantitytobeapplied || "",
          areaofapplication: med.areaofapplication || "",
          applicationtiming: med.timing || med.applicationtiming || "",
          wheretoapply: med.areaofapplication || "",
          productQuantity: isTopical ? (med.productQuantity || "1") : med.productQuantity || "",
          routeofadministration: med.routeofadministration || "",
          timingofinjection: med.timingofinjection || "",
          diluent: med.diluent || "",
          additives: med.additives || "",
          rateofinfusionvalue: med.rateofinfusionvalue || "",
          rateofinfusionunit: med.rateofinfusionunit || "ml/hr",
          duration: isTopical ? "" : (med.durationvalue && med.durationunit ? (med.durationvalue + " " + med.durationunit) : med.durationvalue || ""),
      custommessage: med.custommessage || "",
      sos: med.sos || ""
        };
      });
    }

    function filterAndTransformCurrentMedicinesToPrescription(input) {
      // Filter the objects where "isactive" is not available or not zero
      const filtered = input.filter(
        (item) => item.isactive === undefined || item.isactive !== 0
      );
      console.log(filtered, "function from details");

      // Transform the filtered objects
      const transformed = filtered.map((item) => {
        // Check if this is a topical medicine
        const isTopical = (item.medicinetype === "Syrup" || item.medicinetype === "Ointment" || item.medicinetype === "Cream" || item.medicinetype === "Gel");

        return {
          ...item,
          id: item.id,
          inventoryid: null,
          isactive: 1,
          chemical_composition: item.composition,
          Manufacturer: item.manufacturer,
          DrugClass: item.drugclass,
          TherapeuticCategory: item.therapeutic,
          medicationstartdate: moment(item.medicationstartdate, "DD-MM-YYYY").format("YYYY-MM-DD"),
          medicationenddate: moment(item.medicationenddate, "DD-MM-YYYY").format("YYYY-MM-DD"),
          startdate: item.medicationstartdate ? moment(item.medicationstartdate, "DD-MM-YYYY").format("YYYY-MM-DD") : today,
          enddate: item.medicationenddate ? moment(item.medicationenddate, "DD-MM-YYYY").format("YYYY-MM-DD") : fiveDaysFromToday,
          // Override spread frequency for topical: must match productQuantity (same as transformStatesToApiInput)
          frequency: isTopical ? (item.productQuantity || item.frequency || "1") : item.frequency,
          // Include topical-specific fields
          quantitytobeapplied: item.quantitytobeapplied || "",
          areaofapplication: item.areaofapplication || "",
          applicationtiming: item.timing || item.applicationtiming || "",
          wheretoapply: item.areaofapplication || "",
          routeofadministration: item.routeofadministration || "",
          timingofinjection: item.timingofinjection || "",
          diluent: item.diluent || "",
          additives: item.additives || "",
          rateofinfusionvalue: item.rateofinfusionvalue || "",
          rateofinfusionunit: item.rateofinfusionunit || "ml/hr",
          duration: isTopical ? "" : item.duration || "",
          custommessage: item.custommessage || "",
          sos: item.sos || "",
        };
      });

      return transformed;
    }

    const saveMedicineToOrders = async () => {
      // if (selectedMedicines.length === 0) {
      //   showErrorToast("Please select or add any medicines first.");
      // } else {
      const inputData = {
        input: {
          patientid: patientId,
          doctorid: doctorId,
          appointmentid: appointmentId,
          medicinedetail: [
            ...transformStatesToApiInput(selectedMedicines),
            ...filterAndTransformCurrentMedicinesToPrescription(
              patientCurrentMedicinesForDoctor
            ),
          ],
        },
      };

      // console.log("doctor save", inputData.input);
      // console.log("doctor add", selectedMedicines);

      try {
        showLoader();
        // console.log(inputData);
        const result = await updateDoctorNotes(inputData.input);
        // console.log(result);
        if (result) {
          showSuccessToast("Medicine added to orders successfully");
        }
        addPrescription.current.closeRight();
      } catch (error) {
        console.error("Error adding medicine to orders:", error);
        showErrorToast("An error occurred while adding medicine to orders");
      } finally {
        dismissLoader();
      }

      fetchDoctorNotes();
    };
    // console.log("Clicked");
    // };

    function flipCurrentAndFilterAndTransformMedicines(input) {
      // Filter the objects where "isactive" is not available or not zero
      const filtered = input.filter(
        (item) => item.isactive === undefined || item.isactive !== 0
      );
    //  console.log(filtered, "function called");
      // Transform the filtered objects
      const transformed = filtered.map((item) => {
        // Check if this is a topical medicine (Ointment, Cream, Gel)
        const isTopical = (item.medicinetype === "Syrup" || item.medicinetype === "Ointment" || item.medicinetype === "Cream" || item.medicinetype === "Gel");
        
        return {
          ...item,
          id: item.id,
          inventoryid: null,
          // Ensure topical medicine fields are included
          quantitytobeapplied: item.quantitytobeapplied || "",
          areaofapplication: item.areaofapplication || "",
          applicationtiming: item.timing || item.applicationtiming || "",
          wheretoapply: item.areaofapplication || "",
          duration: isTopical ? "" : (item.duration || ""),
          // Backend expects product quantity mirrored in frequency for topical types
          frequency: isTopical ? (item.productQuantity || item.frequency || "1") : item.frequency,
          custommessage: item.custommessage || "",
          sos: item.sos || ""
        };
      });

      return transformed;
    }

    const saveCurrentPatientMedicineToOrders = async () => {
      const inputData = {
        input: {
          patientid: patientId,
          doctorid: doctorId,
          appointmentid: appointmentId,
          medications: flipCurrentAndFilterAndTransformMedicines(
            patientCurrentMedicinesForDoctor
          ),
        },
      };

      // console.log(inputData.input);

      // console.log("patient save", inputData.input);
      // console.log("patient add", patientCurrentMedicinesForDoctor);

      try {
        // showLoader();
        console.log(inputData);
        const result = await doctorUpdatePatientMedicine(inputData.input);
        // const result = "abc"
        console.log(result);
        if (result) {
          // showSuccessToast("Medicine added to orders successfully");
        }
        addPrescription.current.closeRight();
      } catch (error) {
        console.error("Error adding medicine to orders:", error);
        showErrorToast(
          "An error occurred while updating patient current medicines."
        );
      } finally {
        // dismissLoader();
      }

      // console.log("Clicked");
    };

    useImperativeHandle(ref, () => ({
      saveMedicineToOrders,
      saveCurrentPatientMedicineToOrders,
    }));

    const [sortOption, setSortOption] = useState(""); // this is for sorting medicines on doctor fav panel

    //--------------------Quick Dates Set Options

    //----------Edit card
    const [intervalOption, setIntervalOption] = useState("Days");

    const [intervalValue, setIntervalValue] = useState(5); // default value of 5

    // const calculateEndDate = () => {
    //   if (
    //     editMedicine?.medicationstartdate &&
    //     intervalOption &&
    //     intervalValue
    //   ) {
    //     const intervalMap = { Days: 1, Weeks: 7, Months: 30, Years: 365 };
    //     const intervalMultiplier = intervalMap[intervalOption];
    //     const daysToAdd = intervalMultiplier * intervalValue - 1;

    //     // Parse start date in DD-MM-YYYY format
    //     let medicationStartDate = editMedicine.medicationstartdate;

    //     // // Check if the date is in DD-MM-YYYY format, if not, convert it
    //     // console.log(medicationStartDate)
    //     // console.log(moment(medicationStartDate, "DD-MM-YYYY", true).isValid())
    //     if (!/^\d{2}-\d{2}-\d{4}$/.test(medicationStartDate)) {
    //       // console.log("converting")
    //       medicationStartDate =
    //         moment(medicationStartDate).format("DD-MM-YYYY");
    //     }
    //     // console.log(medicationStartDate)
    //     const [day, month, year] = medicationStartDate.split("-").map(Number);
    //     const startDate = new Date(year, month - 1, day); // JS months are 0-indexed

    //     startDate.setDate(startDate.getDate() + daysToAdd);

    //     // Format new end date as DD-MM-YYYY
    //     const formattedEndDate = [
    //       String(startDate.getDate()).padStart(2, "0"),
    //       String(startDate.getMonth() + 1).padStart(2, "0"),
    //       startDate.getFullYear(),
    //     ].join("-");

    //     // Update medicationenddate in editMedicine
    //     setEditMedicine((prev) => ({
    //       ...prev,
    //       medicationenddate: formattedEndDate,
    //     }));
    //   }
    // };

    // useEffect(() => {
    //   if (intervalOption && intervalValue) {
    //     calculateEndDate();
    //   }
    // }, [intervalOption, intervalValue, editMedicine?.medicationstartdate]);

    const calculateEndDate = () => {
      // if (newMedicine?.medicationstartdate && intervalOption && intervalValue) {
        if (editMedicine?.medicationstartdate && editMedicine.durationunit && editMedicine.durationvalue) {
        const intervalMap = { Days: 1, Weeks: 7, Months: 30, Years: 365 };
        // const intervalMultiplier = intervalMap[intervalNewOption];
        // const daysToAdd = intervalMultiplier * intervalNewValue - 1;
        const intervalMultiplier = intervalMap[editMedicine.durationunit];
        const daysToAdd = intervalMultiplier * editMedicine.durationvalue - 1;

        // Parse start date in DD-MM-YYYY format
        let medicationStartDate = editMedicine.medicationstartdate;

        // Check if the date is in DD-MM-YYYY format, if not, convert it

        if (!/^\d{2}-\d{2}-\d{4}$/.test(medicationStartDate)) {
          medicationStartDate =
            moment(medicationStartDate).format("DD-MM-YYYY");
        }
        const [day, month, year] = medicationStartDate.split("-").map(Number);
        const startDate = new Date(year, month - 1, day); // JS months are 0-indexed

        startDate.setDate(startDate.getDate() + daysToAdd);

        // Format new end date as DD-MM-YYYY
        const formattedEndDate = [
          String(startDate.getDate()).padStart(2, "0"),
          String(startDate.getMonth() + 1).padStart(2, "0"),
          startDate.getFullYear(),
        ].join("-");

        // console.log(formattedEndDate);

        // Update medicationenddate in editMedicine
        setEditMedicine((prev) => ({
          ...prev,
          medicationenddate: formattedEndDate,
        }));
      }
    };

    // useEffect(() => {
    //   if (editMedicine.durationunit && editMedicine.durationvalue) {
    //     calculateEndDate();
    //   }
    // }, [editMedicine.durationunit, editMedicine.durationvalue, editMedicine?.medicationstartdate]);

    const handleIntervalChange = (value) => {
      handleEditMedicineChange("durationunit", value);
      // Update the combined duration string
      handleEditMedicineChange("duration", `${editMedicine.durationvalue} ${value}`);
    };
    
    const handleIntervalValueChange = (e) => {
      const value = parseInt(e.target.value, 10);
      const cleanValue = isNaN(value) ? "" : value;
      handleEditMedicineChange("durationvalue", cleanValue);
      // Update the combined duration string
      handleEditMedicineChange("duration", `${cleanValue} ${editMedicine.durationunit}`);
    };
    useEffect(() => {
      if (
        editMedicine?.medicationstartdate &&
        editMedicine?.durationunit &&
        editMedicine?.durationvalue
      ) {
        calculateSelectedEndDate();
      }
    }, [
      editMedicine?.medicationstartdate,
      editMedicine?.durationunit,
      editMedicine?.durationvalue
    ]);
    
    
    const calculateSelectedEndDate = () => {
      // if (newMedicine?.medicationstartdate && intervalOption && intervalValue) {
        if (editMedicine?.medicationstartdate && editMedicine.durationunit && editMedicine.durationvalue) {
        const intervalMap = { Days: 1, Weeks: 7, Months: 30, Years: 365 };
        // const intervalMultiplier = intervalMap[intervalNewOption];
        // const daysToAdd = intervalMultiplier * intervalNewValue - 1;
        const intervalMultiplier = intervalMap[editMedicine.durationunit];
        const daysToAdd = intervalMultiplier * editMedicine.durationvalue - 1;

        // Parse start date in DD-MM-YYYY format
        let medicationStartDate = editMedicine.medicationstartdate;

        // Check if the date is in DD-MM-YYYY format, if not, convert it

        if (!/^\d{2}-\d{2}-\d{4}$/.test(medicationStartDate)) {
          medicationStartDate =
            moment(medicationStartDate).format("DD-MM-YYYY");
        }
        const [day, month, year] = medicationStartDate.split("-").map(Number);
        const startDate = new Date(year, month - 1, day); // JS months are 0-indexed

        startDate.setDate(startDate.getDate() + daysToAdd);

        // Format new end date as DD-MM-YYYY
        const formattedEndDate = [
          String(startDate.getDate()).padStart(2, "0"),
          String(startDate.getMonth() + 1).padStart(2, "0"),
          startDate.getFullYear(),
        ].join("-");

        // console.log(formattedEndDate);

        // Update medicationenddate in editMedicine
        setEditMedicine((prev) => ({
          ...prev,
          medicationenddate: formattedEndDate,
        }));
      }
    };
    // const handleIntervalChange = (value) => {
    //   setIntervalOption(value);
    // };

    // const handleIntervalValueChange = (e) => {
    //   const value = parseInt(e.target.value, 10);
    //   setIntervalValue(isNaN(value) ? 0 : value); // handle NaN cases if input is empty
    // };

    // const handleRadioChange = (value) => {
    //   setRadioValue(value);
    //   calculateEndDate();
    // };

    // const handleSelectIntervalChange = (e) => {
    //   setIntervalOption(e.target.value);
    //   calculateEndDate();
    // };

    //-------------New card
    // const [intervalNewOption, setIntervalNewOption] = useState("Days");

    // const [intervalNewValue, setIntervalNewValue] = useState(5); // default value of 5

    const handleIntervalNewChange = (value) => {
      handleNewMedicineChange("durationunit", value);
      // Update the combined duration string
      handleNewMedicineChange("duration", `${newMedicine.durationvalue} ${value}`);
    };
    
    const handleIntervalNewValueChange = (e) => {
      const value = parseInt(e.target.value, 10);
      const cleanValue = isNaN(value) ? "" : value;
      handleNewMedicineChange("durationvalue", cleanValue);
      // Update the combined duration string
      handleNewMedicineChange("duration", `${cleanValue} ${newMedicine.durationunit}`);
    };

    const calculateNewEndDate = () => {
      // if (newMedicine?.medicationstartdate && intervalOption && intervalValue) {
        if (newMedicine?.medicationstartdate && newMedicine.durationunit && newMedicine.durationvalue) {
        const intervalMap = { Days: 1, Weeks: 7, Months: 30, Years: 365 };
        // const intervalMultiplier = intervalMap[intervalNewOption];
        // const daysToAdd = intervalMultiplier * intervalNewValue - 1;
        const intervalMultiplier = intervalMap[newMedicine.durationunit];
        const daysToAdd = intervalMultiplier * newMedicine.durationvalue - 1;

        // Parse start date in DD-MM-YYYY format
        let medicationStartDate = newMedicine.medicationstartdate;

        // Check if the date is in DD-MM-YYYY format, if not, convert it

        if (!/^\d{2}-\d{2}-\d{4}$/.test(medicationStartDate)) {
          medicationStartDate =
            moment(medicationStartDate).format("DD-MM-YYYY");
        }
        const [day, month, year] = medicationStartDate.split("-").map(Number);
        const startDate = new Date(year, month - 1, day); // JS months are 0-indexed

        startDate.setDate(startDate.getDate() + daysToAdd);

        // Format new end date as DD-MM-YYYY
        const formattedEndDate = [
          String(startDate.getDate()).padStart(2, "0"),
          String(startDate.getMonth() + 1).padStart(2, "0"),
          startDate.getFullYear(),
        ].join("-");

        // console.log(formattedEndDate);

        // Update medicationenddate in editMedicine
        setNewMedicine((prev) => ({
          ...prev,
          medicationenddate: formattedEndDate,
        }));
      }
    };

    useEffect(() => {
      if (newMedicine.durationunit && newMedicine.durationvalue) {
        calculateNewEndDate();
      }
    }, [newMedicine.durationunit, newMedicine.durationvalue, newMedicine?.medicationstartdate]);

    // useEffect(() => {
    //   if (intervalNewOption && intervalNewValue) {
    //     calculateNewEndDate();
    //   }
    // }, [intervalNewOption, intervalNewValue, newMedicine?.medicationstartdate]);

    // const handleIntervalNewChange = (value) => {
    //   setIntervalNewOption(value);
    // };

    // const handleIntervalNewValueChange = (e) => {
    //   const value = parseInt(e.target.value, 10);
    //   setIntervalNewValue(isNaN(value) ? 0 : value); // handle NaN cases if input is empty
    // };

    //----------------------Current card
    const [intervalCurrentOption, setIntervalCurrentOption] = useState("Days");

    const [intervalCurrentValue, setIntervalCurrentValue] = useState(5); // default value of 5

    // const calculateCurrentEndDate = () => {
    //   if (
    //     editCurrentMedicine?.medicationstartdate &&
    //     intervalOption &&
    //     intervalValue
    //   ) {
    //     const intervalMap = { Days: 1, Weeks: 7, Months: 30, Years: 365 };
    //     const intervalMultiplier = intervalMap[intervalCurrentOption];
    //     const daysToAdd = intervalMultiplier * intervalCurrentValue - 1;

    //     // Parse start date in DD-MM-YYYY format
    //     // console.log(editCurrentMedicine.medicationstartdate)
    //     let medicationStartDate = editCurrentMedicine.medicationstartdate;

    //     // Check if the date is in DD-MM-YYYY format, if not, convert it

    //     if (!/^\d{2}-\d{2}-\d{4}$/.test(medicationStartDate)) {
    //       medicationStartDate =
    //         moment(medicationStartDate).format("DD-MM-YYYY");
    //     }
    //     const [day, month, year] = medicationStartDate.split("-").map(Number);
    //     const startDate = new Date(year, month - 1, day); // JS months are 0-indexed

    //     startDate.setDate(startDate.getDate() + daysToAdd);

    //     // Format new end date as DD-MM-YYYY
    //     const formattedEndDate = [
    //       String(startDate.getDate()).padStart(2, "0"),
    //       String(startDate.getMonth() + 1).padStart(2, "0"),
    //       startDate.getFullYear(),
    //     ].join("-");

    //     // Update medicationenddate in editMedicine
    //     setEditCurrentMedicine((prev) => ({
    //       ...prev,
    //       medicationenddate: formattedEndDate,
    //     }));
    //   }
    // };

    const calculateCurrentEndDate = () => {
      // if (newMedicine?.medicationstartdate && intervalOption && intervalValue) {
        if (editCurrentMedicine?.medicationstartdate && editCurrentMedicine.durationunit && editCurrentMedicine.durationvalue) {
        const intervalMap = { Days: 1, Weeks: 7, Months: 30, Years: 365 };
        // const intervalMultiplier = intervalMap[intervalNewOption];
        // const daysToAdd = intervalMultiplier * intervalNewValue - 1;
        const intervalMultiplier = intervalMap[editCurrentMedicine.durationunit];
        const daysToAdd = intervalMultiplier * editCurrentMedicine.durationvalue - 1;

        // Parse start date in DD-MM-YYYY format
        let medicationStartDate = editCurrentMedicine.medicationstartdate;

        // Check if the date is in DD-MM-YYYY format, if not, convert it

        if (!/^\d{2}-\d{2}-\d{4}$/.test(medicationStartDate)) {
          medicationStartDate =
            moment(medicationStartDate).format("DD-MM-YYYY");
        }
        const [day, month, year] = medicationStartDate.split("-").map(Number);
        const startDate = new Date(year, month - 1, day); // JS months are 0-indexed

        startDate.setDate(startDate.getDate() + daysToAdd);

        // Format new end date as DD-MM-YYYY
        const formattedEndDate = [
          String(startDate.getDate()).padStart(2, "0"),
          String(startDate.getMonth() + 1).padStart(2, "0"),
          startDate.getFullYear(),
        ].join("-");

        // console.log(formattedEndDate);

        // Update medicationenddate in editMedicine
        setEditCurrentMedicine((prev) => ({
          ...prev,
          medicationenddate: formattedEndDate,
        }));
      }
    };

    // useEffect(() => {
    //   if (intervalCurrentOption && intervalCurrentValue) {
    //     calculateCurrentEndDate();
    //   }
    // }, [
    //   intervalCurrentOption,
    //   intervalCurrentValue,
    //   editCurrentMedicine?.medicationstartdate,
    // ]);

    // useEffect(() => {
    //   // if (editCurrentMedicine.durationunit && editCurrentMedicine.durationvalue) {
    //   //   calculateCurrentEndDate();
    //   // }
    //   calculateCurrentEndDate();
    // }, [
    //   editCurrentMedicine?.medicationstartdate,
    // ]);
    useEffect(() => {
      if (editCurrentMedicine?.durationunit && editCurrentMedicine?.durationvalue) {
        calculateCurrentEndDate();
      }
    }, [
      editCurrentMedicine?.durationunit,
      editCurrentMedicine?.durationvalue,
      editCurrentMedicine?.medicationstartdate,
    ]);

    const handleIntervalCurrentChange = (value) => {
      handleEditCurrentMedicineChange("durationunit", value);
      // Update the combined duration string
      handleEditCurrentMedicineChange("duration", `${editCurrentMedicine.durationvalue} ${value}`);
    };
    
    const handleIntervalCurrentValueChange = (e) => {
      const value = parseInt(e.target.value, 10);
      const cleanValue = isNaN(value) ? "" : value;
      handleEditCurrentMedicineChange("durationvalue", cleanValue);
      // Update the combined duration string
      handleEditCurrentMedicineChange("duration", `${cleanValue} ${editCurrentMedicine.durationunit}`);
    };

    // const handleIntervalCurrentChange = (value) => {
    //   setIntervalCurrentOption(value);
    // };

    // const handleIntervalCurrentValueChange = (e) => {
    //   const value = parseInt(e.target.value, 10);
    //   setIntervalCurrentValue(isNaN(value) ? 0 : value); // handle NaN cases if input is empty
    // };

    // new functions
    function handleSOS(e) {
      // setSOS(e.target.value)
    } 
    function handleCustomMessage(e) {
      // setCustomMessage(e.target.value)
    }

    // ---------------------------------------------- Modal Add/edit form -----------------
    const addPrescriptionMedication = useRef();
    const editSelectedPrescriptionMedication = useRef();
    const editCurrentPrescriptionMedication = useRef();

    const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};

// waves 
   const recorderRef = useRef(null);
     const [chunks, setChunks] = useState([]);
       const [recording, setRecording] = useState(false);
     
    const [stream, setStream] = useState(null);

    useEffect(() => {
        if (recorderRef.current) return;
    
        if (navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((stream) => {
              setStream(stream);
    
              recorderRef.current = new MediaRecorder(stream);
              // audioContextRef.current = new AudioContext({
              //   sampleRate: WHISPER_SAMPLING_RATE,
              // });
    
              recorderRef.current.onstart = () => {
                setRecording(true);
                setChunks([]);
              };
              recorderRef.current.ondataavailable = (e) => {
                if (e.data.size > 0) {
                  setChunks((prev) => [...prev, e.data]);
                } else {
                  setTimeout(() => {
                    recorderRef.current.requestData();
                  }, 25);
                }
              };
    
              recorderRef.current.onstop = () => {
                setRecording(false);
              };
            })
            .catch((err) => console.error("The following error occurred: ", err));
        } else {
          console.error("getUserMedia not supported on your browser!");
        }
    
        return () => {
          recorderRef.current?.stop();
          recorderRef.current = null;
        };
      }, []);
    

  // ------------------------------------
  //Remove speech and keep Null to toggle between GPU and Speech
  const [SelectedLanguage, setSelectedLanguage] = useState("en-US");
  const [inpLang, setInpLang] = useState("English");
  
  const handleChangeLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; // Get the selected language
    setInpLang(selectedLanguage)
    const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found

    // Update the language in the transcriber
    setSelectedLanguage(languageCode);
    console.log("Selected Language: ", selectedLanguage);
    console.log("Language Code: ", languageCode);
  };

  const [outLang, setOutputLang] = useState("English")
  const handleChangeOutputLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; 
    // const languageCode = languageCodeMap[selectedLanguage] || "en-US"; 

    // Update the language in the transcriber
    setOutputLang(selectedLanguage);
    console.log("Selected Language OUTPUT: ", selectedLanguage);
    // console.log("Language Code OUTPUT: ", languageCode);
  };

  // Add this state to your parent component
  const [isRecording, setIsRecording] = useState(false);
  
  // Add this function to handle recording state changes
  const handleRecordingStateChange = (recording) => {
    setIsRecording(recording);
  };

// const activeTranscriber = useGPUTranscriber();
//Remove speech and keep Null to toggle between GPU and Speech
  const { transcriber: activeTranscriber, mode } =
    useHybridTranscriber("speech", (text) => {
      // called when speech recognition finishes
      setPlaceholder(text || "");
      setTyping(false);
  },
  SelectedLanguage);

  const [typing, setTyping] = useState(false); // Typing indicator state
  const [HPITextBox, SetHPITextBox] = useState("");

  const [placeholder, setPlaceholder] = useState(
    // "Click anywhere to start typing...."
    "Instructions"
  );
  const { register, handleSubmit, watch, setValue } = useForm();


  // existing
  // useEffect(() => {
  //     // console.log("triggered");
  //     if (activeTranscriber?.output?.text) {
  //       setValue("textField", activeTranscriber.output.text);
  
  //       // setPlaceholder("Click anywhere to start typing....");
  //       setPlaceholder("Instructions");
  //       setTyping(false);
  //     }
  //   }, [activeTranscriber?.output]);

  // newly added
  useEffect(() => {
  if (activeTranscriber?.output?.text) {
    const text = activeTranscriber.output.text;
    setPlaceholder("Instructions");
    setTyping(false);

    if (editMedicine) {
      handleEditMedicineChange("custommessage", text);
      setValue("textField", text, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    } else if (editCurrentMedicine) {
      handleEditCurrentMedicineChange("custommessage", text);
      setValue("textField", text, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    } else {
      handleNewMedicineChange("custommessage", text);
      setValue("textField", text, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    }
  }
}, [activeTranscriber?.output?.text]);
// }, [activeTranscriber?.output?.text, isAddModalOpen, isSelectedEditModalOpen, isCurrentEditModalOpen, setValue]);

  const textFieldValue = watch("textField", "");
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [initialText, setInitialText] = useState("");

  const onSubmit = (data) => {
      setIsButtonDisabled(true); // Disable button on submit
      // UpdateHpiTextBox(data);
      SetHPITextBox(data);
      // fetchDoctorNotesEmptyIndication();
    };
  
     // submit on tab switch and submit button is enalbed
      useEffect(()=>{
          if(!isButtonDisabled){
          handleSubmit(onSubmit)();
          }
      },[])
  
    useEffect(() => {
      if (textFieldValue !== initialText) {
        setIsButtonDisabled(false); // Enable button if text field value changes
      } else {
        setIsButtonDisabled(true); // Disable button if text field value is unchanged
      }
    }, [textFieldValue, initialText]);

    // ---------------------------------------------------

//     const correctOrders = async (formType) => {

//       const currentText = formType === "edit" 
//       ? editMedicine.custommessage 
//       : watch("textField");
//     // const currentText = watch("textField")
//     // const currentText = newMedicine.custommessage; // Using the custommessage directly
    
//     if (!currentText) {
//       showErrorToast("No text available to correct");
//       return;
//     }

//     const inputToSave = {
//       input: {
//         text: currentText,
//       },
//     };

//     showLoader();
//     try {
//       const result = await CorrectChiefComplaintUsingAI(inputToSave.input);
//       if (result) {
//         showSuccessToast("Updated Text");
//         const updatedText = result?.text;

//          if (formType === "add") {
//           // For add form
//           handleNewMedicineChange("custommessage", updatedText);
//           setValue("textField", updatedText, {
//             shouldDirty: true,
//             shouldTouch: true,
//             shouldValidate: true,
//           });
//         } else {
//           // For edit form
//           handleEditMedicineChange("custommessage", updatedText);
//           setValue("textField", updatedText, {
//             shouldDirty: true,
//             shouldTouch: true,
//             shouldValidate: true,
//           });
//         }

//         // Set value in form and manually trigger form revalidation
//         // setValue("textField", updatedText, {
//         //   shouldDirty: true,  // ✅ mark as modified
//         //   shouldTouch: true,  // ✅ mark as touched
//         //   shouldValidate: true, // ✅ force validation so watch() reflects it
//         // });
        
//         // // Update the newMedicine state with the corrected text
//         // if(formType == "add"){
//         //   handleNewMedicineChange("custommessage", updatedText);

//         // }else if(formType == "edit"){
//         //   handleEditMedicineChange("custommessage", updatedText);

//         // }
        
//         // Allow submit button to enable if needed
//         setIsButtonDisabled(false);
//       }
//     } catch (error) {
//       console.error("Error in Correct AI call:", error);
//       showErrorToast("Error Happened While Correcting.");
//     } finally {
//       dismissLoader();
//     }
// };

const correctOrders = async (formType) => {
    // const currentText = watch("textField");
    let currentText = "";
  if (formType === "edit") {
    currentText = editMedicine?.custommessage || "";
  } else if (formType === "currentedit") {
    currentText = editCurrentMedicine?.custommessage || "";
  } else {
    currentText = newMedicine?.custommessage || "";
  }
    
    if (!currentText) {
      showErrorToast("No text available to correct");
      return;
    }

    const inputToSave = {
      input: {
        text: currentText,
        // type: `medicine_instructions#ayurvedic, Psychiatry#99#Consultation Note#Urdu#Hindi`,
        type: `medicine_instructions#${specialities}#${experience}#Consultation Note#${inpLang}#${outLang}`,
      },
    };

    showLoader();
    try {
      const result = await CorrectMedicalTermsUsingAI(inputToSave);
      // const result = await CorrectInstructionsUsingAI(inputToSave.input);
      if (result) {
        showSuccessToast("Updated Text");
        const updatedText = result?.text;

        if (formType === "add") {
        handleNewMedicineChange("custommessage", updatedText);
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      } else if (formType === "edit") {
        handleEditMedicineChange("custommessage", updatedText);
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      } else if (formType === "currentedit") {
        handleEditCurrentMedicineChange("custommessage", updatedText);
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      }

        // Update form value
//         setValue("textField", updatedText, {
//           shouldDirty: true,
//           shouldTouch: true,
//           shouldValidate: true,
//         });

// console.log('updatedText: ', updatedText)
// // Update the instructions map
//       if (selectMedicineId) {
//         setInstructionsMap(prevMap => ({
//           ...prevMap,
//           [selectMedicineId]: updatedText
//         }));
//       }else if(currentMedicineId) {
//         setCurrentInstructionsMap(prevMap => ({
//           ...prevMap,
//           [currentMedicineId]: updatedText
//         }));

//       }
        
//         // Update the appropriate state based on form type
//         if (formType === "add") {
//           handleNewMedicineChange("custommessage", updatedText);
//         } else if(formType === "currentedit") {
//           handleEditCurrentMedicineChange("custommessage", updatedText);
//         } else {
//           handleEditMedicineChange("custommessage", updatedText);
//         }
        
        setIsButtonDisabled(false);
      }
    } catch (error) {
      console.error("Error in Correct AI call:", error);
      showErrorToast("Error Happened While Correcting.");
    } finally {
      dismissLoader();
    }
};

// Handler for transcribed text
// const handleTranscribedText = (text) => {
//   // if (isEditMode) { // You need to determine edit mode
//   console.log('text: ', text)
//     handleEditMedicineChange("custommessage", text);
//     setValue("textField", text, {
//       shouldDirty: true,
//       shouldTouch: true,
//       shouldValidate: true,
//     });
//   // } else {
//   //   handleNewMedicineChange("custommessage", text);
//   //   setValue("textField", text, {
//   //     shouldDirty: true,
//   //     shouldTouch: true,
//   //     shouldValidate: true,
//   //   });
//   // }
// };

    
// keep this, we can use this still
// const handleCheckboxChange = (medicine) => {
//   // helper to compare medicines robustly
//   const areSameMedicine = (a, b) => {
//     const nameA = (a?.medicinename || "").toString().toLowerCase().trim();
//     const nameB = (b?.medicinename || "").toString().toLowerCase().trim();
//     const typeA = (a?.medicinetype || "").toString().trim();
//     const typeB = (b?.medicinetype || "").toString().trim();
//     const doseA = (a?.dosage || "").toString().trim();
//     const doseB = (b?.dosage || "").toString().trim();
//     const unitA = (a?.dosageunit || "").toString().trim();
//     const unitB = (b?.dosageunit || "").toString().trim();
//     return nameA === nameB && typeA === typeB && doseA === doseB && unitA === unitB;
//   };

//   // If medicine already exists in current patient meds or saved prescribed meds (and not already selected),
//   // disallow adding from favourites to prevent duplicates.
//   const existsInCurrent = patientCurrentMedicinesForDoctor.some(
//     (m) => areSameMedicine(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
//   );
//   const existsInSaved = savedMedicines.some(
//     (m) => areSameMedicine(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
//   );
//   const existsInSelected = selectedMedicines.some(
//     (m) => areSameMedicine(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
//   );

//   if ((existsInCurrent || existsInSaved) && !existsInSelected) {
//     // prevent adding duplicate and inform user
//     showErrorToast && showErrorToast("This medicine is already present in the doctor's notes.");
//     return;
//   }

//   // proceed with existing toggle/add behavior
//   setSelectedMedicines((prev) => {
//     const existingIndex = prev.findIndex((m) =>
//       m.medicinename === medicine.medicinename &&
//       m.medicinetype === medicine.medicinetype &&
//       m.dosage === medicine.dosage &&
//       m.dosageunit === medicine.dosageunit
//     );

//     if (existingIndex >= 0) {
//       // Toggle isactive status
//       return prev.map((m, index) =>
//         index === existingIndex
//           ? { ...m, isactive: m.isactive === 0 ? 1 : 0 }
//           : m
//       );
//     } else {
//       // Add new medicine as active
//       return [...prev, { ...medicine, isactive: 1 }];
//     }
//   });
// };

    return (
      <Box
        display="flex"
        height={{ base: "100vh", md: "79vh" }}
        overflow={"hidden, auto"}
        flexWrap={{ base: "wrap", md: "nowrap" }}
      >
        {/* Left area starts */}
        <Box
          width={{ base: "100%", lg: "50%" }}
          borderRight={{ base: "none", lg: "1px solid gray" }}
        >
          <Tabs>
            {screenType == "mobile" && (
              <>
                {selectedTab === "recurrent" && (
                  <Box width="100%" mb="12px" height={"2rem"} mr={"12px"}>
                    <SearchBar
                      passInputPlace="Search"
                      height={"2rem"}
                      onChange={(event) => setSearch(event.target.value)}
                    />
                  </Box>
                )}

                {selectedTab === "current" && (
                  <PrimaryButton
                    buttonText="Select All"
                    verticalAlign="bottom"
                    variant="grayBtn"
                    btnStyle={{
                      w: "100%",
                      color: COLORS.PRIMARY_COLOR,
                      verticalAlign: "bottom",
                      mr: "12px",
                      mb: "10px",
                      h: "2.7rem",
                    }}
                    onClick={handleSelectAll}
                  />
                )}
              </>
            )}
            <TabList height={"3rem"} borderBottom={"1px solid gray"}>
              <Tab
                onClick={() => handleTabChange("recurrent")}
                _selected={{ color: "black", borderBottom: "2px solid black" }}
                fontSize={{ base: "12px", lg: "initial" }}
              >
                My Prescribed Medicines
              </Tab>
              <Tab
                onClick={() => handleTabChange("current")}
                _selected={{ color: "black", borderBottom: "2px solid black" }}
                fontSize={{ base: "12px", lg: "initial" }}
              >
                Patient Current Medicine
              </Tab>
              <Spacer />
              {screenType !== "mobile" && (
                <>
                  {/* {selectedTab === "recurrent" && (
                    <Box width="30%" mb={"4px"} height={"2rem"} mr={"12px"}>
                      <SearchBar
                        passInputPlace="Search"
                        height={"2rem"}
                        onChange={(event) => setSearch(event.target.value)}
                      />
                    </Box>
                  )} */}
                  {selectedTab === "recurrent" && (
                    // <Box display="flex" alignItems="end">

                    <Box
                      display="flex"
                      width="50%"
                      mb={"4px"}
                      height={"2rem"}
                      mr={"12px"}
                    >
                      <Box width="40%">
                        <Select
                          placeholder="Sort by"
                          onChange={(e) => setSortOption(e.target.value)}
                          width="100%"
                          // height={"2rem"}
                        >
                          <option value="A-Z">Name</option>
                          <option value="availability">Availability</option>
                        </Select>
                      </Box>

                      <Box width="60%" ml="12px">
                        {" "}
                        {/* Add margin-left to separate them */}
                        <SearchBar
                          passInputPlace="Search"
                          height={"2rem"}
                          onChange={(event) => setSearch(event.target.value)}
                          width="100%"
                        />
                      </Box>
                    </Box>

                    // </Box>
                  )}
                  {selectedTab === "current" && (
                    <PrimaryButton
                      buttonText="Select All"
                      verticalAlign="bottom"
                      variant="grayBtn"
                      btnStyle={{
                        w: "15%",
                        color: COLORS.PRIMARY_COLOR,
                        verticalAlign: "bottom",
                        mr: "12px",
                        mb: "0px",
                        h: "2.7rem",
                      }}
                      onClick={handleSelectAll}
                    />
                  )}
                </>
              )}
            </TabList>
            <TabPanels height="calc(77vh - 2.5rem)" overflowY="auto">
              {/* {isLoading && (
                <Box
                  position="absolute"
                  top="0"
                  left="0"
                  width="100%"
                  height="100%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  zIndex="10"
                  bg="rgba(255, 255, 255, 0.8)"
                >
                  <Loader miniLoader={true} />
                </Box>
              )} */}
              <TabPanel p={{ base: "0" }}>
                {isLoading && (
                  <Box
                    position="absolute"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    zIndex="10"
                    bg="rgba(255, 255, 255, 0.8)"
                  >
                    <Loader miniLoader={true} />
                  </Box>
                )}
               {recentMedicines.length === 0 ? (
                  <NoDataScreen width="100%" height="100%" />
                ) : search.trim() !== "" &&
                  recentMedicines.filter((medicine) =>
                    medicine.medicinename?.toLowerCase().includes(search.toLowerCase()) ||
                    medicine.composition?.toLowerCase().includes(search.toLowerCase())
                  ).length === 0 ? (
                  <NoDataScreen width="100%" height="100%" />
                ): (
                  recentMedicines
                    .filter((medicine) =>
                      medicine.medicinename
                        ?.toLowerCase()
                        .includes(search.toLowerCase()) ||
                        medicine.composition?.toLowerCase().includes(search.toLowerCase())
                    )
                    .sort((a, b) => {
                      if (sortOption === "A-Z") {
                        return a.medicinename.localeCompare(b.medicinename);
                      } else if (sortOption === "availability") {
                        return b.remainingquantity - a.remainingquantity;
                      }
                      return 0;
                    })
                    .map((medicine) => (
                      <Box display="flex" alignItems="center">
                        <Box
                          as="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="36px"
                          h="auto"
                          p="10px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          onClick={isChatbotAllowed() ? () => fetchAiDoctorPrompts(medicine.medicinename) : null}
                          cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                          opacity={isChatbotAllowed() ? 1 : 0.5}
                          bg={isChatbotAllowed() ? "transparent" : "gray.100"}
                          _hover={
                            isChatbotAllowed() 
                              ? { bg: "gray.50", borderColor: "gray.300" } 
                              : {}
                          }
                          title={
                            !isChatbotAllowed() 
                              ? "Please upgrade your subscription to use AI features" 
                              : "Get AI suggestions"
                          }
                        >
                          <Image 
                            w="26px" 
                            src="/assets/svgs/ai-star-outline.svg" 
                            opacity={isChatbotAllowed() ? 1 : 0.5}
                            filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
                          />
                        </Box>
                        <IconButton
                          aria-label="Search for alternatives"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          icon={<GiMedicines />}
                          onClick={() =>
                            fetchAlternativeMedicines(
                              medicine.medicinename,
                              medicine.composition
                            )
                          }
                          variant="ghost"
                          w="36px"
                          h="36px"
                          ml="4px"
                        />
                        <Box
                          key={medicine.id}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          p="10px"
                          borderBottom="1px solid gray"
                          as="button"
                          // existing
      //                     onClick={() => {
      //                       // console.log("clicked")
      //                       handleCheckboxChange(medicine);
      //                       // Set edit medicine only if it's not already in selectedMedicines
      // //                       if (!selectedMedicines.includes(medicine)) {
      // // editSelectedPrescriptionMedication.current.openModal();
      // //                         setEditMedicine(medicine);
      // //                       }
      //                     }}
      onClick={(e) => {
                            // ignore clicks originating from the checkbox element itself
                            if (e?.target?.type === "checkbox") return;
                            handleCheckboxChange(medicine);
                          }}
                          width={"100%"}
                          gap={{ base: "5px", md: "0" }}
                        >
                          <Checkbox
                            // isChecked={selectedMedicines.includes(medicine)}
                            // isChecked={selectedMedicines.some(m => m.id === medicine.id)}
                             isChecked={selectedMedicines.some(m => 
                              m.medicinename === medicine.medicinename &&
                              m.medicinetype === medicine.medicinetype &&
                              m.dosage === medicine.dosage &&
                              m.dosageunit === medicine.dosageunit &&
                              m.isactive === 1  // Only consider active medicines as checked
                            )}
                            // existing
                            // onChange={() => {
                            //   // console.log("clicked")
                            //   handleCheckboxChange(medicine);
                            //   // Set edit medicine only if it's not already in selectedMedicines
                            //   // if (!selectedMedicines.includes(medicine)) {
                            //   //   editSelectedPrescriptionMedication.current.openModal();
                            //   //   setEditMedicine(medicine);
                            //   // }
                            // }}
                            onClick={(e) => {
                          if (e?.target?.type === "checkbox") return;
                          handleCheckboxChange(medicine);
                        }}
                          ></Checkbox>
                          <Box width="45%">
                            <Box
                              fontWeight={"semibold"}
                              textAlign={"left"}
                              fontSize={{ base: "14px", md: "16px" }}
                            >
                              {medicine.medicinename}{" "}
                              {medicine.dosage && (
                                <>
                                  ({medicine.dosage} {medicine.dosageunit})
                                </>
                              )}{" "}
                              <Box
                                display="inline-block"
                                verticalAlign="bottom"
                                fontSize="10px"
                                fontWeight="600"
                                bg="#E6E7E966"
                                border="1px solid #E6E7E9"
                                p="5px 10px"
                                borderRadius="full"
                                w="fit-content"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                              >
                                {medicine.medicinetype
                                  ? medicine.medicinetype
                                  : "-"}
                              </Box>
                              <Box
                                display="inline-block"
                                verticalAlign="bottom"
                                fontSize="10px"
                                fontWeight="600"
                                bg={
                                  medicine.remainingquantity
                                    ? "#73FF99"
                                    : "#FF7373"
                                }
                                border="1px solid #E6E7E9"
                                p="5px 10px"
                                borderRadius="full"
                                w="fit-content"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                                ml="4px"
                              >
                                {formatQuantity(medicine.remainingquantity)}
                              </Box>
                            </Box>
                            <Box fontSize={"xs"} textAlign={"left"}>
                              Composition: {medicine.composition}
                            </Box>
                          </Box>
                          <Box
                            display="flex"
                            flexDir={{ base: "column", md: "row" }}
                            w={{ base: "50%" }}
                          >
                            {medicine.frequencytime && medicine.frequencyvalue ? (
                               <Box
                               width={{ base: "100%", md: "30%" }}
                               textAlign={"left"}
                               fontSize={{ base: "14px", md: "16px" }}
                             >
                              {medicine.frequencytime === "Hours"
                                        ? `Every ${medicine.frequencyvalue} ${medicine.frequencytime}`
                                        : `${medicine.frequencytime} ${
                                          medicine.frequencyvalue === 1
                                              ? "once"
                                              : medicine.frequencyvalue === 2
                                              ? "twice"
                                              : medicine.frequencyvalue === 3
                                              ? "thrice"
                                              : `${medicine.frequencyvalue} times`
                                          }`}
                             </Box>
                            ):(
                              <Box
                              width={{ base: "100%", md: "30%" }}
                              textAlign={"left"}
                              fontSize={{ base: "14px", md: "16px" }}
                            >
                              {medicine.morning}-{medicine.afternoon}-
                              {medicine.night}
                            </Box>
                            )}
                           
                            <Box 
                             width={{ base: "100%", md: "70%" }}
                             textAlign={"left"}
                             fontSize={{ base: "14px", md: "16px" }}>
                                          {medicine.beforefood === 1 && medicine.afterfood === 1 && "Before & After Food"}
                                          {medicine.beforefood === 1 && (!medicine.afterfood || medicine.afterfood === 0) && "Before Food"}
                                          {(!medicine.beforefood || medicine.beforefood === 0) && medicine.afterfood === 1 && "After Food"}

                                          {(medicine.beforefood === 1 || medicine.afterfood === 1) && medicine.frequency && " - "}

                                          {medicine.frequency && `${medicine.frequency} Qty`}
                                        </Box>
                            {/* <Box
                              width={{ base: "100%", md: "70%" }}
                              textAlign={"left"}
                              fontSize={{ base: "14px", md: "16px" }}
                            >
                              {medicine.beforefood === 1 &&
                                medicine.afterfood === 1 && (
                                  <>Before & After Food</>
                                )}
                              {medicine.beforefood === 1 &&
                                (medicine.afterfood === 0 ||
                                  medicine.afterfood === null) && (
                                  <>Before Food</>
                                )}
                              {(medicine.beforefood === 0 ||
                                medicine.beforefood === null) &&
                                medicine.afterfood === 1 && (
                                  <>After Food</>
                                )}{" "}
                              {(medicine.beforefood === 1 ||
                                medicine.afterfood === 1) &&
                                medicine.frequency &&
                                "-"}
                              {medicine.frequency &&
                                `${medicine.frequency} x per day`}
                            </Box> */}
                          </Box>
                        </Box>
                      </Box>
                    ))
                )}
              </TabPanel>
              <TabPanel>
                {isLoading && (
                  <Box
                    position="absolute"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    zIndex="10"
                    bg="rgba(255, 255, 255, 0.8)"
                  >
                    <Loader miniLoader={true} />
                  </Box>
                )}
                {patientCurrentMedicinesForDoctor.length === 0 ? (
                  <NoDataScreen width="100%" height="100%" />
                ) : (
                  currentMedicines.map((medicine) => (
                    <Box display="flex" alignItems="center">
                        <Box
                          as="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="36px"
                          h="auto"
                          p="10px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          onClick={isChatbotAllowed() ? () => fetchAiDoctorPrompts(medicine.medicinename) : null}
                          cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                          opacity={isChatbotAllowed() ? 1 : 0.5}
                          bg={isChatbotAllowed() ? "transparent" : "gray.100"}
                          _hover={
                            isChatbotAllowed() 
                              ? { bg: "gray.50", borderColor: "gray.300" } 
                              : {}
                          }
                          title={
                            !isChatbotAllowed() 
                              ? "Please upgrade your subscription to use AI features" 
                              : "Get AI suggestions"
                          }
                        >
                          <Image 
                            w="26px" 
                            src="/assets/svgs/ai-star-outline.svg" 
                            opacity={isChatbotAllowed() ? 1 : 0.5}
                            filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
                          />
                        </Box>
                      {/* <IconButton
                          aria-label="Search for alternatives"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          icon={<GiMedicines />}
                          // onClick={() =>
                          //   copyToClipboard(aiPatientSocialHistory)
                          // }
                          variant="ghost"
                          w="36px"
                          h="36px"
                          ml="4px"
                        /> */}
                      <Box
                        key={medicine.id}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        p="10px"
                        borderBottom="1px solid gray"
                        as="button"
                        onClick={() => {
                          handleCheckboxChange(medicine)
                          // if (!currentMedicines.includes(medicine)) {
                          //     editCurrentPrescriptionMedication.current.openModal();
                          //     setEditCurrentMedicine(medicine);
                          //   }
                        }}
                        width={"100%"}
                      >
                        <Checkbox
                          isChecked={selectedMedicines.includes(medicine)}
                          onChange={() => {
                            handleCheckboxChange(medicine)
                            // if (!currentMedicines.includes(medicine)) {
                            //     editCurrentPrescriptionMedication.current.openModal();
                            //     setEditCurrentMedicine(medicine);
                            //   }
                          }}
                        ></Checkbox>
                        <Box width="45%">
                          <Box fontWeight={"semibold"} textAlign={"left"}>
                            {medicine.medicinename}{" "}
                            {medicine.dosage && (
                              <>
                                ({medicine.dosage} {medicine.dosageunit})
                              </>
                            )}{" "}
                            <Box
                              display="inline-block"
                              verticalAlign="bottom"
                              fontSize="10px"
                              fontWeight="600"
                              bg="#E6E7E966"
                              border="1px solid #E6E7E9"
                              p="5px 10px"
                              borderRadius="full"
                              w="fit-content"
                              whiteSpace="nowrap"
                              overflow="hidden"
                              textOverflow="ellipsis"
                            >
                              {medicine.medicinetype
                                ? medicine.medicinetype
                                : "-"}
                            </Box>
                          </Box>
                          <Box fontSize={"xs"} textAlign={"left"}>
                            Composition: {medicine.composition}
                          </Box>
                        </Box>
                        <Box width="15%" textAlign={"left"}>
                          {medicine.morning}-{medicine.afternoon}-{medicine.night}
                        </Box>
                        <Box width="32%" textAlign={"left"}>
                          {medicine.beforefood === 1 &&
                            medicine.afterfood === 1 && (
                              <>Before & After Food</>
                            )}
                          {medicine.beforefood === 1 &&
                            (medicine.afterfood === 0 ||
                              medicine.afterfood === null) && <>Before Food</>}
                          {(medicine.beforefood === 0 ||
                            medicine.beforefood === null) &&
                            medicine.afterfood === 1 && <>After Food</>}{" "}
                          {(medicine.beforefood === 1 ||
                            medicine.afterfood === 1) &&
                            medicine.frequency &&
                            "-"}
                          {medicine.frequency &&
                            `${medicine.frequency} x per day`}
                        </Box>
                      </Box>
                    </Box>
                  ))
                )}
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
        {/* Left area ends */}

        {/* Right section starts */}
        <Box width={{ base: "100%", lg: "50%" }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            height={"3rem"}
            borderBottom={"1px solid gray"}
          >
            {/* Right Header */}
            <Box
              fontSize="md"
              px={{ base: "0", md: "32px" }}
              fontWeight={"semibold"}
            >
              New Prescription
            </Box>
            <Button
              bg={"#fcfcfd"}
              color={"blue"}
              height={"2rem"}
              // onClick={() => setShowAddCard(true)}
              onClick={() => {
                setIsAddModalOpen(true)
                addPrescriptionMedication.current.openModal();
                setAddMedicineInstructions(""); // Clear instructions when opening modal
                setNewMedicine({
                  id: null,
                inventoryid: null,
                medicinename: "",
                manufacturer: "",
                drugclass: "",
                therapeutic: "",
                composition: "",
                medicinetype: "Tablet",
                dosage: "",
                dosageunit: "mg",
                medicationstartdate: today, // SETTING DEFAULTS
                medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
                frequency: 1, // SETTING DEFAULTS
                frequencytime: "",
                frequencyvalue: "",
                morning: 1, // SETTING DEFAULTS
                afternoon: 0,
                evening: 0,
                night: 0,
                prescribedby: "",
                hospitalname: "",
                beforefood: 0, // SETTING DEFAULTS
                afterfood: 1,
                // beforefood: 1, // SETTING DEFAULTS
                // afterfood: 0,
                issaved: false,

                // new inputs

                frequencyduration: null,
                routeofadministration: null,
                timingofinjection: null,
                quantitytobeapplied: null,
                areaofapplication: null,
                diluent: null,
                additives: null,

                rateofinfusionvalue: null,
                rateofinfusionunit: "ml/hr",
                // duration: null,
                duration: "5 Days", // Set default duration value
            durationunit: "Days", // Add this new field
            durationvalue: 5, // Add this new field

            custommessage:null,
            sos:null
                })
                setShowAddCard(true)
              }}
            >
              + Add medicine
            </Button>
          </Box>
          <Box
            px={{ base: "0", md: "2rem" }}
            height="calc(77vh - 2.5rem)"
            overflowY="auto"
            pt="1.5rem"
          >
            <Stack spacing={4}>
            
              {patientCurrentMedicinesForDoctor
                .filter((medicine) => medicine.isactive !== 0)
                .map((medicine) => (
                  <Box key={medicine.id}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      p="10px"
                      border="1px solid gray"
                      borderRadius="10px"
                    >
                      {screenType !== "mobile" && (
                        <>
                          <Box width="42%">
                            <Box fontWeight={"semibold"}>
                              {medicine.medicinename} (
                              {medicine.dosage ? (
                                <>
                                  {medicine.dosage} {medicine.dosageunit}
                                </>
                              ) : (
                                <>-/- {medicine.dosageunit}</>
                              )}
                              )
                              <Box
                                display="inline-block"
                                verticalAlign="bottom"
                                fontSize="10px"
                                fontWeight="600"
                                bg="#E6E7E966"
                                border="1px solid #E6E7E9"
                                p="5px 10px"
                                borderRadius="full"
                                w="fit-content"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                              >
                                {medicine.medicinetype
                                  ? medicine.medicinetype
                                  : "-"}
                              </Box>
                              <Box
                                display="inline-block"
                                verticalAlign="bottom"
                                fontSize="10px"
                                fontWeight="600"
                                // bg="#E6E7E966"
                                bg="#FF7373"
                                border="1px solid #E6E7E9"
                                p="5px 10px"
                                borderRadius="full"
                                w="fit-content"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                              >
                                Current
                              </Box>
                            </Box>
                            <Box fontSize={"xs"}>
                              Composition: {medicine.composition}
                            </Box>
                          </Box>
                          {medicine.frequencytime && medicine.frequencyvalue ? (
                             <Box width="10%">
                             {medicine.frequencytime} {medicine.frequencyvalue}
                           </Box>
                          ):(
                            <Box width="8%">
                            {medicine.morning}-{medicine.afternoon}-
                            {medicine.night}
                          </Box>
                          )}
                          <Box width="30%">
                            {medicine.beforefood === 1 &&
                              medicine.afterfood === 1 && (
                                <>Before & After Food</>
                              )}
                            {medicine.beforefood === 1 &&
                              (medicine.afterfood === 0 ||
                                medicine.afterfood === null) && (
                                <>Before Food</>
                              )}
                            {(medicine.beforefood === 0 ||
                              medicine.beforefood === null) &&
                              medicine.afterfood === 1 && <>After Food</>}{" "}
                            {(medicine.beforefood === 1 ||
                              medicine.afterfood === 1) &&
                              medicine.frequency &&
                              "- "}
                            {medicine.frequency &&
                              `${medicine.frequency} Qty`}
                          </Box>
                          <Box display="flex" alignItems="center" width="20%">
                                                    <Box
                          as="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="36px"
                          h="auto"
                          p="10px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          onClick={isChatbotAllowed() ? () => fetchAiDoctorPrompts(medicine.medicinename) : null}
                          cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                          opacity={isChatbotAllowed() ? 1 : 0.5}
                          bg={isChatbotAllowed() ? "transparent" : "gray.100"}
                          _hover={
                            isChatbotAllowed() 
                              ? { bg: "gray.50", borderColor: "gray.300" } 
                              : {}
                          }
                          title={
                            !isChatbotAllowed() 
                              ? "Please upgrade your subscription to use AI features" 
                              : "Get AI suggestions"
                          }
                        >
                          <Image 
                            w="26px" 
                            src="/assets/svgs/ai-star-outline.svg" 
                            opacity={isChatbotAllowed() ? 1 : 0.5}
                            filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
                          />
                        </Box>
                            <Box
                              as="button"
                              border="1px solid #E6E7E9"
                              borderRadius="full"
                              w="36px"
                              h="auto"
                              p="10px"
                              ml="10px"
                              onClick={() =>
                                handleEditCurrentMedicine(medicine)
                              }
                            >
                              <Image
                                w="13px"
                                src="/assets/svgs/edit-gray.svg"
                              />
                            </Box>
                            <Box
                              as="button"
                              border="1px solid #E6E7E9"
                              borderRadius="full"
                              w="36px"
                              h="auto"
                              p="10px"
                              ml="10px"
                              onClick={() =>
                                handleDeleteCurrentMedicine(medicine)
                              }
                            >
                              <Image w="13px" src="/assets/imgs/delete.png" />
                            </Box>
                          </Box>
                        </>
                      )}

                      {screenType == "mobile" && (
                        <>
                          <Box width="100%">
                            <Box fontWeight={"semibold"}>
                              {medicine.medicinename} ({medicine.dosage}
                              {medicine.dosageunit}){" "}
                              <Box
                                display="inline-block"
                                verticalAlign="bottom"
                                fontSize="10px"
                                fontWeight="600"
                                bg="#E6E7E966"
                                border="1px solid #E6E7E9"
                                p="5px 10px"
                                borderRadius="full"
                                w="fit-content"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                              >
                                {medicine.medicinetype
                                  ? medicine.medicinetype
                                  : "-"}
                              </Box>
                            </Box>
                            <Box fontSize={"xs"}>
                              Composition: {medicine.composition}
                            </Box>
                          </Box>
                          <Box
                            display="flex"
                            w="100%"
                            flexDir="column"
                            gap="10px"
                          >
                            {medicine.frequencytime && medicine.frequencyvalue ? (
                             <Box width="10%">
                             {medicine.frequencytime} {medicine.frequencyvalue}
                           </Box>
                          ):(
                            <Box width="8%">
                            {medicine.morning}-{medicine.afternoon}-
                            {medicine.night}
                          </Box>
                          )}
                            <Box width="100%">
                              {medicine.beforefood === 1 &&
                                medicine.afterfood === 1 && (
                                  <>Before & After Food</>
                                )}
                              {medicine.beforefood === 1 &&
                                (medicine.afterfood === 0 ||
                                  medicine.afterfood === null) && (
                                  <>Before Food</>
                                )}
                              {(medicine.beforefood === 0 ||
                                medicine.beforefood === null) &&
                                medicine.afterfood === 1 && (
                                  <>After Food</>
                                )}{" "}
                              {(medicine.beforefood === 1 ||
                                medicine.afterfood === 1) &&
                                medicine.frequency &&
                                " - "}
                              {medicine.frequency &&
                                `${medicine.frequency} Qty`}
                            </Box>
                            <Box
                              display="flex"
                              alignItems="center"
                              width="100%"
                            >
                                                      <Box
                          as="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="36px"
                          h="auto"
                          p="10px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          onClick={isChatbotAllowed() ? () => fetchAiDoctorPrompts(medicine.medicinename) : null}
                          cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                          opacity={isChatbotAllowed() ? 1 : 0.5}
                          bg={isChatbotAllowed() ? "transparent" : "gray.100"}
                          _hover={
                            isChatbotAllowed() 
                              ? { bg: "gray.50", borderColor: "gray.300" } 
                              : {}
                          }
                          title={
                            !isChatbotAllowed() 
                              ? "Please upgrade your subscription to use AI features" 
                              : "Get AI suggestions"
                          }
                        >
                          <Image 
                            w="26px" 
                            src="/assets/svgs/ai-star-outline.svg" 
                            opacity={isChatbotAllowed() ? 1 : 0.5}
                            filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
                          />
                        </Box>
                              <Box
                                as="button"
                                border="1px solid #E6E7E9"
                                borderRadius="full"
                                w="36px"
                                h="auto"
                                p="10px"
                                ml="10px"
                                onClick={() =>
                                  handleEditCurrentMedicine(medicine)
                                }
                              >
                                <Image
                                  w="13px"
                                  src="/assets/svgs/edit-gray.svg"
                                />
                              </Box>
                              <Box
                                as="button"
                                border="1px solid #E6E7E9"
                                borderRadius="full"
                                w="36px"
                                h="auto"
                                p="10px"
                                ml="10px"
                                onClick={() => handleDeleteMedicine(medicine)}
                              >
                                <Image w="13px" src="/assets/imgs/delete.png" />
                              </Box>
                            </Box>
                          </Box>
                        </>
                      )}
                    </Box>
                  </Box>
                ))}

              {selectedMedicines
                .filter((medicine) => medicine.isactive !== 0)
                .map((medicine) => (
                  <Box key={medicine.id}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      p="10px"
                      border="1px solid gray"
                      borderRadius="10px"
                    >
                      {screenType !== "mobile" && (
                        <>
                          <Box width="42%">
                            <Box fontWeight={"semibold"}>
                              {medicine.medicinename} (
                              {medicine.dosage ? (
                                <>
                                  {medicine.dosage} {medicine.dosageunit}
                                </>
                              ) : (
                                <>-/- {medicine.dosageunit}</>
                              )}
                              )
                              <Box
                                display="inline-block"
                                verticalAlign="bottom"
                                fontSize="10px"
                                fontWeight="600"
                                bg="#E6E7E966"
                                border="1px solid #E6E7E9"
                                p="5px 10px"
                                borderRadius="full"
                                w="fit-content"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                              >
                                {medicine.medicinetype
                                  ? medicine.medicinetype
                                  : "-"}
                              </Box>
                              <Box
                                display="inline-block"
                                verticalAlign="bottom"
                                fontSize="10px"
                                fontWeight="600"
                                // bg="#E6E7E966"
                                bg="#73FF99"
                                border="1px solid #E6E7E9"
                                p="5px 10px"
                                borderRadius="full"
                                w="fit-content"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                              >
                                Prescribed
                              </Box>
                            </Box>
                            <Box fontSize={"xs"}>
                              Composition: {medicine.composition}
                            </Box>
                          </Box>
                          {medicine.frequencytime && medicine.frequencyvalue ? (
                             <Box width="10%">
                             {medicine.frequencytime} {medicine.frequencyvalue}
                           </Box>
                          ):(
                            <Box width="8%">
                            {medicine.morning}-{medicine.afternoon}-
                            {medicine.night}
                          </Box>
                          )}
                         
                          <Box width="30%">
                            {medicine.beforefood === 1 &&
                              medicine.afterfood === 1 && (
                                <>Before & After Food</>
                              )}
                            {medicine.beforefood === 1 &&
                              (medicine.afterfood === 0 ||
                                medicine.afterfood === null) && (
                                <>Before Food</>
                              )}
                            {(medicine.beforefood === 0 ||
                              medicine.beforefood === null) &&
                              medicine.afterfood === 1 && <>After Food</>}{" "}
                            {(medicine.beforefood === 1 ||
                              medicine.afterfood === 1) &&
                              medicine.frequency &&
                              "- "}
                            {medicine.frequency &&
                              `${medicine.frequency} Qty`}
                          </Box>
                          <Box display="flex" alignItems="center" width="20%">
                                                    <Box
                          as="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="36px"
                          h="auto"
                          p="10px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          onClick={isChatbotAllowed() ? () => fetchAiDoctorPrompts(medicine.medicinename) : null}
                          cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                          opacity={isChatbotAllowed() ? 1 : 0.5}
                          bg={isChatbotAllowed() ? "transparent" : "gray.100"}
                          _hover={
                            isChatbotAllowed() 
                              ? { bg: "gray.50", borderColor: "gray.300" } 
                              : {}
                          }
                          title={
                            !isChatbotAllowed() 
                              ? "Please upgrade your subscription to use AI features" 
                              : "Get AI suggestions"
                          }
                        >
                          <Image 
                            w="26px" 
                            src="/assets/svgs/ai-star-outline.svg" 
                            opacity={isChatbotAllowed() ? 1 : 0.5}
                            filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
                          />
                        </Box>
                            <Box
                              as="button"
                              border="1px solid #E6E7E9"
                              borderRadius="full"
                              w="36px"
                              h="auto"
                              p="10px"
                              ml="10px"
                              onClick={() => handleEditMedicine(medicine)}
                            >
                              <Image
                                w="13px"
                                src="/assets/svgs/edit-gray.svg"
                              />
                            </Box>
                            <Box
                              as="button"
                              border="1px solid #E6E7E9"
                              borderRadius="full"
                              w="36px"
                              h="auto"
                              p="10px"
                              ml="10px"
                              onClick={() => handleDeleteMedicine(medicine)}
                            >
                              <Image w="13px" src="/assets/imgs/delete.png" />
                            </Box>
                          </Box>
                        </>
                      )}

                      {screenType == "mobile" && (
                        <>
                          <Box width="100%">
                            <Box fontWeight={"semibold"}>
                              {medicine.medicinename} ({medicine.dosage}
                              {medicine.dosageunit}){" "}
                              <Box
                                display="inline-block"
                                verticalAlign="bottom"
                                fontSize="10px"
                                fontWeight="600"
                                bg="#E6E7E966"
                                border="1px solid #E6E7E9"
                                p="5px 10px"
                                borderRadius="full"
                                w="fit-content"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                              >
                                {medicine.medicinetype
                                  ? medicine.medicinetype
                                  : "-"}
                              </Box>
                            </Box>
                            <Box fontSize={"xs"}>
                              Composition: {medicine.composition}
                            </Box>
                          </Box>
                          <Box
                            display="flex"
                            w="100%"
                            flexDir="column"
                            gap="10px"
                          >
                            <Box width="100%">
                              {medicine.morning}-{medicine.afternoon}-
                              {medicine.night}
                            </Box>
                            <Box width="100%">
                              {medicine.beforefood === 1 &&
                                medicine.afterfood === 1 && (
                                  <>Before & After Food</>
                                )}
                              {medicine.beforefood === 1 &&
                                (medicine.afterfood === 0 ||
                                  medicine.afterfood === null) && (
                                  <>Before Food</>
                                )}
                              {(medicine.beforefood === 0 ||
                                medicine.beforefood === null) &&
                                medicine.afterfood === 1 && (
                                  <>After Food</>
                                )}{" "}
                              {(medicine.beforefood === 1 ||
                                medicine.afterfood === 1) &&
                                medicine.frequency &&
                                "-"}
                              {medicine.frequency &&
                                `${medicine.frequency} x per day`}
                            </Box>
                            <Box
                              display="flex"
                              alignItems="center"
                              width="100%"
                            >
                                                      <Box
                          as="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="36px"
                          h="auto"
                          p="10px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          onClick={isChatbotAllowed() ? () => fetchAiDoctorPrompts(medicine.medicinename) : null}
                          cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                          opacity={isChatbotAllowed() ? 1 : 0.5}
                          bg={isChatbotAllowed() ? "transparent" : "gray.100"}
                          _hover={
                            isChatbotAllowed() 
                              ? { bg: "gray.50", borderColor: "gray.300" } 
                              : {}
                          }
                          title={
                            !isChatbotAllowed() 
                              ? "Please upgrade your subscription to use AI features" 
                              : "Get AI suggestions"
                          }
                        >
                          <Image 
                            w="26px" 
                            src="/assets/svgs/ai-star-outline.svg" 
                            opacity={isChatbotAllowed() ? 1 : 0.5}
                            filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
                          />
                        </Box>
                              <Box
                                as="button"
                                border="1px solid #E6E7E9"
                                borderRadius="full"
                                w="36px"
                                h="auto"
                                p="10px"
                                ml="10px"
                                onClick={() => handleEditMedicine(medicine)}
                              >
                                <Image
                                  w="13px"
                                  src="/assets/svgs/edit-gray.svg"
                                />
                              </Box>
                              <Box
                                as="button"
                                border="1px solid #E6E7E9"
                                borderRadius="full"
                                w="36px"
                                h="auto"
                                p="10px"
                                ml="10px"
                                onClick={() => handleDeleteMedicine(medicine)}
                              >
                                <Image w="13px" src="/assets/imgs/delete.png" />
                              </Box>
                            </Box>
                          </Box>
                        </>
                      )}
                    </Box>
                  </Box>
                ))}

            
            </Stack>
          </Box>
        </Box>
        {/* Right section ends */}

        <AiModal
          ref={AIChatModel}
          modalSize="420px"
          //icon="/assets/imgs/ai-doctor.png"
          header={
            <>
              <Box display="flex" flexDir="column">
                <Text
                  fontSize="1rem"
                  fontWeight="700"
                  backgroundImage="linear-gradient(to right top, #0d7e54, #007774, #006d94, #005ea7, #1146a0)"
                  color="transparent"
                  backgroundClip="text"
                >
                  Aira - AI
                </Text>
                <Text fontSize="0.75rem" fontWeight="400">
                  Chat with your AI health guide
                </Text>
              </Box>
            </>
          }
          headerStyle={{ p: "24px 32px", lineHeight: "normal" }}
          closeBtnStyle={{ top: "18px" }}
          footerStyle={{
            maxH: "35%",
            overflow: "hidden auto",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
          withoutBg={true}
          backDropBlur="10px"
          body={
            <>
              <Flex flexDirection="column" height="100%">
                <Box
                  p="24px 32px"
                  ref={chatContainerRef}
                  className="chat-container"
                  style={{
                    overflowY: "auto",
                    maxHeight: "calc(100vh - 160px)",
                  }}
                >
                  {initialRender && remainingquestions.length > 0 && (
                    <Box>
                      {remainingquestions.map((step, index) => (
                        <Box
                          key={index}
                          as="button"
                          w="100%"
                          p="16px"
                          mb="16px"
                          fontSize="14px"
                          fontWeight="600"
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                          justifyContent="space-between"
                          borderRadius="10px"
                          border="1px solid #7795DC"
                          bg="#EAEDF5"
                          color="#163E9E"
                          onClick={() => GetAIAnswer(step.value)}
                          className={`question-box ${
                            animate ? "slide-in" : ""
                          }`}
                        >
                          {step.value ? step.value : "-"}
                          <Image src="/assets/imgs/right-icon.png" />
                        </Box>
                      ))}
                    </Box>
                  )}
                  {aianswers.map((step, index) => (
                    <React.Fragment key={index}>
                      <Box
                        as="div"
                        bg="#061027"
                        p="12px 16px"
                        w="fit-content"
                        float="right"
                        borderRadius="10px 10px 1px 10px"
                        className={`answer-box ${animate ? "slide-in" : ""}`}
                      >
                        <Text fontSize="14px" fontWeight="500" color="white">
                          {step.question ? step.question : "-"}
                        </Text>
                      </Box>

                      <Box
                        as="div"
                        my="20px"
                        w="fit-content"
                        display="flex"
                        alignItems="end"
                        float="left"
                        className={`answer-box ${animate ? "slide-in" : ""}`}
                      >
                        <Image
                          bg="#061027"
                          p="4px"
                          mr="8px"
                          borderRadius="6px"
                          src="/assets/imgs/ai-chat-logo.png"
                        />
                        <Text
                          bg="#E6E7E980"
                          p="12px 16px"
                          fontSize="14px"
                          fontWeight="500"
                          color="#061027"
                          borderRadius="10px 10px 10px 1px"
                        >
                          {step.answer ? step.answer : <TypingLoader />}
                        </Text>
                      </Box>
                    </React.Fragment>
                  ))}
                </Box>
              </Flex>
            </>
          }
          footerActions={
            !initialRender && (
              <Box
                p="24px 32px"
                display="flex"
                w="100%"
                h="100%"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Box w="100%">
                  {remainingquestions.map((step, index) => (
                    <Box
                      key={index}
                      as="button"
                      w="100%"
                      p="16px"
                      mb="16px"
                      fontSize="14px"
                      fontWeight="600"
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="space-between"
                      borderRadius="10px"
                      border="1px solid #7795DC"
                      bg="#EAEDF5"
                      color="#163E9E"
                      onClick={() => GetAIAnswer(step.value)}
                      className={`question-box ${animate ? "slide-in" : ""}`}
                    >
                      {step.value ? step.value : "-"}
                      <Image src="/assets/imgs/right-icon.png" />
                    </Box>
                  ))}
                </Box>
              </Box>
            )
          }
        />

        {/* DynamicModal for Close Prescription */}
        <DynamicModal
          ref={drugInteractionAlertModal}
          modalHeader={`Aira - AI: Your AI Drug Interaction Alert`}
          modalBody={
            <>
              {drugInteractionAlerts.map((interaction, index) => (
                <Text key={index} fontSize="14px" fontWeight="600">
                  •{interaction.message}
                </Text>
              ))}
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                buttonText="Close"
                variant="grayBtn"
                btnStyle={{
                  w: "100%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                onClick={() => {
                  drugInteractionAlertModal.current.closeModal();
                }}
              />
            </>
          }
        />

        <DynamicModalForTwo
          ref={aiRecommendMedicineRef}
          modalWidth="45%"
          modalHeader={`Aira - AI: Alternatives`}
          modalBody={
            <>
              {recommendMedicinesAiResponse.map((medicine, index) => (
                <Box key={medicine.id}>
                  <Box
                    p="10px"
                    border="1px solid gray"
                    borderRadius="10px"
                    mt="10px"
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      // p="10px"
                      // border="1px solid gray"
                      // borderRadius="10px"
                      // mt="10px"
                    >
                      <Checkbox
                        isChecked={selectedRecommendedMedicinesAiResponses.includes(
                          index
                        )}
                        onChange={() =>
                          handleRecommendedMedicinesCheckboxChange(index)
                        }
                        mr={4}
                        alignSelf="center" // Vertically center the checkbox
                      ></Checkbox>
                      <Box width="100%">
                        <Box fontWeight={"semibold"}>
                          {medicine.name}
                          <Box
                            display="inline-block"
                            verticalAlign="bottom"
                            fontSize="10px"
                            fontWeight="600"
                            bg="#E6E7E966"
                            border="1px solid #E6E7E9"
                            p="5px 10px"
                            borderRadius="full"
                            w="fit-content"
                            whiteSpace="nowrap"
                            overflow="hidden"
                            textOverflow="ellipsis"
                          >
                            {medicine.medicinetype
                              ? medicine.medicinetype
                              : "Tablet"}
                            {/* Tablet */}
                          </Box>
                        </Box>
                        <Box fontSize={"xs"}>
                          Composition: {medicine.composition}
                        </Box>
                      </Box>
                      {/* <Box width="8%">
                        {medicine.morning}-{medicine.evening}-{medicine.night}
                      </Box> */}
                      {/* <Box width="35%">
                        {medicine.beforefood === 1 &&
                          medicine.afterfood === 1 && <>Before & After Food</>}
                        {medicine.beforefood === 1 &&
                          (medicine.afterfood === 0 ||
                            medicine.afterfood === null) && <>Before Food</>}
                        {(medicine.beforefood === 0 ||
                          medicine.beforefood === null) &&
                          medicine.afterfood === 1 && <>After Food</>}{" "}
                        {(medicine.beforefood === 1 ||
                          medicine.afterfood === 1) &&
                          medicine.frequency &&
                          "-"}
                        {medicine.frequency &&
                          `${medicine.frequency} x per day`}
                      </Box> */}

                      {/* <Box>
                        
                        <Box display="flex" justifyContent="space-between">
                          <Box
                            as="button"
                            border="1px solid #E6E7E9"
                            borderRadius="full"
                            w="36px"
                            h="auto"
                            p="10px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            onClick={() =>
                              fetchAiDoctorPrompts(medicine.medicinename)
                            }
                          >
                            <Image
                              w="26px"
                              src="/assets/svgs/ai-star-outline.svg"
                            />
                          </Box>
                          <Box
                            as="button"
                            border="1px solid #E6E7E9"
                            borderRadius="full"
                            w="36px"
                            h="auto"
                            p="10px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            onClick={() => handleEditMedicine(medicine)}
                          >
                            <Image w="13px" src="/assets/svgs/edit-gray.svg" />
                          </Box>
                        </Box>
                      </Box> */}
                    </Box>
                    {/* Reason Box */}
                    {/* <Box
                      as="p"
                      p="2px"
                      bg="#F9FAFB"
                      w="auto"
                      borderLeft="2px solid #14C585"
                      fontSize="0.875rem"
                      fontWeight="500"
                      mt="2px"
                      ml="3rem"
                    >
                      {medicine?.reason}{" "}
                    </Box> */}
                  </Box>

                  {/* {editMedicine && editMedicine.id === medicine.id && (
                    <Box
                      p="20px"
                      border="1px solid gray"
                      borderRadius="10px"
                      mt="10px" 
                    >
                      <Stack spacing={4}>
                        <InputGroup>
                          <PrimaryInput
                            type="text"
                            variant="bothSide"
                            inputPlace="Medicine name*"
                            defaultValue={editMedicine.medicinename}
                            onChange={(e) =>
                              handleEditMedicineChange(
                                "medicinename",
                                e.target.value
                              )
                            }
                          />
                          <PrimaryInput
                            key={compositionEditKey}
                            type="text"
                            variant="bothSide"
                            inputPlace="Medicine Composition"
                            defaultValue={editMedicine.composition}
                            onChange={(e) =>
                              handleEditMedicineChange(
                                "composition",
                                e.target.value
                              )
                            }
                          />{" "}
                          <PrimaryButton
                            buttonText="Fetch"
                            verticalAlign="bottom"
                            variant="grayBtn"
                            btnStyle={{
                              w: "15%",
                              color: COLORS.PRIMARY_COLOR,
                              verticalAlign: "bottom",
                              ml: "4px",
                              mb: "0px",
                              h: "2.8rem",
                            }}
                            onClick={() =>
                              fetchCompositionForEdit(editMedicine.medicinename)
                            }
                            isDisabled={false}
                          />
                        </InputGroup>
                        <RadioGroup
                          defaultValue={editMedicine.medicinetype}
                          onChange={(value) => {
                            handleEditMedicineChange("medicinetype", value);

                            if (value === "Syrup") {
                              handleEditMedicineChange("dosageunit", "ml");
                            } else if (value === "Tablet") {
                              handleEditMedicineChange("dosageunit", "mg");
                            }
                          }}
                        >
                          <Stack direction="row" gap="20px">
                            <Radio value="Tablet">Tablet</Radio>
                            <Radio value="Syrup">Syrup</Radio>
                          </Stack>
                        </RadioGroup>
                        <Divider />
                        <Box>
                          <Box display="flex" flexDir="row">
                            <MiniDropdownInput
                              variant="bothSide"
                              options={[
                                { label: "mg", value: "mg" },
                                { label: "ml", value: "ml" },
                              ]}
                              placeholderProp="Dosage"
                              defaultValue={editMedicine.dosage}
                              defaultOptionProp={editMedicine.dosageunit}
                              onSelect={(value) =>
                                handleEditMedicineChange(
                                  "dosageunit",
                                  value.label
                                )
                              }
                              handleInputChange={(event) =>
                                handleEditMedicineChange(
                                  "dosage",
                                  event.target.value
                                )
                              }
                              maxLength="6"
                            />
                            <DropdownInput
                              variant="bothSide"
                              dropDownPlace="Consumption frequency per day"
                              options={["1", "2", "3", "4"]}
                              onClick={(value) =>
                                handleEditMedicineChange("frequency", value)
                              }
                              defaultOption={editMedicine.frequency}
                            />
                          </Box>
                          <Box display="flex" flexDir="row">
                            <DatePicker
                              defaultDate={moment(
                                editMedicine.medicationstartdate,
                                ["YYYY-MM-DD", "DD-MM-YYYY"]
                              ).format("DD-MM-YYYY")}
                              minDate={editMedicine.medicationstartdate}
                              onDateChange={(selectedDateValue) =>
                                handleEditMedicineChange(
                                  "medicationstartdate",
                                  moment(selectedDateValue).format("YYYY-MM-DD")
                                )
                              }
                              placeholderProp={"Start Date"}
                              calendarStlye={{
                                left: "-18px",
                                right: "unset",
                              }}
                            />
                            <DatePicker
                              defaultDate={moment(
                                editMedicine.medicationenddate,
                                ["YYYY-MM-DD", "DD-MM-YYYY"]
                              ).format("DD-MM-YYYY")}
                              minDate={editMedicine.medicationstartdate}
                              onDateChange={(selectedDateValue) =>
                                handleEditMedicineChange(
                                  "medicationenddate",
                                  moment(selectedDateValue).format("YYYY-MM-DD")
                                )
                              }
                              placeholderProp={"End Date"}
                              calendarStlye={{
                                transform: "scale(0.9)",
                                right: "-22px",
                                top: "30px",
                              }}
                            />
                          </Box>

                          <CheckboxGroup colorScheme="green">
                            <Stack spacing={2} pt="20px" direction="row">
                              <Checkbox
                                isChecked={editMedicine.morning === 1}
                                onChange={() =>
                                  handleEditMedicineChange(
                                    "morning",
                                    editMedicine.morning === 1 ? 0 : 1
                                  )
                                }
                              >
                                Morning
                              </Checkbox>
                              <Checkbox
                                isChecked={editMedicine.evening === 1}
                                onChange={() =>
                                  handleEditMedicineChange(
                                    "evening",
                                    editMedicine.evening === 1 ? 0 : 1
                                  )
                                }
                              >
                                Evening
                              </Checkbox>
                              <Checkbox
                                isChecked={editMedicine.night === 1}
                                onChange={() =>
                                  handleEditMedicineChange(
                                    "night",
                                    editMedicine.night === 1 ? 0 : 1
                                  )
                                }
                              >
                                Night
                              </Checkbox>
                              <Spacer />{" "}
                              <Checkbox
                                isChecked={editMedicine.beforefood === 1}
                                onChange={() =>
                                  handleEditMedicineChange(
                                    "beforefood",
                                    editMedicine.beforefood === 1 ? 0 : 1
                                  )
                                }
                              >
                                Before Food
                              </Checkbox>
                              <Checkbox
                                isChecked={editMedicine.afterfood === 1}
                                onChange={() =>
                                  handleEditMedicineChange(
                                    "afterfood",
                                    editMedicine.afterfood === 1 ? 0 : 1
                                  )
                                }
                              >
                                After Food
                              </Checkbox>
                            </Stack>
                          </CheckboxGroup>
                        </Box>
                        <Divider />
                        <Box
                          display="flex"
                          justifyContent="flex-end"
                          gap="10px"
                        >
                          <PrimaryButton
                            buttonText="Cancel"
                            variant="grayBtn"
                            btnStyle={{
                              w: "15%",
                              color: COLORS.PRIMARY_COLOR,
                              h: "2.5rem",
                            }}
                            onClick={() => setEditMedicine(null)}
                            isDisabled={false}
                          />
                          <PrimaryButton
                            buttonText="Save"
                            onClick={handleSaveEditMedicine}
                            isDisabled={false}
                            btnStyle={{
                              w: "25%",
                              h: "2.5rem",
                            }}
                          />
                        </Box>
                      </Stack>
                    </Box>
                  )} */}
                </Box>
              ))}
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                variant="deleteBtn"
                buttonText="Discard"
                btnStyle={{
                  w: "48%",
                  h: "2.5rem",
                }}
                onClick={() => {
                  aiRecommendMedicineRef.current.closeModal();
                }}
              />

              <Spacer />

              <PrimaryButton
                buttonText="Save selected items"
                variant="grayBtn"
                btnStyle={{
                  w: "48%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                isDisabled={
                  !(selectedRecommendedMedicinesAiResponses.length > 0)
                }
                onClick={() => {
                  saveSelectedRecommendedMedicinesToOrder();
                  aiRecommendMedicineRef.current.closeModal();
                }}
              />
            </>
          }
        />

        <DynamicModal
                ref={addPrescriptionMedication}
                modalHeader="Add medication"
                // modalWidth="900px"
      // modalWidth={{base:'100%', md: 'calc(100vw - 40%)'}}
      modalWidth={{base:'100%', md: 'calc(100vw - 10%)'}}
                hasFooter= {false}
                modalBody={
                  <>
                  {showAddCard && (
                <Box
                  // p="20px"
                  // border="1px solid gray"
                  borderRadius="10px"
                  ml="0px"
                  // mb="10rem"
                >
                  <Stack spacing={4}>
                    {/* Row 1: MedicineName, Manufacturer, Composition,Fetch */}
                    <Flex
                      width="100%"
                      justifyContent="space-between"
                      alignItems="center"
                      flexDir={{ base: "column", md: "row" }}
                    >
                      <Box width={{ base: "100%", md: "45%" }}>
                        <Box w="100%" pos="relative" cursor="pointer">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace="Medicine name"
                            inputValue={newMedicine.medicinename}
                            onChange={(e) => {
                              handleNewMedicineChange(
                                "medicinename",
                                e.target.value
                              );
                              filterMedicineNames(e.target.value);
                              setShowMedicineNamesDropdown(1);
                              setBoolValForSuggestions(!boolValForSuggestions);
                            }}
                            inputIdProp={"MedicineNameInAdd" + 1}
                            boolProp={boolValForSuggestions}
                            onKeyDown={(e) => handleKeyDown(e, 1)}
                            autoFocus={showMedicineNamesDropdown === 1}
                            autocomplete="off"
                          />
                          <Image
                            top="33%"
                            right="6.5%"
                            w="15px"
                            pos="absolute"
                            src="/assets/imgs/double-arrow.png"
                          />
                        </Box>
                        {showMedicineNamesDropdown === 1 &&
                          suggestions.length > 0 && (
                            <Menu isOpen={true}>
                              <MenuButton
                                as={Box}
                                w="100%"
                                display="block"
                                pos="relative"
                                zIndex="999"
                              >
                                <Box
                                  pos="absolute"
                                  top="100%"
                                  left="0"
                                  w="100%"
                                  bg="white"
                                  borderTop="none"
                                  border="1px solid #E6E7E9"
                                  borderRadius="0 0 12px 12px"
                                />
                              </MenuButton>
                              <MenuList
                                w="100%"
                                borderRadius="0 0 12px 12px"
                                zIndex="999"
                                bg="white"
                                maxH="150px"
                                overflow="hidden auto"
                                ref={suggestionsMenuRef}
                              >
                                {suggestions.map((suggestion, sIndex) => (
                                  <MenuItem
                                    key={sIndex}
                                    onClick={() => handleSelect(suggestion, 1)}
                                    cursor="pointer"
                                    p="1rem"
                                    py="0.5rem"
                                    borderBottom="1px solid #E6E7E9"
                                    bg={
                                      focusedItemIndex === sIndex
                                        ? "#f0f0f0"
                                        : "white"
                                    }
                                  >
                                    <Text fontSize="0.875rem" fontWeight="500">
                                      {suggestion.productname +
                                        " (" +
                                        suggestion.remainingquantity +
                                        " Qty)"}
                                    </Text>
                                  </MenuItem>
                                ))}
                              </MenuList>
                            </Menu>
                          )}
                      </Box>
                      <Box width={{ base: "100%", md: "45%" }}>
                        <PrimaryInput
                          variant={"bothSide"}
                          inputPlace="Manufacturer"
                          inputValue={newMedicine.manufacturer || ""}
                          onChange={(e) =>
                            handleNewMedicineChange(
                              "manufacturer",
                              e.target.value
                            )
                          }
                        />
                      </Box>
                      <Box width={{ base: "100%", md: "45%" }}>
                        <PrimaryInput
                          key={key}
                          type="text"
                          variant={"bothSide"}
                          inputPlace="Medicine Composition"
                          inputValue={newMedicine.composition}
                          onChange={(e) =>
                            handleNewMedicineChange(
                              "composition",
                              e.target.value
                            )
                          }
                        />{" "}
                      </Box>
                      {/* <Box width={{ base: "100%", md: "10%" }}>
                        <PrimaryButton
                          buttonText="Fetch"
                          verticalAlign="bottom"
                          variant="grayBtn"
                          btnStyle={{
                            w: "100%",
                            color: COLORS.PRIMARY_COLOR,
                            verticalAlign: "bottom",
                            ml: { base: "0", md: "4px" },
                            mb: "0px",
                            h: "2.8rem",
                            opacity: isChatbotAllowed() ? 1 : 0.6,
                              cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                          }}
                          onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchComposition(newMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                          // onClick={() =>
                          //   fetchComposition(newMedicine.medicinename)
                          // }
                          // isDisabled={false}
                        />
                      </Box> */}
                      <Box
                                as="button"
                                type="button"
                                border="1px solid #E6E7E9"
                                // borderRadius="full"
                                width={{ base: "100%", md: "10%" }}
                                // w="40px"
                                // h="40px"
                                p="8px"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                                // opacity={medicineTextFieldValue ? 1 : 0.5}
                                // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                                onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchComposition(newMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                                bg="white"
                                // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                              >
                                <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                              </Box>
                    </Flex>

                    {/* Row 2: Medicine Type Selection */}
                    <RadioGroup
  value={additionalMedicineTypes.includes(newMedicine.medicinetype) ? "" : newMedicine.medicinetype}
  onChange={(value) => handleTypeChange(value)}
                    >
                      <Stack direction="row" alignItems='center' gap="20px" wrap="wrap">
                  <Radio colorScheme="green" value="Tablet">Tablet</Radio>
                                    <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                                    <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                                    <Radio colorScheme="green" value="Drops">Drops</Radio>
                                    <Radio colorScheme="green" value="Injection">Injection</Radio>
                                    <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                                    <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                                    <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                                    <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                                    <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                                    <Radio colorScheme="green" value="Cream">Cream</Radio>
                                    <Radio colorScheme="green" value="Gel">Gel</Radio>  
                      <Text>-Or-</Text>
                      <Box mx='1rem'>
                      <DropdownInput
    variant="bothSide"
    dropDownPlace="More Types"
    options={additionalMedicineTypes}
    onClick={(value) => handleTypeChange(value)}
    value={dropdownMedType}
    defaultOption={dropdownMedType || "Select more types"}
  />

                      </Box>
                      </Stack>
                    </RadioGroup>
                    <Divider my={2} />

                    <Box>
                    {/* Row 3: DrugClass, Therapeutic, Strength, Quantity */}
                      <Box
                        display="flex"
                        flexDir={{ base: "column", md: "row" }}
                      >
                        <PrimaryInput
                          variant={"bothSide"}
                          inputPlace="Drug Class"
                          inputValue={newMedicine.drugclass || ""}
                          onChange={(e) =>
                            handleNewMedicineChange(
                              "drugclass",
                              e.target.value
                            )
                          }
                        />
                        <PrimaryInput
                          variant={"bothSide"}
                          // onChange={handleTherapeuticCategory}
                          inputPlace="Therapeutic category"
                          inputValue={newMedicine.therapeutic || ""}
                          onChange={(e) =>
                            handleNewMedicineChange(
                              "therapeutic",
                              e.target.value
                            )
                          }
                        />

                        {newMedicine.medicinetype === "Tablet" || 
 newMedicine.medicinetype === "Capsule" || 
 newMedicine.medicinetype === "Suppository" || 
 newMedicine.medicinetype === "Powder" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "mcg", value: "mcg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Inhaler" || 
    newMedicine.medicinetype === "Spray" || 
    newMedicine.medicinetype === "Aerosol" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "puffs", value: "puffs" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Volume"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Syrup" ||
    newMedicine.medicinetype === "Drops" ||
    newMedicine.medicinetype === "Injection" ||
    newMedicine.medicinetype === "Nebulization" ||
    newMedicine.medicinetype === "IVFluids" ||
    newMedicine.medicinetype === "Suspension" ||
    newMedicine.medicinetype === "Respules" ||
    newMedicine.medicinetype === "Gargle" ||
    newMedicine.medicinetype === "Shampoo" ||
    newMedicine.medicinetype === "Topical Cleanser" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "ml", value: "ml" }]}
    placeholderProp="Volume"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Ointment" ||
    newMedicine.medicinetype === "Cream" ||
    newMedicine.medicinetype === "Gel" ||
    newMedicine.medicinetype === "Foam" ||
    newMedicine.medicinetype === "Lotion" ||
    newMedicine.medicinetype === "Tube" ||
    newMedicine.medicinetype === "Soap" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "grms", value: "grms" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Weight/Volume"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "EA" || 
    newMedicine.medicinetype === "Device" || 
    newMedicine.medicinetype === "Box" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "each", value: "each" }]}
    placeholderProp="Count"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Sachet" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : (
  // Default case for CUSTOM and any other types
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
      { label: "puffs", value: "puffs" },
      { label: "each", value: "each" },
    ]}
    placeholderProp={newMedicine.medicinetype === "Custom" ? "Custom Unit" : "Strength/Volume"}
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
)}

      {/* Consumption Quantity / Product Quantity dropdown
          - For Ointment/Cream/Gel: acts as Product Quantity (1–4) -> stored in productQuantity
          - For other solid/oral types: acts as Consumption Quantity (0.5–4) -> stored in frequency
          - Hidden for liquid/infusion/parenteral types where this doesn't apply */}
      {/* {(newMedicine.medicinetype !== "Syrup" && */}
        {(newMedicine.medicinetype !== "Drops" &&
        newMedicine.medicinetype !== "IVFluids" &&
        newMedicine.medicinetype !== "Injection" &&
        newMedicine.medicinetype !== "Nebulization" &&
        newMedicine.medicinetype !== "Inhaler") && (
        <DropdownInput
          variant="bothSide"
          dropDownPlace={
            newMedicine.medicinetype === "Syrup" ||
            newMedicine.medicinetype === "Cream" ||
            newMedicine.medicinetype === "Ointment" ||
            newMedicine.medicinetype === "Gel"
              ? "Product Quantity"
              : "Consumption Quantity"
          }
          options={
            newMedicine.medicinetype === "Syrup" ||
            newMedicine.medicinetype === "Cream" ||
            newMedicine.medicinetype === "Ointment" ||
            newMedicine.medicinetype === "Gel"
              ? ["1", "2", "3", "4"]
              : ["0.5", "1", "2", "3", "4"]
          }
          onClick={(value) => {
            if (
              newMedicine.medicinetype === "Syrup" ||
              newMedicine.medicinetype === "Cream" ||
              newMedicine.medicinetype === "Ointment" ||
              newMedicine.medicinetype === "Gel"
            ) {
              handleNewMedicineChange("productQuantity", value);
            } else {
              handleNewMedicineChange("frequency", value);
            }
          }}
          value={
            newMedicine.medicinetype === "Syrup" ||
            newMedicine.medicinetype === "Cream" ||
            newMedicine.medicinetype === "Ointment" ||
            newMedicine.medicinetype === "Gel"
              ? newMedicine.productQuantity || "1"
              : newMedicine.frequency
          }
        />
      )}
                        
                      </Box>

                    {/* Row 4: Duration, IntervalValue, StartDate, EndDate */}
                    {/* Hide these fields for Ointment/Cream/Gel */}
                    {(newMedicine.medicinetype !== "Ointment" &&
                      newMedicine.medicinetype !== "Cream" &&
                      newMedicine.medicinetype !== "Syrup" &&
                      newMedicine.medicinetype !== "Gel") && (
                      <Box display="flex" flexDir="row">
                        <Box width="25%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace={
                              newMedicine.medicinetype === "IVFluids"
                                ? "Infusion Frequency"
                                : newMedicine.medicinetype === "Ointment"
                                ? "Application Duration"
                                : "Duration"
                                // : "Interval Duration"
                            }
                            options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                            // onClick={handleIntervalNewChange} // Handle changes with setIntervalOption
                            // defaultOption={intervalNewOption}
                            onClick={handleIntervalNewChange}
                            value={newMedicine.durationunit} // Use from newMedicine state
                          />
                        </Box>
                        <Box width="25%">
                          <PrimaryInput
                            variant={"bothSide"}
                            inputType="number"
                            // defaultValue={intervalNewValue}
                            // onChange={handleIntervalNewValueChange}
                            inputValue={newMedicine.durationvalue} // Controlled input
                            // defaultOption={newMedicine.durationvalue}
                            onChange={handleIntervalNewValueChange}
                            inputPlace={
                              newMedicine.medicinetype === "IVFluids"
                                ? "Infusion Duration"
                                : "Interval Value"
                            }
                          />
                        </Box>
                        <Box width={"50%"} display="flex" flexDir="row">
                          <DatePicker
                            dateWidth="50%"
                            defaultDate={newMedicine.medicationstartdate}
                            minDate={newMedicine.medicationstartdate}
                            onDateChange={(selectedDateValue) =>
                              handleNewMedicineChange(
                                "medicationstartdate",
                                selectedDateValue
                              )
                            }
                            placeholderProp={"Start Date"}
                            calendarStlye={{
                              left: "-18px",
                              right: "unset",
                            }}
                          />
                          <DatePicker
                            dateWidth="50%"
                            key={newMedicine.medicationenddate}
                            defaultDate={newMedicine.medicationenddate}
                            disableDatePicker={true}
                            minDate={newMedicine.medicationstartdate}
                            onDateChange={(selectedDateValue) =>
                              handleNewMedicineChange(
                                "medicationenddate",
                                selectedDateValue
                              )
                            }
                            placeholderProp={"End Date"}
                            calendarStlye={{
                              transform: "scale(0.9)",
                              right: "-22px",
                              top: "30px",
                              pointerEvents: "none", // Disable interaction
                              opacity: 0.5, // Visually indicate disabled state
                            }}
                          />
                        </Box>
                      </Box>
                    )}

                    {/* Row 5: RouteAdministration, Timing / Quantity, AreaApplication / Diluent, RateInfusion / Additives */}
                      <Box display="flex" flexDir="row">
                        {newMedicine.medicinetype == "Injection" && (
                          <>
                            <Box width={"50%"}>
                              <DropdownInput
                                variant="downSide"
                                dropDownPlace="Route of Administration"
                                options={[
                                  "Intravenous (IV)",
                                  "Intramuscular (IM)",
                                  "Subcutaneous (SC)",
                                ]}
                                onClick={(value) =>
                                  handleNewMedicineChange(
                                    "routeofadministration",
                                    value
                                  )
                                }
                              />
                            </Box>
                            <Box width={"50%"}>
                              <PrimaryInput
                                variant={"bothSide"}
                                onChange={(e) =>
                                  handleNewMedicineChange(
                                    "timingofinjection",
                                    e.target.value
                                  )
                                }
                                inputPlace="Timing"
                              />
                            </Box>
                          </>
                        )}
                        {(newMedicine.medicinetype === "Ointment" || newMedicine.medicinetype === "Cream" || newMedicine.medicinetype === "Gel") && (
                          <>
                            <DropdownInput
                              variant="downSide"
                              dropDownPlace="Quantity"
                              options={[
                                "Pea-sized",
                                "Thin layer",
                                "Fingertip unit (FTU)",
                                "Half a fingertip",
                              ]}
                              onClick={(value) =>
                                handleNewMedicineChange(
                                  "quantitytobeapplied",
                                  value
                                )
                              }
                              value={newMedicine.quantitytobeapplied || ""}
                            />
                            <DropdownInput
                              variant="downSide"
                              dropDownPlace="Area of Application"
                              options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                              onClick={(value) =>
                                handleNewMedicineChange(
                                  "areaofapplication",
                                  value
                                )
                              }
                              value={newMedicine.areaofapplication || ""}
                            />
                          </>
                        )}

                        {newMedicine.medicinetype == "Nebulization" && (
                          <>
                            <DropdownInput
                              variant="downSide"
                              dropDownPlace="Diluent"
                              options={["Normal saline", "Distilled water","3% saline"]}
                              onClick={(value) =>
                                handleNewMedicineChange("diluent", value)
                              }
                            />
                          </>
                        )}

                        {newMedicine.medicinetype == "IVFluids" && (
                          <>
                            <MiniDropdownInput
                              variant="bothside"
                              options={[
                                { label: "ml/hr", value: "ml/hr" },
                                { label: "ml/min", value: "ml/min" },
                                // { label: "mg/hr", value: "mg/hr" },
                                // { label: "grms/hr", value: "grms/hr" },
                              ]}
                              handleInputChange={(e) =>
                                handleNewMedicineChange(
                                  "rateofinfusionvalue",
                                  validationOfNumberWithOnly1Decimal(
                                    e.target.value
                                  )
                                )
                              }
                              placeholderProp={"Rate of Infusion"}
                              onSelect={(selectedOption) =>
                                handleEditMedicineChange(
                                  "rateofinfusionunit",
                                  selectedOption.label
                                )
                              }
                              maxLength="6"
                            />
                            <PrimaryInput
                              variant={"bothSide"}
                              onChange={(e) =>
                                handleNewMedicineChange(
                                  "additives",
                                  e.target.value
                                )
                              }
                              inputPlace="Additives"
                            />
                          </>
                        )}
                      </Box>

                    {/* Row 6: MealTiming or Frequency / Before/AfterFood / ApplicationTiming, WhereToApply */}
                      <CheckboxGroup colorScheme="green">
  <Stack
    spacing={2}
    pt="20px"
    direction="row"
    alignItems='center'
    flexWrap={{ base: "wrap", md: "nowrap" }}
  >
    {/* COMMENTED OUT - Replaced with dropdown */}
    {/* <Checkbox
      isChecked={newMedicine.morning === 1}
      onChange={() => {
        // Uncheck frequency inputs when checking a time checkbox
        if (newMedicine.morning !== 1) {
          handleNewMedicineChange("frequencytime", "");
          handleNewMedicineChange("frequencyvalue", "");
        }
        handleNewMedicineChange(
          "morning",
          newMedicine.morning === 1 ? 0 : 1
        );
      }}
    >
      Morning
    </Checkbox>
    <Checkbox
      isChecked={newMedicine.afternoon === 1}
      onChange={() => {
        // Uncheck frequency inputs when checking a time checkbox
        if (newMedicine.afternoon !== 1) {
          handleNewMedicineChange("frequencytime", "");
          handleNewMedicineChange("frequencyvalue", "");
        }
        handleNewMedicineChange(
          "afternoon",
          newMedicine.afternoon === 1 ? 0 : 1
        );
      }}
    >
      Afternoon
    </Checkbox>
    <Checkbox
      isChecked={newMedicine.night === 1}
      onChange={() => {
        // Uncheck frequency inputs when checking a time checkbox
        if (newMedicine.night !== 1) {
          handleNewMedicineChange("frequencytime", "");
          handleNewMedicineChange("frequencyvalue", "");
        }
        handleNewMedicineChange(
          "night",
          newMedicine.night === 1 ? 0 : 1
        );
      }}
    >
      Night
    </Checkbox> */}

    {/* Dropdown for Meal Timing */}
    <Box width='180px'>
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Meal Timing"
        arrowCSS={{pr:0}}
        options={[
          "1-0-0",
          "0-1-0",
          "0-0-1",
          "1-1-0",
          "1-0-1",
          "0-1-1",
          "1-1-1",
          "0-0-0"
          // "1-0-0 (Morning)",
          // "0-1-0 (Afternoon)",
          // "0-0-1 (Night)",
          // "1-1-0 (Morning & Afternoon)",
          // "1-0-1 (Morning & Night)",
          // "0-1-1 (Afternoon & Night)",
          // "1-1-1 (All three)",
          // "0-0-0 (None)"
        ]}
        onClick={(value) => {
          if (value) {
            const { morning, afternoon, night } = parseMealTiming(value);
            handleNewMedicineChange("morning", morning);
            handleNewMedicineChange("afternoon", afternoon);
            handleNewMedicineChange("night", night);
            // Clear frequency inputs when selecting meal timing
            handleNewMedicineChange("frequencytime", "");
            handleNewMedicineChange("frequencyvalue", "");
          }
        }}
        value={getMealTimingLabel(newMedicine.morning, newMedicine.afternoon, newMedicine.night)}
      />
    </Box>

    <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>
    <Box display='flex'>
    <Box width='120px'>
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Frequency"
        arrowCSS={{pr:0}}
        options={["Hours", "Daily", "Weekly"]}
        onClick={(value) => {
          // Uncheck time checkboxes when selecting frequency
          if (value) {
            handleNewMedicineChange("morning", 0);
            handleNewMedicineChange("afternoon", 0);
            handleNewMedicineChange("night", 0);
          }
          handleNewMedicineChange("frequencytime", value || "");
        }}
        // defaultOption={"Hours"}
        value={newMedicine.frequencytime || ""}
      />
    </Box>

    <Box width='80px'>

      {/* <DropdownInputForVitals
                              variant="fullSide"
                              dropDownPlace="Referral Doctor"
                              options={referralUsersList}
                              onClick={handleUsersChange}
                              onChange={usersChange}
                              readOnly=""
                              inputStyleCss={{w: "100%"}}
                              inputValueProp={referralDoctor}
                              menuList={{ pos: "absolute", right: "-45px", minW: "300px" }}
                              // maxLength={2}
                            /> */}
      <DropdownInputForVitals
        variant="bothSide"
        dropDownPlace="Value"
        arrowCSS={{pr:0}}
        options={["1", "2", "3", "4", "8"]}
        readOnly=""
        maxLength={2}
        onClick={(value) => {
          // Uncheck time checkboxes when selecting value
          if (value) {
            handleNewMedicineChange("morning", 0);
            handleNewMedicineChange("afternoon", 0);
            handleNewMedicineChange("night", 0);
            handleNewMedicineChange("frequencyvalue", value);
          }
        }}
        onChange={(e) => {
          // Handle manual text input for value
          const value = e.target.value;
          console.log('e, ', e)
          if (value) {
            handleNewMedicineChange("morning", 0);
            handleNewMedicineChange("afternoon", 0);
            handleNewMedicineChange("night", 0);
          }
          handleNewMedicineChange("frequencyvalue", value);
        }}
        value={newMedicine.frequencyvalue}
        inputValueProp={newMedicine.frequencyvalue}
        
      />
    </Box>
    </Box>
    <Spacer />
    
    {/* OLD FOOD TIMING RADIOS - COMMENTED OUT FOR TOPICAL SUPPORT
    <RadioGroup
      value={newMedicine && newMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
      display='flex'
      justifyItems='start'
      flexWrap='wrap'
      gap='0.5rem'
      onChange={(value) => {
        if (value === "beforefood") {
          handleNewMedicineChange("beforefood", 1);
          handleNewMedicineChange("afterfood", 0);
        } else if (value === "afterfood") {
          handleNewMedicineChange("beforefood", 0);
          handleNewMedicineChange("afterfood", 1);
        }
      }}
    >
      <Radio value="beforefood" colorScheme="green">Before Food</Radio>
      <Radio value="afterfood" colorScheme="green">After Food</Radio>
    </RadioGroup>
    END OLD FOOD RADIOS */}

    {/* CONDITIONAL TIMING: TOPICAL VS FOOD */}
    {(newMedicine?.medicinetype === "Cream" || newMedicine?.medicinetype === "Ointment" || newMedicine?.medicinetype === "Gel") ? (
      <Box>
        {/* <Text fontSize="sm" mb={1}>Application Timing</Text> */}
        <DropdownInput
          variant="downSide"
          dropDownPlace="Application Timing"
          options={[
            "After Bath",
            "Before Bath",
            "After Sun",
            "Before Sun",
            "Time-based",
          ]}
          onClick={(value) => {
            handleNewMedicineChange("timing", value);
            handleNewMedicineChange("beforefood", 0);
            handleNewMedicineChange("afterfood", 0);
          }}
          value={newMedicine.timing || ""}
        />
      </Box>
    ) : (
      <RadioGroup
        value={newMedicine && newMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
        display='flex'
        justifyItems='start'
        flexWrap='wrap'
        gap='0.5rem'
        onChange={(value) => {
          if (value === "beforefood") {
            handleNewMedicineChange("beforefood", 1);
            handleNewMedicineChange("afterfood", 0);
            handleNewMedicineChange("timing", "Before Food");
          } else if (value === "afterfood") {
            handleNewMedicineChange("beforefood", 0);
            handleNewMedicineChange("afterfood", 1);
            handleNewMedicineChange("timing", "After Food");
          }
        }}
      >
        <Radio value="beforefood" colorScheme="green">Before Food</Radio>
        <Radio value="afterfood" colorScheme="green">After Food</Radio>
      </RadioGroup>
    )}
  </Stack>
</CheckboxGroup>
                      <Divider my="10px" />

                    {/* Row 7: Instructions Text area */}
<Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
  <Box
    as="form"
    width='100%'
    bg="white"
    pt={"2px"}
  >
    <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
      <Textarea
        borderRadius='0'
        // placeholder="Instructions"
        // {...register("textField")} 
        // value={addMedicineInstructions}
        // inputValue={newMedicine.custommessage}
        value={newMedicine.custommessage || ''}
        // onChange={(e) => handleNewMedicineChange("custommessage", e.target.value)}
        // onChange={(e) => {
        //   handleEditMedicineChange("custommessage", e.target.value);
        //   setValue("textField", e.target.value, {
        //     shouldDirty: true,
        //     shouldTouch: true,
        //     shouldValidate: true,
        //   });
        // }}
        onChange={(e) => {
    handleNewMedicineChange("custommessage", e.target.value);
    setValue("textField", e.target.value); // Keep form sync if needed
  }}
        height="100%"
        padding="2"
        resize="none"
        // disabled={typing} // Disable when AI typing is true
        style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
      />

      {/* <Input
                {...register("textField")}
                height="100%"
                padding="2"
                resize="none"
                as="textarea"
                disabled={typing} // Disable when AI typing is true
                style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
              /> */}
      
      {!newMedicine.custommessage && (
        <Text
          position="absolute"
          bottom="2"
          left="50%"
          transform="translateX(-50%)"
          fontSize="sm"
          color="gray.500"
          w={{ base: "100%", md: "unset" }}
          textAlign={{ base: "center", md: "unset" }}
        >
          {placeholder}
        </Text>
      )}
    </Box>
    
  </Box>

  {/* <GPUChatAudioManager
      transcriber={activeTranscriber}
      setPlaceholder={setPlaceholder}
      setTyping={setTyping}
      // onTranscribedText={handleTranscribedText}  // This is the key addition
       onTranscribedText={(text) => {
    handleNewMedicineChange("custommessage", text);
    setValue("textField", text);
  }}
    /> */}
            {/* <Box w='15%'>
    <DropdownWithMultiLingual 
              menuList={{pos:'relative', right:'75px'}}
              placeholder="English"
              onClick={handleChangeLanguage}
              options={languageOptions.map(value => ({ value }))}
              title="Input Language"
            />
            </Box>
  <GPUChatAudioManagerSpeechMode
      transcriber={activeTranscriber}
      setPlaceholder={setPlaceholder}
      setTyping={setTyping}
      mode={mode}
      // onTranscribedText={handleTranscribedText}  // This is the key addition
       onTranscribedText={(text) => {
    handleNewMedicineChange("custommessage", text);
    setValue("textField", text); 
  }}
  onRecordingStateChange={handleRecordingStateChange} 
    />
    {isRecording && (
              <AudioDisplayForClutter
                mx="auto"
                borderRadius="lg"
                stream={stream}
              />
            )}
            <Box w='15%'>
            <DropdownWithMultiLingual 
              menuList={{pos:'relative', right:'75px'}}
              placeholder="English"
              onClick={handleChangeOutputLanguage}
              options={languageOptions.map(value => ({ value }))}
              title="Output Language"
            />
            </Box>
    <Box
      as="button"
      type="button" // Prevent form submission
      border="1px solid #E6E7E9"
      borderRadius="full"
      w="36px"
      h="auto"
      p="10px"
      mr='10px'
      display="flex"
      justifyContent="center"
      alignItems="center"
      // cursor={newMedicine.custommessage ? "pointer" : "not-allowed"}
      // opacity={newMedicine.custommessage ? 1 : 0.5}
      // pointerEvents={newMedicine.custommessage ? "auto" : "none"}
      // onClick={() => newMedicine.custommessage && correctOrders()}
      cursor={textFieldValue ? "pointer" : "not-allowed"}
              opacity={textFieldValue ? 1 : 0.5}
              pointerEvents={textFieldValue ? "auto" : "none"}
              onClick={() => textFieldValue && correctOrders("add")}
    >
      <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
    </Box> */}
</Box>

                    {/* Row 8: Input/Output Language, AudioRecorder */}
{/* Audio & Language Controls Row - Highlighted Section */}
                    <Box
                      bg="#f8f9fa"
                      border="1px solid #e9ecef"
                      borderRadius="8px"
                      p="0.5rem"
                      mt="1rem"
                      // mb="1rem"
                    >
                      <Flex
                        alignItems="center"
                        justifyContent="space-around"
                        // justifyContent="space-between"
                        gap="1rem"
                        flexWrap={{ base: "wrap", md: "nowrap" }}
                      >
                        {/* Input Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleChangeLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Input Language"
                          />
                        </Box>
                        
                        {/* Audio Controls and Wave Display */}
                        <Box 
                    flex="1"
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    gap="0.75rem"
                    minH="50px"
                    px="1rem"
                  >
                    <GPUChatAudioManagerSpeechMode
                      transcriber={activeTranscriber}
                      mode={mode}
                      setPlaceholder={setPlaceholder}
                      setTyping={setTyping}
                      onTranscribedText={(text) => {
                        handleNewMedicineChange("custommessage", text);
                        setValue("textField", text); 
                      }}
                      onRecordingStateChange={handleRecordingStateChange} 
                    />
              
                    {isRecording && (
                      <Box flex="1" minW="180px" maxW="250px">
                        <AudioDisplayForClutter
                          borderRadius="lg"
                          stream={stream}
                          width="100%"
                        />
                      </Box>
                    )}
                  </Box>
              
                        {/* Output Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleChangeOutputLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Output Language"
                          />
                        </Box>
              
                        {/* AI Correction Button */}
                        <Box
                          as="button"
                          type="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="40px"
                          h="40px"
                          p="8px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          cursor={textFieldValue ? "pointer" : "not-allowed"}
                          opacity={textFieldValue ? 1 : 0.5}
                          pointerEvents={textFieldValue ? "auto" : "none"}
                          onClick={() => textFieldValue && correctOrders("add")}
                          flexShrink="0"
                          bg="white"
                          _hover={textFieldValue ? { bg: "#f0f0f0" } : {}}
                        >
                          <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                        </Box>
                      </Flex>
                    </Box>

<Divider my="10px" />
                    </Box>
                    {/* <Divider /> */}
                    {/* Save & cancel button */}
                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      w={{ base: "100%" }}
                      gap="10px"
                    >
                      {/* <Button onClick={() => setShowAddCard(false)}>
                        Cancel
                      </Button> */}
                      <PrimaryButton
                        buttonText="Cancel"
                        variant="grayBtn"
                        btnStyle={{
                          // w: { base: "50%", md: "15%" },
                          w: "50%",
                          color: COLORS.PRIMARY_COLOR,
                          h: "2.5rem",
                        }}
                        onClick={handleCancelAddMedicine}
                        isDisabled={false}
                      />
                      {/* <Button colorScheme="blue" onClick={handleAddMedicine}>
                        Add medicine
                      </Button> */}
                      <PrimaryButton
                        buttonText="Save to prescription"
                        onClick={handleAddMedicine}
                        isDisabled={false}
                        btnStyle={{
                          // w: { base: "50%", md: "25%" },
                          w: "50%",
                          //   color: COLORS.PRIMARY_COLOR,
                          h: "2.5rem",
                        }}
                      />
                    </Box>
                  </Stack>
                </Box>
              )}    
                  </>
                }
              />

        <DynamicModal
                ref={editSelectedPrescriptionMedication}
                modalHeader="Edit medication"
                // modalWidth="900px"
      // modalWidth={{base:'100%', md: 'calc(100vw - 40%)'}}
      modalWidth={{base:'100%', md: 'calc(100vw - 10%)'}}
                hasFooter= {false}
                modalBody={
                  <>
                  {selectedMedicines
                .filter((medicine) => medicine.isactive !== 0)
                .map((medicine) => (
                  <Box key={medicine.id}>
                    {/* {editMedicine && editMedicine.id === medicine.id && ( */}
                    {editMedicine && editMedicine.id === medicine.id && (
                      <Box
                        // p="20px"
                        // border="1px solid gray"
                        borderRadius="10px"
                        mt="10px" // Add some margin-top to separate from the above row
                      >
                        <Stack spacing={4}>
                    {/* Row 1: MedicineName, Manufacturer, Composition,Fetch */}
                          <Flex
                            width="100%"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Box width="45%">
                              <Box w="100%" pos="relative" cursor="pointer">
                                <PrimaryInput
                                  variant="bothSide"
                                  inputPlace="Medicine name"
                                  inputValue={editMedicine.medicinename}
                                  onChange={(e) => {
                                    handleEditMedicineChange(
                                      "medicinename",
                                      e.target.value
                                    );
                                    filterMedicineNames(e.target.value);
                                    setShowMedicineNamesDropdown(0);
                                    setBoolValForSuggestions(
                                      !boolValForSuggestions
                                    );
                                  }}
                                  inputIdProp={"MedicineNameInAdd" + 0}
                                  boolProp={boolValForSuggestions}
                                  onKeyDown={(e) => handleEditKeyDown(e, 0)}
                                  autoFocus={showMedicineNamesDropdown === 0}
                                  autocomplete="off"
                                />
                                <Image
                                  top="33%"
                                  right="6.5%"
                                  w="15px"
                                  pos="absolute"
                                  src="/assets/imgs/double-arrow.png"
                                />
                              </Box>
                              {showMedicineNamesDropdown === 0 &&
                                suggestions.length > 0 && (
                                  <Menu isOpen={true}>
                                    <MenuButton
                                      as={Box}
                                      w="100%"
                                      display="block"
                                      pos="relative"
                                      zIndex="999"
                                    >
                                      <Box
                                        pos="absolute"
                                        top="100%"
                                        left="0"
                                        w="100%"
                                        bg="white"
                                        borderTop="none"
                                        border="1px solid #E6E7E9"
                                        borderRadius="0 0 12px 12px"
                                      />
                                    </MenuButton>
                                    <MenuList
                                      w="100%"
                                      borderRadius="0 0 12px 12px"
                                      zIndex="999"
                                      bg="white"
                                      maxH="150px"
                                      overflow="hidden auto"
                                      ref={suggestionsMenuRef}
                                    >
                                      {suggestions.map((suggestion, sIndex) => (
                                        <MenuItem
                                          key={sIndex}
                                          onClick={() =>
                                            handleEditSelect(suggestion, 0)
                                          }
                                          cursor="pointer"
                                          p="1rem"
                                          py="0.5rem"
                                          borderBottom="1px solid #E6E7E9"
                                          bg={
                                            focusedItemIndex === sIndex
                                              ? "#f0f0f0"
                                              : "white"
                                          }
                                        >
                                          <Text
                                            fontSize="0.875rem"
                                            fontWeight="500"
                                          >
                                            {suggestion.productname +
                                              " (" +
                                              suggestion.remainingquantity +
                                              " Qty)"}
                                          </Text>
                                        </MenuItem>
                                      ))}
                                    </MenuList>
                                  </Menu>
                                )}
                            </Box>
                            <Box width={{ base: "100%", md: "45%" }}>
                        <PrimaryInput
                          key={key}
                          type="text"
                          variant={"bothSide"}
                          inputPlace="Manufacturer"
                          defaultValue={editMedicine.manufacturer || ""}
                          inputValue={editMedicine.manufacturer || ""}
                          onChange={(e) =>
                            handleEditMedicineChange(
                              "manufacturer",
                              e.target.value
                            )
                          }
                        />{" "}
                      </Box>
                            <Box width="45%">
                              <PrimaryInput
                                key={compositionEditKey}
                                type="text"
                                variant="bothSide"
                                inputPlace="Medicine Composition"
                                defaultValue={editMedicine.composition}
                                onChange={(e) =>
                                  handleEditMedicineChange(
                                    "composition",
                                    e.target.value
                                  )
                                }
                              />{" "}
                            </Box>
                            <Box
                                as="button"
                                type="button"
                                border="1px solid #E6E7E9"
                                // borderRadius="full"
                                width={{ base: "100%", md: "10%" }}
                                // w="40px"
                                // h="40px"
                                p="8px"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                                // opacity={medicineTextFieldValue ? 1 : 0.5}
                                // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                                onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchCompositionForEdit(editMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                                bg="white"
                                // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                              >
                                <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                              </Box>
                            {/* <Box width="10%">
                              <PrimaryButton
                                buttonText="Fetch"
                                verticalAlign="bottom"
                                variant="grayBtn"
                                btnStyle={{
                                  w: "100%",
                                  color: COLORS.PRIMARY_COLOR,
                                  verticalAlign: "bottom",
                                  ml: "4px",
                                  mb: "0px",
                                  h: "2.8rem",
                                  opacity: isChatbotAllowed() ? 1 : 0.6,
                              cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                                }}
                                onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchCompositionForEdit(editMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                                // onClick={() =>
                                //   fetchCompositionForEdit(
                                //     editMedicine.medicinename
                                //   )
                                // }
                                // isDisabled={false}
                              />
                            </Box> */}
                          </Flex>

                    {/* Row 2: Medicine Type Selection */}
                          <RadioGroup
  value={additionalMedicineTypes.includes(editMedicine.medicinetype) ? "" : editMedicine.medicinetype}
  onChange={(value) => handleEditTypeChange(value)}
                          >
                            <Stack direction="row" alignItems='center' gap="20px" wrap="wrap">
                  <Radio colorScheme="green" value="Tablet">Tablet</Radio>
                                    <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                                    <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                                    <Radio colorScheme="green" value="Drops">Drops</Radio>
                                    <Radio colorScheme="green" value="Injection">Injection</Radio>
                                    <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                                    <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                                    <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                                    <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                                    <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                                    <Radio colorScheme="green" value="Cream">Cream</Radio>
                                    <Radio colorScheme="green" value="Gel">Gel</Radio> 
                            <Text>-Or-</Text>
                            <Box mx='1rem'>
                            <DropdownInput
    variant="bothSide"
    dropDownPlace="More Types"
    options={additionalMedicineTypes}
    onClick={(value) => handleEditTypeChange(value)}
    value={dropdownMedType}
    defaultOption={dropdownMedType || "Select more types"}
  />
                            </Box>
                            </Stack>
                          </RadioGroup>
                          <Divider my={2} />
                    
                          <Box>
                    {/* Row 3: DrugClass, Therapeutic, Strength, Quantity */}
                            <Box display="flex" flexDir="row">
                              <PrimaryInput
                          variant={"bothSide"}
                          inputPlace="Drug Class"
                          defaultValue={editMedicine.drugclass || ""}
                          inputValue={editMedicine.drugclass || ""}
                          onChange={(e) =>
                            handleEditMedicineChange(
                              "drugclass",
                              e.target.value
                            )
                          }
                        />
                        <PrimaryInput
                          variant={"bothSide"}
                          inputPlace="Therapeutic category"
                          defaultValue={editMedicine.therapeutic || ""}
                          inputValue={editMedicine.therapeutic || ""}
                          onChange={(e) =>
                            handleEditMedicineChange(
                              "therapeutic",
                              e.target.value
                            )
                          }
                        />

                        {editMedicine.medicinetype === "Tablet" || 
 editMedicine.medicinetype === "Capsule" || 
 editMedicine.medicinetype === "Suppository" || 
 editMedicine.medicinetype === "Powder" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "mcg", value: "mcg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Inhaler" || 
    editMedicine.medicinetype === "Spray" || 
    editMedicine.medicinetype === "Aerosol" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "puffs", value: "puffs" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Volume"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Syrup" ||
    editMedicine.medicinetype === "Drops" ||
    editMedicine.medicinetype === "Injection" ||
    editMedicine.medicinetype === "Nebulization" ||
    editMedicine.medicinetype === "IVFluids" ||
    editMedicine.medicinetype === "Suspension" ||
    editMedicine.medicinetype === "Respules" ||
    editMedicine.medicinetype === "Gargle" ||
    editMedicine.medicinetype === "Shampoo" ||
    editMedicine.medicinetype === "Topical Cleanser" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "ml", value: "ml" }]}
    placeholderProp="Volume"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Ointment" ||
    editMedicine.medicinetype === "Cream" ||
    editMedicine.medicinetype === "Gel" ||
    editMedicine.medicinetype === "Foam" ||
    editMedicine.medicinetype === "Lotion" ||
    editMedicine.medicinetype === "Tube" ||
    editMedicine.medicinetype === "Soap" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "grms", value: "grms" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Weight/Volume"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "EA" || 
    editMedicine.medicinetype === "Device" || 
    editMedicine.medicinetype === "Box" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "each", value: "each" }]}
    placeholderProp="Count"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Sachet" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : (
  // Default case for CUSTOM and any other types
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
      { label: "puffs", value: "puffs" },
      { label: "each", value: "each" },
    ]}
    placeholderProp={editMedicine.medicinetype === "Custom" ? "Custom Unit" : "Strength/Volume"}
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
)}

{/* Consumption Quantity / Product Quantity dropdown in Edit modal
    - For Ointment/Cream/Gel: Product Quantity (1–4) -> productQuantity
    - For other solid/oral types: Consumption Quantity (0.5–4) -> frequency
    - Hidden for liquid/infusion/parenteral types */}
{/* {(editMedicine.medicinetype !== "Syrup" && */}
  {(editMedicine.medicinetype !== "Drops" &&
  editMedicine.medicinetype !== "IVFluids" &&
  editMedicine.medicinetype !== "Injection" &&
  editMedicine.medicinetype !== "Nebulization" &&
  editMedicine.medicinetype !== "Inhaler") && (
  <DropdownInput
    variant="bothSide"
    dropDownPlace={
      editMedicine.medicinetype === "Cream" ||
      editMedicine.medicinetype === "Syrup" ||
      editMedicine.medicinetype === "Ointment" ||
      editMedicine.medicinetype === "Gel"
        ? "Product Quantity"
        : "Consumption Quantity"
    }
    options={
      editMedicine.medicinetype === "Cream" ||
      editMedicine.medicinetype === "Syrup" ||
      editMedicine.medicinetype === "Ointment" ||
      editMedicine.medicinetype === "Gel"
        ? ["1", "2", "3", "4"]
        : ["0.5", "1", "2", "3", "4"]
    }
    onClick={(value) => {
      if (
        editMedicine.medicinetype === "Cream" ||
        editMedicine.medicinetype === "Syrup" ||
        editMedicine.medicinetype === "Ointment" ||
        editMedicine.medicinetype === "Gel"
      ) {
        handleEditMedicineChange("productQuantity", value);
      } else {
        handleEditMedicineChange("frequency", value);
      }
    }}
    value={
      editMedicine.medicinetype === "Cream" ||
      editMedicine.medicinetype === "Syrup" ||
      editMedicine.medicinetype === "Ointment" ||
      editMedicine.medicinetype === "Gel"
        ? editMedicine.productQuantity || "1"
        : editMedicine.frequency
    }
  />
)}
                            </Box>

                    {/* Row 4: Duration, IntervalValue, StartDate, EndDate */}
                    {/* Hide these fields for Ointment/Cream/Gel */}
                    {(editMedicine.medicinetype !== "Ointment" &&
                      editMedicine.medicinetype !== "Cream" &&
                      editMedicine.medicinetype !== "Syrup" &&
                      editMedicine.medicinetype !== "Gel") && (
                          <Box width='100%' display="flex" flexDir="row">
                              <Box width="25%">
                                <DropdownInput
                                  variant="bothSide"
                                  dropDownPlace={
                                    editMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Frequency"
                                      : editMedicine.medicinetype === "Ointment"
                                      ? "Application Duration"
                                      : "Duration"
                                  }
                                  options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                                  // onClick={handleIntervalChange} 
                                  // defaultOption={intervalOption}
                                  onClick={handleIntervalChange}
                                  value={editMedicine.durationunit}
                                />
                              </Box>
                              <Box width="25%">
                                <PrimaryInput
                                  variant={"bothSide"}
                                  inputType="number"
                                  // defaultValue={intervalValue}
                                  // onChange={handleIntervalValueChange}
                                  inputValue={editMedicine.durationvalue} // Controlled input
                                  onChange={handleIntervalValueChange}
                                  inputPlace={
                                    editMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Duration"
                                      : "Interval Value"
                                  }
                                />
                              </Box>
                              <Box width={"50%"}  display="flex" flexDir="row">
                                <DatePicker
                                  dateWidth="50%"
                                  defaultDate={editMedicine.medicationstartdate}
                                  minDate={newMedicine.medicationstartdate}
                                  onDateChange={(selectedDateValue) =>
                                    handleEditMedicineChange(
                                      "medicationstartdate",
                                      selectedDateValue
                                    )
                                  }
                                  placeholderProp={"Start Date"}
                                  calendarStlye={{
                                    left: "-18px",
                                    right: "unset",
                                  }}
                                />
                                <DatePicker
                                  dateWidth="50%"
                                  key={editMedicine.medicationenddate}
                                  defaultDate={editMedicine.medicationenddate}
                                  disableDatePicker={true}
                                  minDate={newMedicine.medicationstartdate}
                                  onDateChange={(selectedDateValue) =>
                                    handleEditMedicineChange(
                                      "medicationenddate",
                                      selectedDateValue
                                    )
                                  }
                                  placeholderProp={"End Date"}
                                  calendarStlye={{
                                    transform: "scale(0.9)",
                                    right: "-22px",
                                    top: "30px",
                                    pointerEvents: "none", // Disable interaction
                                    opacity: 0.5, // Visually indicate disabled state
                                  }}
                                />
                              </Box>
                            </Box>
                    )}

                    {/* Row 5: RouteAdministration, Timing / Quantity, AreaApplication / Diluent, RateInfusion / Additives */}
                            <Box display="flex" flexDir="row">
                              {editMedicine.medicinetype == "Injection" && (
                                <>
                                  <Box width={"50%"}>
                                    <DropdownInput
                                      variant="downSide"
                                      dropDownPlace="Route of Administration"
                                      options={[
                                        "Intravenous (IV)",
                                        "Intramuscular (IM)",
                                        "Subcutaneous (SC)",
                                      ]}
                                      onClick={(value) =>
                                        handleEditMedicineChange(
                                          "routeofadministration",
                                          value
                                        )
                                      }
                                      defaultOption={
                                        editMedicine.routeofadministration
                                      }
                                    />
                                  </Box>
                                  <Box width={"50%"}>
                                    <PrimaryInput
                                      variant={"bothSide"}
                                      onChange={(e) =>
                                        handleEditMedicineChange(
                                          "timingofinjection",
                                          e.target.value
                                        )
                                      }
                                      inputPlace="Timing"
                                      defaultValue={
                                        editMedicine.timingofinjection
                                      }
                                    />
                                  </Box>
                                </>
                              )}
                              {(editMedicine.medicinetype === "Ointment" || editMedicine.medicinetype === "Cream" || editMedicine.medicinetype === "Gel") && (
                                <>
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Quantity"
                                    options={[
                                      "Pea-sized",
                                      "Thin layer",
                                      "Fingertip unit (FTU)",
                                      "Half a fingertip",
                                    ]}
                                    onClick={(value) =>
                                      handleEditMedicineChange(
                                        "quantitytobeapplied",
                                        value
                                      )
                                    }
                                    defaultOption={editMedicine.quantitytobeapplied}
                                    value={editMedicine.quantitytobeapplied || ""}
                                  />
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Area of Application"
                                    options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                                    onClick={(value) =>
                                      handleEditMedicineChange(
                                        "areaofapplication",
                                        value
                                      )
                                    }
                                    defaultOption={editMedicine.areaofapplication}
                                    value={editMedicine.areaofapplication || ""}
                                  />
                                </>
                              )}

                              {editMedicine.medicinetype == "Nebulization" && (
                                <>
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Diluent"
                                    options={[
                                      "Normal saline",
                                      "Distilled water",
                                      "3% saline",
                                    ]}
                                    onClick={(value) =>
                                      handleEditMedicineChange("diluent", value)
                                    }
                                    defaultOption={editMedicine.diluent}
                                  />
                                </>
                              )}

                              {editMedicine.medicinetype == "IVFluids" && (
                                <>
                                  <MiniDropdownInput
                                    variant="bothside"
                                    options={[
                                      { label: "ml/hr", value: "ml/hr" },
                                      { label: "ml/min", value: "ml/min" },
                                      // { label: "mg/hr", value: "mg/hr" },
                                      // { label: "grms/hr", value: "grms/hr" },
                                    ]}
                                    handleInputChange={(e) =>
                                      handleEditMedicineChange(
                                        "rateofinfusionvalue",
                                        validationOfNumberWithOnly1Decimal(
                                          e.target.value
                                        )
                                      )
                                    }
                                    placeholderProp={"Rate of Infusion"}
                                    onSelect={(selectedOption) =>
                                      handleEditMedicineChange(
                                        "rateofinfusionunit",
                                        selectedOption.label
                                      )
                                    }
                                    maxLength="6"
                                    defaultOptionProp={
                                      editMedicine.rateofinfusionunit
                                    }
                                    defaultValue={
                                      editMedicine.rateofinfusionvalue
                                    }
                                  />
                                  <PrimaryInput
                                    variant={"bothSide"}
                                    onChange={(e) =>
                                      handleEditMedicineChange(
                                        "additives",
                                        e.target.value
                                      )
                                    }
                                    inputPlace="Additives"
                                    defaultValue={editMedicine.additives}
                                  />
                                </>
                              )}
                            </Box>

                    {/* Row 6: MealTiming or Frequency / Before/AfterFood / ApplicationTiming, WhereToApply */} 
                            <CheckboxGroup colorScheme="green">
                              <Stack spacing={2} alignItems='center' pt="20px" direction="row" flexWrap="wrap">
                                {/* COMMENTED OUT - Replaced with dropdown */}
                                {/* Time checkboxes */}
                                {/* <Checkbox
                                  isChecked={editMedicine.morning === 1}
                                  onChange={() => {
                                    // Uncheck frequency inputs when checking a time checkbox
                                    if (editMedicine.morning !== 1) {
                                      handleEditMedicineChange("frequencytime", "");
                                      handleEditMedicineChange("frequencyvalue", "");
                                    }
                                    handleEditMedicineChange(
                                      "morning",
                                      editMedicine.morning === 1 ? 0 : 1
                                    );
                                  }}
                                >
                                  Morning
                                </Checkbox>
                                
                                <Checkbox
                                  isChecked={editMedicine.afternoon === 1}
                                  onChange={() => {
                                    // Uncheck frequency inputs when checking a time checkbox
                                    if (editMedicine.afternoon !== 1) {
                                      handleEditMedicineChange("frequencytime", "");
                                      handleEditMedicineChange("frequencyvalue", "");
                                    }
                                    handleEditMedicineChange(
                                      "afternoon",
                                      editMedicine.afternoon === 1 ? 0 : 1
                                    );
                                  }}
                                >
                                  Afternoon
                                </Checkbox>
                                
                                <Checkbox
                                  isChecked={editMedicine.night === 1}
                                  onChange={() => {
                                    // Uncheck frequency inputs when checking a time checkbox
                                    if (editMedicine.night !== 1) {
                                      handleEditMedicineChange("frequencytime", "");
                                      handleEditMedicineChange("frequencyvalue", "");
                                    }
                                    handleEditMedicineChange(
                                      "night",
                                      editMedicine.night === 1 ? 0 : 1
                                    );
                                  }}
                                >
                                  Night
                                </Checkbox> */}

                                {/* Dropdown for Meal Timing */}
                                <Box width='180px'>
                                  <DropdownInput
                                    variant="bothSide"
                                    dropDownPlace="Meal Timing"
                                    arrowCSS={{pr:0}}
                                    options={[
                                      "1-0-0",
                                      "0-1-0",
                                      "0-0-1",
                                      "1-1-0",
                                      "1-0-1",
                                      "0-1-1",
                                      "1-1-1",
                                      "0-0-0"
                                      // "1-0-0 (Morning)",
                                      // "0-1-0 (Afternoon)",
                                      // "0-0-1 (Night)",
                                      // "1-1-0 (Morning & Afternoon)",
                                      // "1-0-1 (Morning & Night)",
                                      // "0-1-1 (Afternoon & Night)",
                                      // "1-1-1 (All three)",
                                      // "0-0-0 (None)"
                                    ]}
                                    onClick={(value) => {
                                      if (value) {
                                        const { morning, afternoon, night } = parseMealTiming(value);
                                        handleEditMedicineChange("morning", morning);
                                        handleEditMedicineChange("afternoon", afternoon);
                                        handleEditMedicineChange("night", night);
                                        // Clear frequency inputs when selecting meal timing
                                        handleEditMedicineChange("frequencytime", "");
                                        handleEditMedicineChange("frequencyvalue", "");
                                      }
                                    }}
                                    value={editMedicine && getMealTimingLabel(editMedicine.morning, editMedicine.afternoon, editMedicine.night)}
                                  />
                                </Box>

                                <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>

                                {/* Frequency inputs */}
                                <Box display='flex'>
                                <Box width='120px'>
                                  <DropdownInput
                                    variant="bothSide"
                                    dropDownPlace="Frequency"
                                    arrowCSS={{pr:0}}
                                    options={["Hours", "Daily", "Weekly"]}
                                    onClick={(value) => {
                                      // Uncheck time checkboxes when selecting frequency
                                      if (value) {
                                        handleEditMedicineChange("morning", 0);
                                        handleEditMedicineChange("afternoon", 0);
                                        handleEditMedicineChange("night", 0);
                                      }
                                      handleEditMedicineChange("frequencytime", value || 0);
                                    }}
                                    // defaultOption={"Hours"}
                                    value={editMedicine.frequencytime}
                                  />
                                </Box>

                                <Box width='70px'>
                                  <DropdownInputForVitals
                                    variant="bothSide"
                                    dropDownPlace="Value"
                                    arrowCSS={{pr:0}}
                                    readOnly=""
                                    options={["1", "2", "3", "4", "8"]}
                                    onClick={(value) => {
                                      // Uncheck time checkboxes when selecting value
                                      if (value) {
                                        handleEditMedicineChange("morning", 0);
                                        handleEditMedicineChange("afternoon", 0);
                                        handleEditMedicineChange("night", 0);
                                        handleEditMedicineChange("frequencyvalue", value);
                                      }
                                    }}
                                    onChange={(e) => {
                                      // Handle manual text input for value
                                      const value = e.target.value;
                                      if (value) {
                                        handleEditMedicineChange("morning", 0);
                                        handleEditMedicineChange("afternoon", 0);
                                        handleEditMedicineChange("night", 0);
                                      }
                                      handleEditMedicineChange("frequencyvalue", value);
                                    }}
                                    value={editMedicine.frequencyvalue}
                                    inputValueProp={editMedicine.frequencyvalue || ""}
                                    maxLength={2}
                                  />
                                  {/* <DropdownInput
                                    variant="bothSide"
                                    dropDownPlace="Value"
                                    options={["1", "2", "3", "4", "8"]}
                                    onClick={(value) => {
                                      // Uncheck time checkboxes when selecting value
                                      if (value) {
                                        handleEditMedicineChange("morning", 0);
                                        handleEditMedicineChange("afternoon", 0);
                                        handleEditMedicineChange("night", 0);
                                      }
                                      handleEditMedicineChange("frequencyvalue", value || "");
                                    }}
                                    onChange={(e) => {
                                      // Handle manual text input for value
                                      const value = e.target.value;
                                      if (value) {
                                        handleEditMedicineChange("morning", 0);
                                        handleEditMedicineChange("afternoon", 0);
                                        handleEditMedicineChange("night", 0);
                                      }
                                      handleEditMedicineChange("frequencyvalue", value || "");
                                    }}
                                    value={editMedicine.frequencyvalue}
                                  /> */}
                                </Box>
                                </Box>
                                {/* OLD FOOD TIMING RADIO BUTTONS - COMMENTED OUT FOR TOPICAL SUPPORT */}
                                {/* <Spacer/>
                                <RadioGroup
                                  value={editMedicine && editMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
                                  display='flex'
                                  justifyItems='start'
                                  flexWrap='wrap'
                                  gap='0.5rem'
                                  onChange={(value) => {
                                    if (value === "beforefood") {
                                      handleEditMedicineChange("beforefood", 1);
                                      handleEditMedicineChange("afterfood", 0);
                                    } else if (value === "afterfood") {
                                      handleEditMedicineChange("beforefood", 0);
                                      handleEditMedicineChange("afterfood", 1);
                                    }
                                  }}
                                >
                                  <Radio value="beforefood" colorScheme="green">Before Food</Radio>
                                  <Radio value="afterfood" colorScheme="green">After Food</Radio>
                                </RadioGroup>
                                END OLD FOOD RADIOS */}

                                {/* CONDITIONAL TIMING: TOPICAL VS FOOD */}
                                <Spacer/>
                                {(editMedicine?.medicinetype === "Cream" || editMedicine?.medicinetype === "Ointment" || editMedicine?.medicinetype === "Gel") ? (
                                  <Box>
                                    {/* <Text fontSize="sm" mb={1}>Application Timing</Text> */}
                                    <DropdownInput
                                      variant="downSide"
                                      dropDownPlace="Application Timing"
                                      options={[
                                        "After Bath",
                                        "Before Bath",
                                        "After Sun",
                                        "Before Sun",
                                        "Time-based",
                                      ]}
                                      onClick={(value) => {
                                        handleEditMedicineChange("timing", value);
                                        handleEditMedicineChange("beforefood", 0);
                                        handleEditMedicineChange("afterfood", 0);
                                      }}
                                      value={editMedicine.timing || ""}
                                    />
                                  </Box>
                                ) : (
                                  <RadioGroup
                                    value={editMedicine && editMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
                                    display='flex'
                                    justifyItems='start'
                                    flexWrap='wrap'
                                    gap='0.5rem'
                                    onChange={(value) => {
                                      if (value === "beforefood") {
                                        handleEditMedicineChange("beforefood", 1);
                                        handleEditMedicineChange("afterfood", 0);
                                        handleEditMedicineChange("timing", "Before Food");
                                      } else if (value === "afterfood") {
                                        handleEditMedicineChange("beforefood", 0);
                                        handleEditMedicineChange("afterfood", 1);
                                        handleEditMedicineChange("timing", "After Food");
                                      }
                                    }}
                                  >
                                    <Radio value="beforefood" colorScheme="green">Before Food</Radio>
                                    <Radio value="afterfood" colorScheme="green">After Food</Radio>
                                  </RadioGroup>
                                )}
                              </Stack>
                            </CheckboxGroup>

                            <Divider my="10px" />

                    {/* Row 7: Instructions Text area */}
                            <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
  <Box
    as="form"
    width='100%'
    bg="white"
    pt={"2px"}
  >
    <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
      <Textarea
        borderRadius='0'
        // {...register("textField")}
        // defaultValue={editMedicine.custommessage}
        // inputValue={editMedicine.custommessage}
        value={editMedicine.custommessage}
        onChange={(e) => {
          handleEditMedicineChange("custommessage", e.target.value);
          // Also update the form field
          setValue("textField", e.target.value, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          });
        }}
        height="100%"
        padding="2"
        resize="none"
        style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
      />
      
      {!editMedicine.custommessage && (
        <Text
          position="absolute"
          bottom="2"
          left="50%"
          transform="translateX(-50%)"
          fontSize="sm"
          color="gray.500"
          w={{ base: "100%", md: "unset" }}
          textAlign={{ base: "center", md: "unset" }}
        >
          {placeholder}
        </Text>
      )}
    </Box>
    
  </Box>

  {/* <GPUChatAudioManager
      transcriber={activeTranscriber}
      setPlaceholder={setPlaceholder}
      setTyping={setTyping}
      // onTranscribedText={handleTranscribedText}
    /> */}
    {/* <Box w='15%'>
    <DropdownWithMultiLingual 
              menuList={{pos:'relative', right:'75px'}}
              placeholder="English"
              onClick={handleChangeLanguage}
              options={languageOptions.map(value => ({ value }))}
              title="Input Language"
            />
            </Box>
    <GPUChatAudioManagerSpeechMode
      transcriber={activeTranscriber}
      mode={mode}
      setPlaceholder={setPlaceholder}
      setTyping={setTyping}
        onRecordingStateChange={handleRecordingStateChange} 
    />
    {isRecording && (
              <AudioDisplayForClutter
                mx="auto"
                borderRadius="lg"
                stream={stream}
              />
            )}
            <Box w='15%'>
            <DropdownWithMultiLingual 
              menuList={{pos:'relative', right:'75px'}}
              placeholder="English"
              onClick={handleChangeOutputLanguage}
              options={languageOptions.map(value => ({ value }))}
              title="Output Language"
            />
            </Box>

    <Box
      as="button"
      type="button"
      border="1px solid #E6E7E9"
      borderRadius="full"
      w="36px"
      h="auto"
      p="10px"
      mr='10px'
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor={textFieldValue ? "pointer" : "not-allowed"}
      opacity={textFieldValue ? 1 : 0.5}
      pointerEvents={textFieldValue ? "auto" : "none"}
      onClick={() => textFieldValue && correctOrders("edit")}
    >
      <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
    </Box> */}
</Box>

                    {/* Row 8: Input/Output Language, AudioRecorder */}
{/* Audio & Language Controls Row - Highlighted Section */}
                    <Box
                      bg="#f8f9fa"
                      border="1px solid #e9ecef"
                      borderRadius="8px"
                      p="0.5rem"
                      mt="1rem"
                      // mb="1rem"
                    >
                      <Flex
                        alignItems="center"
                        justifyContent="space-around"
                        // justifyContent="space-between"
                        gap="1rem"
                        flexWrap={{ base: "wrap", md: "nowrap" }}
                      >
                        {/* Input Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleChangeLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Input Language"
                          />
                        </Box>
                        
                        {/* Audio Controls and Wave Display */}
                        <Box 
                    flex="1"
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    gap="0.75rem"
                    minH="50px"
                    px="1rem"
                  >
                    <GPUChatAudioManagerSpeechMode
                      transcriber={activeTranscriber}
                      mode={mode}
                      setPlaceholder={setPlaceholder}
                      setTyping={setTyping}
                      // onTranscribedText={(text) => {
                      //   handleNewMedicineChange("custommessage", text);
                      //   setValue("textField", text); 
                      // }}
                      onRecordingStateChange={handleRecordingStateChange} 
                    />
              
                    {isRecording && (
                      <Box flex="1" minW="180px" maxW="250px">
                        <AudioDisplayForClutter
                          borderRadius="lg"
                          stream={stream}
                          width="100%"
                        />
                      </Box>
                    )}
                  </Box>
              
                        {/* Output Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleChangeOutputLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Output Language"
                          />
                        </Box>
              
                        {/* AI Correction Button */}
                        <Box
                          as="button"
                          type="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="40px"
                          h="40px"
                          p="8px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          cursor={textFieldValue ? "pointer" : "not-allowed"}
                          opacity={textFieldValue ? 1 : 0.5}
                          pointerEvents={textFieldValue ? "auto" : "none"}
                          onClick={() => textFieldValue && correctOrders("edit")}
                          flexShrink="0"
                          bg="white"
                          _hover={textFieldValue ? { bg: "#f0f0f0" } : {}}
                        >
                          <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                        </Box>
                      </Flex>
                    </Box>


                            <Divider my="10px" />
                          </Box>
                          {/* <Divider /> */}
                          <Box
                            display="flex"
                            justifyContent="flex-end"
                            gap="10px"
                          >
                            {/* <Button onClick={() => setEditMedicine(null)}>
                            Cancel
                          </Button> */}
                            <PrimaryButton
                              buttonText="Cancel"
                              variant="grayBtn"
                              btnStyle={{
                                // w: "15%",
                          w: "50%",
                                color: COLORS.PRIMARY_COLOR,
                                h: "2.5rem",
                              }}
                              // onClick={() => setEditMedicine(null)}
                              onClick={() => {
                                setEditMedicine(null)
                                editSelectedPrescriptionMedication.current.closeModal();
                                setIsSelectedEditModalOpen(false)
                              }}
                              isDisabled={false}
                            />
                            {/* <Button
                            colorScheme="blue"
                            onClick={handleSaveEditMedicine}
                          >
                            Save
                          </Button> */}
                            <PrimaryButton
                              buttonText="Save"
                              onClick={handleSaveEditMedicine}
                              isDisabled={false}
                              btnStyle={{
                                // w: "25%",
                          w: "50%",
                                //   color: COLORS.PRIMARY_COLOR,
                                h: "2.5rem",
                              }}
                            />
                          </Box>
                        </Stack>
                      </Box>
                    )}
                  </Box>
                ))}   
                  </>
                }
              />


        <DynamicModal
                ref={editCurrentPrescriptionMedication}
                modalHeader="Edit medication"
                // modalWidth="900px"
                // modalWidth={{base:'100%', md: 'calc(100vw - 40%)'}}
      modalWidth={{base:'100%', md: 'calc(100vw - 10%)'}}
                hasFooter= {false}
                modalBody={
                  <>
                  {patientCurrentMedicinesForDoctor
                .filter((medicine) => medicine.isactive !== 0)
                .map((medicine) => (
                  <Box key={medicine.id}>
                    {editCurrentMedicine &&
                      editCurrentMedicine.id === medicine.id && (
                        <Box
                          // p="20px"
                          // border="1px solid gray"
                          borderRadius="10px"
                          mt="10px" // Add some margin-top to separate from the above row
                        >
                          <Stack spacing={4}>
                    {/* Row 1: MedicineName, Manufacturer, Composition,Fetch */}
                            <Flex
                              width="100%"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Box width="45%">
                                <Box w="100%" pos="relative" cursor="pointer">
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="Medicine name"
                                    inputValue={
                                      editCurrentMedicine.medicinename
                                    }
                                    onChange={(e) => {
                                      handleEditCurrentMedicineChange(
                                        "medicinename",
                                        e.target.value
                                      );
                                      // filterMedicineNames(e.target.value);
                                      // setShowMedicineNamesDropdown(0);
                                      // setBoolValForSuggestions(
                                      //   !boolValForSuggestions
                                      // );
                                    }}
                                    // inputIdProp={"MedicineNameInAdd" + 0}
                                    // boolProp={boolValForSuggestions}
                                    // onKeyDown={(e) => handleEditKeyDown(e, 0)}
                                    // autoFocus={showMedicineNamesDropdown === 0}
                                    // autocomplete="off"
                                  />
                                  <Image
                                    top="33%"
                                    right="6.5%"
                                    w="15px"
                                    pos="absolute"
                                    src="/assets/imgs/double-arrow.png"
                                  />
                                </Box>
                              </Box>
                              <Box width={{ base: "100%", md: "45%" }}>
                        <PrimaryInput
                          key={key}
                          type="text"
                          variant={"bothSide"}
                          inputPlace="Manufacturer"
                          defaultValue={editCurrentMedicine.manufacturer || ""}
                          inputValue={editCurrentMedicine.manufacturer || ""}
                          onChange={(e) =>
                            handleEditCurrentMedicineChange(
                              "manufacturer",
                              e.target.value
                            )
                          }
                        />{" "}
                      </Box>
                              <Box width="45%">
                                <PrimaryInput
                                  key={compositionEditKey}
                                  type="text"
                                  variant="bothSide"
                                  inputPlace="Medicine Composition"
                                  defaultValue={editCurrentMedicine.composition}
                                  onChange={(e) =>
                                    handleEditCurrentMedicineChange(
                                      "composition",
                                      e.target.value
                                    )
                                  }
                                />{" "}
                              </Box>
                              <Box
                                as="button"
                                type="button"
                                border="1px solid #E6E7E9"
                                // borderRadius="full"
                                width={{ base: "100%", md: "10%" }}
                                // w="40px"
                                // h="40px"
                                p="8px"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                                // opacity={medicineTextFieldValue ? 1 : 0.5}
                                // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                                onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchCompositionForCurrentEdit(editCurrentMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                                bg="white"
                                // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                              >
                                <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                              </Box>
                              {/* <Box width="10%">
                                <PrimaryButton
                                  buttonText="Fetch"
                                  verticalAlign="bottom"
                                  variant="grayBtn"
                                  btnStyle={{
                                    w: "100%",
                                    color: COLORS.PRIMARY_COLOR,
                                    verticalAlign: "bottom",
                                    ml: "4px",
                                    mb: "0px",
                                    h: "2.8rem",
                                    opacity: isChatbotAllowed() ? 1 : 0.6,
                              cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                                  }}
                                  onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchCompositionForCurrentEdit(editCurrentMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                                  // onClick={() =>
                                  //   fetchCompositionForCurrentEdit(
                                  //     editCurrentMedicine.medicinename
                                  //   )
                                  // }
                                  // isDisabled={false}
                                />
                              </Box> */}
                            </Flex>

                    {/* Row 2: Medicine Type Selection */}
                            <RadioGroup
  //                             defaultValue={editCurrentMedicine.medicinetype}

  //                             onChange={(value) => {
  //   handleEditCurrentMedicineChange("medicinetype", value);

  //   // Set default dosage units based on medicine type
  //   if (value === "Syrup" || value === "Drops" || value === "Suspension" || 
  //       value === "Respules" || value === "Gargle" || value === "Shampoo" || 
  //       value === "Topical Cleanser") {
  //     handleEditCurrentMedicineChange("dosageunit", "ml");
  //   } else if (value === "Tablet" || value === "Capsule" || value === "Suppository" || 
  //              value === "Powder") {
  //     handleEditCurrentMedicineChange("dosageunit", "mg");
  //   } else if (value === "Injection" || value === "Nebulization" || value === "IVFluids") {
  //     handleEditCurrentMedicineChange("dosageunit", "ml");
  //   } else if (value === "Ointment" || value === "Cream" || value === "Gel" || 
  //              value === "Foam" || value === "Lotion" || value === "Tube" || 
  //              value === "Soap") {
  //     handleEditCurrentMedicineChange("dosageunit", "grms");
  //   } else if (value === "Inhaler" || value === "Spray" || value === "Aerosol") {
  //     handleEditCurrentMedicineChange("dosageunit", "puffs");
  //   } else if (value === "EA" || value === "Device" || value === "Box") {
  //     handleEditCurrentMedicineChange("dosageunit", "each");
  //   } else if (value === "Sachet") {
  //     handleEditCurrentMedicineChange("dosageunit", "mg"); // or 'g' as default
  //   } else if (value === "Custom") {
  //     handleEditCurrentMedicineChange("dosageunit", ""); // No default for custom
  //   }
  // }}

  value={additionalMedicineTypes.includes(editCurrentMedicine.medicinetype) ? "" : editCurrentMedicine.medicinetype}
  onChange={(value) => handleCurrentEditTypeChange(value)}
                              // existing
                              // onChange={(value) => {
                              //   handleEditCurrentMedicineChange(
                              //     "medicinetype",
                              //     value
                              //   );

                              //   if (value === "Syrup" || value === "Drops") {
                              //     handleEditCurrentMedicineChange(
                              //       "dosageunit",
                              //       "ml"
                              //     );
                              //   } else if (value === "Tablet") {
                              //     handleEditCurrentMedicineChange(
                              //       "dosageunit",
                              //       "mg"
                              //     );
                              //   } else if (value === "Capsule") {
                              //     handleEditCurrentMedicineChange(
                              //       "dosageunit",
                              //       "mg"
                              //     );
                              //   }  else if (value === "Injection") {
                              //     handleEditCurrentMedicineChange("dosageunit", "ml");
                              //   } else if (value === "Ointment") {
                              //     handleEditCurrentMedicineChange("dosageunit", "grms");
                              //   } else if (value === "Nebulization") {
                              //     handleEditCurrentMedicineChange("dosageunit", "ml");
                              //   } else if (value === "IVFluids") {
                              //     handleEditCurrentMedicineChange("dosageunit", "ml");
                              //   } else if (value === "Inhaler") {
                              //     handleEditCurrentMedicineChange("dosageunit", "puffs");
                              //   }
                              // }}
                            >
                             <Stack direction="row" alignItems='center' gap="20px" wrap="wrap">
                  <Radio colorScheme="green" value="Tablet">Tablet</Radio>
                                    <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                                    <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                                    <Radio colorScheme="green" value="Drops">Drops</Radio>
                                    <Radio colorScheme="green" value="Injection">Injection</Radio>
                                    <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                                    <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                                    <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                                    <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                                    <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                                    <Radio colorScheme="green" value="Cream">Cream</Radio>
                                    <Radio colorScheme="green" value="Gel">Gel</Radio> 

                              {/* existing */}
                              {/* <Radio value="Tablet">Tablet</Radio>
                              <Radio value="Syrup">Syrup</Radio>
                              <Radio value="Drops">Drops</Radio>
                              <Radio value="Capsule">Capsule</Radio>
                              <Radio value="Injection">Injection</Radio>
                              <Radio value="Ointment">
                                Ointments / Creams / Gels
                              </Radio>
                              <Radio value="Nebulization">Nebulization</Radio>
                              <Radio value="IVFluids">IV Fluids</Radio>
                              <Radio value="Inhaler">Inhaler</Radio> */}
                            <Text>-Or-</Text>
                            <Box mx='1rem'>

                            <DropdownInput
    variant="bothSide"
    dropDownPlace="More Types"
    options={additionalMedicineTypes}
    onClick={(value) => handleCurrentEditTypeChange(value)}
    value={dropdownMedType}
    defaultOption={dropdownMedType || "Select more types"}
  />

                            </Box>
                            </Stack>
                            </RadioGroup>
                            <Divider my={2}/>
                            
                            <Box>
                    {/* Row 3: DrugClass, Therapeutic, Strength, Quantity */}
                              <Box display="flex" flexDir="row">
                                <PrimaryInput
                          variant={"bothSide"}
                          inputPlace="Drug Class"
                          defaultValue={editCurrentMedicine.drugclass || ""}
                          inputValue={editCurrentMedicine.drugclass || ""}
                          onChange={(e) =>
                            handleEditCurrentMedicineChange(
                              "drugclass",
                              e.target.value
                            )
                          }
                        />
                        <PrimaryInput
                          variant={"bothSide"}
                          inputPlace="Therapeutic category"
                          defaultValue={editCurrentMedicine.therapeutic || ""}
                          inputValue={editCurrentMedicine.therapeutic || ""}
                          onChange={(e) =>
                            handleEditCurrentMedicineChange(
                              "therapeutic",
                              e.target.value
                            )
                          }
                        />

{editCurrentMedicine.medicinetype === "Tablet" || 
 editCurrentMedicine.medicinetype === "Capsule" || 
 editCurrentMedicine.medicinetype === "Suppository" || 
 editCurrentMedicine.medicinetype === "Powder" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "mcg", value: "mcg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={editCurrentMedicine.dosage}
    defaultOptionProp={editCurrentMedicine.dosageunit}
    onSelect={(value) => handleEditCurrentMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditCurrentMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editCurrentMedicine.dosage}
    maxLength="6"
  />
) : editCurrentMedicine.medicinetype === "Inhaler" || 
    editCurrentMedicine.medicinetype === "Spray" || 
    editCurrentMedicine.medicinetype === "Aerosol" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "puffs", value: "puffs" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Dosage"
    defaultValue={editCurrentMedicine.dosage}
    defaultOptionProp={editCurrentMedicine.dosageunit}
    onSelect={(value) => handleEditCurrentMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditCurrentMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editCurrentMedicine.dosage}
    maxLength="6"
  />
) : editCurrentMedicine.medicinetype === "Syrup" ||
    editCurrentMedicine.medicinetype === "Drops" ||
    editCurrentMedicine.medicinetype === "Injection" ||
    editCurrentMedicine.medicinetype === "Nebulization" ||
    editCurrentMedicine.medicinetype === "IVFluids" ||
    editCurrentMedicine.medicinetype === "Suspension" ||
    editCurrentMedicine.medicinetype === "Respules" ||
    editCurrentMedicine.medicinetype === "Gargle" ||
    editCurrentMedicine.medicinetype === "Shampoo" ||
    editCurrentMedicine.medicinetype === "Topical Cleanser" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "ml", value: "ml" }]}
    placeholderProp="Volume"
    defaultValue={editCurrentMedicine.dosage}
    defaultOptionProp={editCurrentMedicine.dosageunit}
    onSelect={(value) => handleEditCurrentMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditCurrentMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editCurrentMedicine.dosage}
    maxLength="6"
  />
) : editCurrentMedicine.medicinetype === "Ointment" ||
    editCurrentMedicine.medicinetype === "Cream" ||
    editCurrentMedicine.medicinetype === "Gel" ||
    editCurrentMedicine.medicinetype === "Foam" ||
    editCurrentMedicine.medicinetype === "Lotion" ||
    editCurrentMedicine.medicinetype === "Tube" ||
    editCurrentMedicine.medicinetype === "Soap" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "grms", value: "grms" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Weight/Volume"
    defaultValue={editCurrentMedicine.dosage}
    defaultOptionProp={editCurrentMedicine.dosageunit}
    onSelect={(value) => handleEditCurrentMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditCurrentMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editCurrentMedicine.dosage}
    maxLength="6"
  />
) : editCurrentMedicine.medicinetype === "EA" || 
    editCurrentMedicine.medicinetype === "Device" || 
    editCurrentMedicine.medicinetype === "Box" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "each", value: "each" }]}
    placeholderProp="Count"
    defaultValue={editCurrentMedicine.dosage}
    defaultOptionProp={editCurrentMedicine.dosageunit}
    onSelect={(value) => handleEditCurrentMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditCurrentMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editCurrentMedicine.dosage}
    maxLength="6"
  />
) : editCurrentMedicine.medicinetype === "Sachet" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Content"
    defaultValue={editCurrentMedicine.dosage}
    defaultOptionProp={editCurrentMedicine.dosageunit}
    onSelect={(value) => handleEditCurrentMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditCurrentMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editCurrentMedicine.dosage}
    maxLength="6"
  />
) : (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
      { label: "puffs", value: "puffs" },
      { label: "each", value: "each" },
    ]}
    // placeholderProp="Dosage"
    placeholderProp={editCurrentMedicine.medicinetype === "Custom" ? "Custom Unit" : "Strength/Volume"}
    defaultValue={editCurrentMedicine.dosage}
    defaultOptionProp={editCurrentMedicine.dosageunit}
    onSelect={(value) => handleEditCurrentMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditCurrentMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editCurrentMedicine.dosage}
    maxLength="6"
  />
)}

                                {/* Consumption Quantity / Product Quantity for current medicines
                                    - For Ointment/Cream/Gel: Product Quantity (1–4) -> productQuantity
                                    - For other solid/oral types: Consumption Quantity (0.5–4) -> frequency
                                    - Hidden for liquid/infusion/parenteral types */}
                                {(editCurrentMedicine.medicinetype !== "Drops" &&
                                  editCurrentMedicine.medicinetype !== "IVFluids" &&
                                  editCurrentMedicine.medicinetype !== "Injection" &&
                                  editCurrentMedicine.medicinetype !== "Nebulization" &&
                                  editCurrentMedicine.medicinetype !== "Inhaler") && (
                                  <DropdownInput
                                    variant="bothSide"
                                    dropDownPlace={
                                      editCurrentMedicine.medicinetype === "Cream" ||
                                      editCurrentMedicine.medicinetype === "Syrup" ||
                                      editCurrentMedicine.medicinetype === "Ointment" ||
                                      editCurrentMedicine.medicinetype === "Gel"
                                        ? "Product Quantity"
                                        : "Consumption Quantity"
                                    }
                                    options={
                                      editCurrentMedicine.medicinetype === "Cream" ||
                                      editCurrentMedicine.medicinetype === "Syrup" ||
                                      editCurrentMedicine.medicinetype === "Ointment" ||
                                      editCurrentMedicine.medicinetype === "Gel"
                                        ? ["1", "2", "3", "4"]
                                        : ["0.5", "1", "2", "3", "4"]
                                    }
                                    onClick={(value) => {
                                      if (
                                        editCurrentMedicine.medicinetype === "Cream" ||
                                        editCurrentMedicine.medicinetype === "Syrup" ||
                                        editCurrentMedicine.medicinetype === "Ointment" ||
                                        editCurrentMedicine.medicinetype === "Gel"
                                      ) {
                                        handleEditCurrentMedicineChange("productQuantity", value);
                                      } else {
                                        handleEditCurrentMedicineChange("frequency", value);
                                      }
                                    }}
                                    value={
                                      editCurrentMedicine.medicinetype === "Cream" ||
                                      editCurrentMedicine.medicinetype === "Syrup" ||
                                      editCurrentMedicine.medicinetype === "Ointment" ||
                                      editCurrentMedicine.medicinetype === "Gel"
                                        ? editCurrentMedicine.productQuantity || "1"
                                        : editCurrentMedicine.frequency
                                    }
                                  />
                                )}
                              </Box>

                    {/* Row 4: Duration, IntervalValue, StartDate, EndDate */}
                    {(editCurrentMedicine.medicinetype !== "Ointment" &&
                      editCurrentMedicine.medicinetype !== "Cream" &&
                      editCurrentMedicine.medicinetype !== "Syrup" &&
                      editCurrentMedicine.medicinetype !== "Gel") && (
                              <Box w='100%' display="flex" flexDir="row">
                                <Box width="25%">
                                <DropdownInput
                                  variant="bothSide"
                                  dropDownPlace={
                                    editCurrentMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Frequency"
                                      : editCurrentMedicine.medicinetype === "Ointment"
                                      ? "Application Duration"
                                      : "Duration"
                                  }
                                  options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                                  // onClick={handleIntervalChange} 
                                  // defaultOption={intervalOption}
                                  onClick={handleIntervalCurrentChange}
                                  value={editCurrentMedicine.durationunit}
                                />
                              </Box>
                              <Box width="25%">
                                <PrimaryInput
                                  variant={"bothSide"}
                                  inputType="number"
                                  // defaultValue={intervalValue}
                                  // onChange={handleIntervalValueChange}
                                  inputValue={editCurrentMedicine.durationvalue} // Controlled input
                                  onChange={handleIntervalCurrentValueChange}
                                  inputPlace={
                                    editCurrentMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Duration"
                                      : "Interval Value"
                                  }
                                />
                              </Box>
                              <Box width={"50%"}  display="flex" flexDir="row">
                                <DatePicker
                                  dateWidth="50%"
                                  defaultDate={editCurrentMedicine.medicationstartdate}
                                  minDate={newMedicine.medicationstartdate}
                                  onDateChange={(selectedDateValue) =>
                                    handleEditCurrentMedicineChange(
                                      "medicationstartdate",
                                      selectedDateValue
                                    )
                                  }
                                  placeholderProp={"Start Date"}
                                  calendarStlye={{
                                    left: "-18px",
                                    right: "unset",
                                  }}
                                />
                                <DatePicker
                                  dateWidth="50%"
                                  key={editCurrentMedicine.medicationenddate}
                                  defaultDate={editCurrentMedicine.medicationenddate}
                                  disableDatePicker={true}
                                  minDate={newMedicine.medicationstartdate}
                                  onDateChange={(selectedDateValue) =>
                                    handleEditCurrentMedicineChange(
                                      "medicationenddate",
                                      selectedDateValue
                                    )
                                  }
                                  placeholderProp={"End Date"}
                                  calendarStlye={{
                                    transform: "scale(0.9)",
                                    right: "-22px",
                                    top: "30px",
                                    pointerEvents: "none", // Disable interaction
                                    opacity: 0.5, // Visually indicate disabled state
                                  }}
                                />
                              </Box>
                              </Box>
                      )}

                    {/* Row 5: Route of Administration, Timing, Quantity, Area of Application, Diluent, Rate of Infusion, Additives */}
                              <Box display="flex" flexDir="row">
                              {editCurrentMedicine.medicinetype == "Injection" && (
                                <>
                                  <Box width={"50%"}>
                                    <DropdownInput
                                      variant="downSide"
                                      dropDownPlace="Route of Administration"
                                      options={[
                                        "Intravenous (IV)",
                                        "Intramuscular (IM)",
                                        "Subcutaneous (SC)",
                                      ]}
                                      onClick={(value) =>
                                        handleEditCurrentMedicineChange(
                                          "routeofadministration",
                                          value
                                        )
                                      }
                                      defaultOption={
                                        editCurrentMedicine.routeofadministration
                                      }
                                    />
                                  </Box>
                                  <Box width={"50%"}>
                                    <PrimaryInput
                                      variant={"bothSide"}
                                      onChange={(e) =>
                                        handleEditCurrentMedicineChange(
                                          "timingofinjection",
                                          e.target.value
                                        )
                                      }
                                      inputPlace="Timing"
                                      defaultValue={
                                        editCurrentMedicine.timingofinjection
                                      }
                                    />
                                  </Box>
                                </>
                              )}
                              {(editCurrentMedicine.medicinetype === "Ointment" || editCurrentMedicine.medicinetype === "Cream" || editCurrentMedicine.medicinetype === "Gel") && (
                                <>
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Quantity"
                                    options={[
                                      "Pea-sized",
                                      "Thin layer",
                                      "Fingertip unit (FTU)",
                                      "Half a fingertip",
                                    ]}
                                    onClick={(value) =>
                                      handleEditCurrentMedicineChange(
                                        "quantitytobeapplied",
                                        value
                                      )
                                    }
                                    defaultOption={editCurrentMedicine.quantitytobeapplied}
                                    value={editCurrentMedicine.quantitytobeapplied || ""}
                                  />
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Area of Application"
                                    options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                                    onClick={(value) =>
                                      handleEditCurrentMedicineChange(
                                        "areaofapplication",
                                        value
                                      )
                                    }
                                    defaultOption={editCurrentMedicine.areaofapplication}
                                    value={editCurrentMedicine.areaofapplication || ""}
                                  />
                                </>
                              )}

                              {editCurrentMedicine.medicinetype == "Nebulization" && (
                                <>
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Diluent"
                                    options={[
                                      "Normal saline",
                                      "Distilled water",
                                      "3% saline",
                                    ]}
                                    onClick={(value) =>
                                      handleEditCurrentMedicineChange("diluent", value)
                                    }
                                    defaultOption={editCurrentMedicine.diluent}
                                  />
                                </>
                              )}

                              {editCurrentMedicine.medicinetype == "IVFluids" && (
                                <>
                                  <MiniDropdownInput
                                    variant="bothside"
                                    options={[
                                      { label: "ml/hr", value: "ml/hr" },
                                      { label: "ml/min", value: "ml/min" },
                                      // { label: "mg/hr", value: "mg/hr" },
                                      // { label: "grms/hr", value: "grms/hr" },
                                    ]}
                                    handleInputChange={(e) =>
                                      handleEditCurrentMedicineChange(
                                        "rateofinfusionvalue",
                                        validationOfNumberWithOnly1Decimal(
                                          e.target.value
                                        )
                                      )
                                    }
                                    placeholderProp={"Rate of Infusion"}
                                    onSelect={(selectedOption) =>
                                      handleEditCurrentMedicineChange(
                                        "rateofinfusionunit",
                                        selectedOption.label
                                      )
                                    }
                                    maxLength="6"
                                    defaultOptionProp={
                                      editCurrentMedicine.rateofinfusionunit
                                    }
                                    defaultValue={
                                      editCurrentMedicine.rateofinfusionvalue
                                    }
                                  />
                                  <PrimaryInput
                                    variant={"bothSide"}
                                    onChange={(e) =>
                                      handleEditCurrentMedicineChange(
                                        "additives",
                                        e.target.value
                                      )
                                    }
                                    inputPlace="Additives"
                                    defaultValue={editCurrentMedicine.additives}
                                  />
                                </>
                              )}
                              </Box>

                    {/* Row 6: MealTiming or Frequency / Before/AfterFood / ApplicationTiming, WhereToApply */} 
                              <CheckboxGroup colorScheme="green">
                                <Stack spacing={2} pt="20px" direction="row" flexWrap="wrap" alignItems="center">
                                  {/* COMMENTED OUT - Replaced with dropdown */}
                                  {/* <Checkbox
                                    isChecked={
                                      editCurrentMedicine.morning === 1
                                    }
                                    onChange={() => {
                                      // Uncheck frequency inputs when checking a time checkbox
                                      if (editCurrentMedicine.morning !== 1) {
                                        handleEditCurrentMedicineChange("frequencytime", "");
                                        handleEditCurrentMedicineChange("frequencyvalue", "");
                                      }
                                      handleEditCurrentMedicineChange(
                                        "morning",
                                        editCurrentMedicine.morning === 1 ? 0 : 1
                                      );
                                    }}
                                  >
                                    Morning
                                  </Checkbox>
                                  <Checkbox
                                    isChecked={
                                      editCurrentMedicine.afternoon === 1
                                    }
                                    onChange={() => {
                                      // Uncheck frequency inputs when checking a time checkbox
                                      if (editCurrentMedicine.morning !== 1) {
                                        handleEditCurrentMedicineChange("frequencytime", "");
                                        handleEditCurrentMedicineChange("frequencyvalue", "");
                                      }
                                      handleEditCurrentMedicineChange(
                                        "afternoon",
                                        editCurrentMedicine.afternoon === 1 ? 0 : 1
                                      );
                                    }}
                                  >
                                    Afternoon
                                  </Checkbox>
                                  <Checkbox
                                    isChecked={editCurrentMedicine.night === 1}
                                    onChange={() => {
                                      // Uncheck frequency inputs when checking a time checkbox
                                      if (editCurrentMedicine.morning !== 1) {
                                        handleEditCurrentMedicineChange("frequencytime", "");
                                        handleEditCurrentMedicineChange("frequencyvalue", "");
                                      }
                                      handleEditCurrentMedicineChange(
                                        "night",
                                        editCurrentMedicine.night === 1 ? 0 : 1
                                      );
                                    }}
                                  >
                                    Night
                                  </Checkbox> */}

                                  {/* Dropdown for Meal Timing */}
                                  <Box width='180px'>
                                    <DropdownInput
                                      variant="bothSide"
                                      dropDownPlace="Meal Timing"
                                      arrowCSS={{pr:0}}
                                      options={[
                                        "1-0-0",
                                        "0-1-0",
                                        "0-0-1",
                                        "1-1-0",
                                        "1-0-1",
                                        "0-1-1",
                                        "1-1-1",
                                        "0-0-0"
                                        // "1-0-0 (Morning)",
                                        // "0-1-0 (Afternoon)",
                                        // "0-0-1 (Night)",
                                        // "1-1-0 (Morning & Afternoon)",
                                        // "1-0-1 (Morning & Night)",
                                        // "0-1-1 (Afternoon & Night)",
                                        // "1-1-1 (All three)",
                                        // "0-0-0 (None)"
                                      ]}
                                      onClick={(value) => {
                                        if (value) {
                                          const { morning, afternoon, night } = parseMealTiming(value);
                                          handleEditCurrentMedicineChange("morning", morning);
                                          handleEditCurrentMedicineChange("afternoon", afternoon);
                                          handleEditCurrentMedicineChange("night", night);
                                          // Clear frequency inputs when selecting meal timing
                                          handleEditCurrentMedicineChange("frequencytime", "");
                                          handleEditCurrentMedicineChange("frequencyvalue", "");
                                        }
                                      }}
                                      value={editCurrentMedicine && getMealTimingLabel(editCurrentMedicine.morning, editCurrentMedicine.afternoon, editCurrentMedicine.night)}
                                    />
                                  </Box>

                                  {/* <Spacer /> */}
                                  <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>

                                    {/* Frequency inputs */}
                                    <Box display='flex'>
                                    <Box width='120px'>
                                      <DropdownInput
                                        variant="bothSide"
                                        dropDownPlace="Frequency"
                                        arrowCSS={{pr:0}}
                                        options={["Hours", "Daily", "Weekly"]}
                                        onClick={(value) => {
                                          // Uncheck time checkboxes when selecting frequency
                                          if (value) {
                                            handleEditCurrentMedicineChange("morning", 0);
                                            handleEditCurrentMedicineChange("afternoon", 0);
                                            handleEditCurrentMedicineChange("night", 0);
                                          }
                                          handleEditCurrentMedicineChange("frequencytime", value || 0);
                                        }}
                                        // defaultOption={"Hours"}
                                        value={editCurrentMedicine.frequencytime}
                                      />
                                    </Box>

                                    <Box width='70px'>
                                      <DropdownInputForVitals
                                        variant="bothSide"
                                        dropDownPlace="Value"
                                        readOnly=""
                                        arrowCSS={{pr:0}}
                                        options={["1", "2", "3", "4", "8"]}
                                        onClick={(value) => {
                                          // Uncheck time checkboxes when selecting value
                                          if (value) {
                                            handleEditCurrentMedicineChange("morning", 0);
                                            handleEditCurrentMedicineChange("afternoon", 0);
                                            handleEditCurrentMedicineChange("night", 0);
                                            handleEditCurrentMedicineChange("frequencyvalue", value);
                                          }
                                        }}
                                        onChange={(e) => {
                                          // Handle manual text input for value
                                          const value = e.target.value;
                                          if (value) {
                                            handleEditCurrentMedicineChange("morning", 0);
                                            handleEditCurrentMedicineChange("afternoon", 0);
                                            handleEditCurrentMedicineChange("night", 0);
                                          }
                                          handleEditCurrentMedicineChange("frequencyvalue", value);
                                        }}
                                        value={editCurrentMedicine.frequencyvalue}
                                        inputValueProp={editCurrentMedicine.frequencyvalue || ""}
                                        maxLength={2}
                                      />
                                    </Box>
                                    </Box>
                                  <Spacer />
                                   {/* Food timing radio buttons */}
                                    <Spacer/>
                                {(editCurrentMedicine?.medicinetype === "Cream" || editCurrentMedicine?.medicinetype === "Ointment" || editCurrentMedicine?.medicinetype === "Gel") ? (
                                  <Box>
                                    {/* <Text fontSize="sm" mb={1}>Application Timing</Text> */}
                                    <DropdownInput
                                      variant="downSide"
                                      dropDownPlace="Application Timing"
                                      options={[
                                        "After Bath",
                                        "Before Bath",
                                        "After Sun",
                                        "Before Sun",
                                        "Time-based",
                                      ]}
                                      onClick={(value) => {
                                        handleEditCurrentMedicineChange("timing", value);
                                        handleEditCurrentMedicineChange("beforefood", 0);
                                        handleEditCurrentMedicineChange("afterfood", 0);
                                      }}
                                      value={editCurrentMedicine.timing || ""}
                                    />
                                  </Box>
                                ) : (
                                  <RadioGroup
                                    value={editCurrentMedicine && editCurrentMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
                                    display='flex'
                                    justifyItems='start'
                                    flexWrap='wrap'
                                    gap='0.5rem'
                                    onChange={(value) => {
                                      if (value === "beforefood") {
                                        handleEditCurrentMedicineChange("beforefood", 1);
                                        handleEditCurrentMedicineChange("afterfood", 0);
                                        handleEditCurrentMedicineChange("timing", "Before Food");
                                      } else if (value === "afterfood") {
                                        handleEditCurrentMedicineChange("beforefood", 0);
                                        handleEditCurrentMedicineChange("afterfood", 1);
                                        handleEditCurrentMedicineChange("timing", "After Food");
                                      }
                                    }}
                                  >
                                    <Radio value="beforefood" colorScheme="green">Before Food</Radio>
                                    <Radio value="afterfood" colorScheme="green">After Food</Radio>
                                  </RadioGroup>
                                )}
                                </Stack>
                              </CheckboxGroup>

                               <Divider my="10px" />

                    {/* Row 7: Instructions Text area */}
                  <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
  <Box
    as="form"
    width='100%'
    bg="white"
    pt={"2px"}
  >
    <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
      <Textarea
        borderRadius='0'
        // {...register("textField")}
        // defaultValue={editCurrentMedicine.custommessage}
        // inputValue={editCurrentMedicine.custommessage}
        value={editCurrentMedicine.custommessage}
        onChange={(e) => {
          handleEditCurrentMedicineChange("custommessage", e.target.value);
          // Also update the form field
          setValue("textField", e.target.value, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          });
        }}
        height="100%"
        padding="2"
        resize="none"
        style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
      />
      
      {!editCurrentMedicine.custommessage && (
        <Text
          position="absolute"
          bottom="2"
          left="50%"
          transform="translateX(-50%)"
          fontSize="sm"
          color="gray.500"
          w={{ base: "100%", md: "unset" }}
          textAlign={{ base: "center", md: "unset" }}
        >
          {placeholder}
        </Text>
      )}
    </Box>
    
  </Box>

  {/* <GPUChatAudioManager
      transcriber={activeTranscriber}
      setPlaceholder={setPlaceholder}
      setTyping={setTyping}
    /> */}
    {/* <Box w='15%'>
    <DropdownWithMultiLingual 
              menuList={{pos:'relative', right:'75px'}}
              placeholder="English"
              onClick={handleChangeLanguage}
              options={languageOptions.map(value => ({ value }))}
              title="Input Language"
            />
            </Box>
    <GPUChatAudioManagerSpeechMode
      transcriber={activeTranscriber}
      mode={mode}
      setPlaceholder={setPlaceholder}
      setTyping={setTyping}
        onRecordingStateChange={handleRecordingStateChange} 
    />
    {isRecording && (
              <AudioDisplayForClutter
                mx="auto"
                borderRadius="lg"
                stream={stream}
              />
            )}
            <Box w='15%'>
            <DropdownWithMultiLingual 
              menuList={{pos:'relative', right:'75px'}}
              placeholder="English"
              onClick={handleChangeOutputLanguage}
              options={languageOptions.map(value => ({ value }))}
              title="Output Language"
            />
            </Box>
    <Box
      as="button"
      type="button"
      border="1px solid #E6E7E9"
      borderRadius="full"
      w="36px"
      h="auto"
      p="10px"
      mr='10px'
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor={textFieldValue ? "pointer" : "not-allowed"}
      opacity={textFieldValue ? 1 : 0.5}
      pointerEvents={textFieldValue ? "auto" : "none"}
      onClick={() => textFieldValue && correctOrders("currentedit")}
    >
      <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
    </Box> */}
    
</Box>

                    {/* Row 8: Input/Output Language, AudioRecorder */}
{/* Audio & Language Controls Row - Highlighted Section */}
                    <Box
                      bg="#f8f9fa"
                      border="1px solid #e9ecef"
                      borderRadius="8px"
                      p="0.5rem"
                      mt="1rem"
                      // mb="1rem"
                    >
                      <Flex
                        alignItems="center"
                        justifyContent="space-around"
                        // justifyContent="space-between"
                        gap="1rem"
                        flexWrap={{ base: "wrap", md: "nowrap" }}
                      >
                        {/* Input Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleChangeLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Input Language"
                          />
                        </Box>
                        
                        {/* Audio Controls and Wave Display */}
                        <Box 
                    flex="1"
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    gap="0.75rem"
                    minH="50px"
                    px="1rem"
                  >
                    <GPUChatAudioManagerSpeechMode
                      transcriber={activeTranscriber}
                      mode={mode}
                      setPlaceholder={setPlaceholder}
                      setTyping={setTyping}
                      // onTranscribedText={(text) => {
                      //   handleNewMedicineChange("custommessage", text);
                      //   setValue("textField", text); 
                      // }}
                      onRecordingStateChange={handleRecordingStateChange} 
                    />
              
                    {isRecording && (
                      <Box flex="1" minW="180px" maxW="250px">
                        <AudioDisplayForClutter
                          borderRadius="lg"
                          stream={stream}
                          width="100%"
                        />
                      </Box>
                    )}
                  </Box>
              
                        {/* Output Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleChangeOutputLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Output Language"
                          />
                        </Box>
              
                        {/* AI Correction Button */}
                        <Box
                          as="button"
                          type="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="40px"
                          h="40px"
                          p="8px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          cursor={textFieldValue ? "pointer" : "not-allowed"}
                          opacity={textFieldValue ? 1 : 0.5}
                          pointerEvents={textFieldValue ? "auto" : "none"}
                          onClick={() => textFieldValue && correctOrders("currentedit")}
                          flexShrink="0"
                          bg="white"
                          _hover={textFieldValue ? { bg: "#f0f0f0" } : {}}
                        >
                          <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                        </Box>
                      </Flex>
                    </Box>

                  <Divider my="10px" />
                            </Box>
                            {/* <Divider /> */}
                            <Box
                              display="flex"
                              justifyContent="flex-end"
                              gap="10px"
                            >
                              {/* <Button onClick={() => setEditMedicine(null)}>
                            Cancel
                          </Button> */}
                              <PrimaryButton
                                buttonText="Cancel"
                                variant="grayBtn"
                                btnStyle={{
                                  // w: "15%",
                                  w: "50%",
                                  color: COLORS.PRIMARY_COLOR,
                                  h: "2.5rem",
                                }}
                                onClick={() => {
                                  editCurrentPrescriptionMedication.current.closeModal();
                                  setIsCurrentEditModalOpen(false)
                                  setEditCurrentMedicine(null)
                                }}
                                isDisabled={false}
                              />
                              {/* <Button
                            colorScheme="blue"
                            onClick={handleSaveEditMedicine}
                          >
                            Save
                          </Button> */}
                              <PrimaryButton
                                buttonText="Save"
                                onClick={handleSaveEditCurrentMedicine}
                                isDisabled={false}
                                btnStyle={{
                                  // w: "25%",
                                  w: "50%",
                                  //   color: COLORS.PRIMARY_COLOR,
                                  h: "2.5rem",
                                }}
                              />
                            </Box>
                          </Stack>
                        </Box>
                      )}
                  </Box>
                ))}   
                  </>
                }
              />       

      </Box>
    );
  }
);

export default PrescriptionComponent;
